// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Exposit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Pacifico/Pacifico-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Parisienne/Parisienne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Shrikhand/Shrikhand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Rock_Salt/RockSalt-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Arizonia/Arizonia-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/deftone stylus.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Bebas_Neue_Pro_Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/JosefinSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/mistral.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/BreeSerif-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Courgette-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Raleway/static/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Raleway/static/Raleway-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Raleway/static/Raleway-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/assets/fonts/Rethink_Sans/RethinkSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/assets/fonts/Rethink_Sans/RethinkSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/fonts/Rethink_Sans/RethinkSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/src/assets/fonts/Rethink_Sans/RethinkSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/src/assets/fonts/Rethink_Sans/RethinkSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/src/assets/fonts/aAtmospheric.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/banner-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/lastsection.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/coffe-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/Textura.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/lp-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./../images/banner-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./../images/light-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../../public/images/profit-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../assets/images/Newlogin-back.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../../../public/images/sec-three.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../../../public/images/sec-eight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("/src/assets/images/home-sec-1-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("/src/assets/images/home-sec-four-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("/src/assets/images/home-sec-six-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("/src/assets/images/home-sec-eight-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #e11f1c;
  --secondary: rgb(74, 52, 11);
  --white: #fff;
  --black: #000000;
  --gray: gray;
  --dark-gray: #a6a6a6;
  --darkest-gray: #606060;
  --dark: #404040;
  --darker: #40404088;
  --light: #f3f3f3;
  --lighter: #dadada;
  --lightest: #ebebeb;
  --grey-bg: #f3f3f3;
  --highlight: #c4743f;
  --light-gray: #d3d3d3;
  --lighter-gray: #d3d3d399;
}

/* @import url('https://fonts.googleapis.com/css2?family=Chewy&display=swap'); */
@font-face {
  font-family: "exposit";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Pacifico";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Parisienne";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Shrikhand";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

@font-face {
  font-family: "Rock_Salt";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}

@font-face {
  font-family: "Arizonia";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}

@font-face {
  font-family: "deftone";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}

@font-face {
  font-family: "Bebas Neue";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}

@font-face {
  font-family: "josefin Sans";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}

@font-face {
  font-family: "Mistral";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}

@font-face {
  font-family: "Breef serif";
  src: URL(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}

@font-face {
  font-family: "Courgette";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-weight: 400;
}

@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: 600;
}

@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-weight: 800;
}

@font-face {
  font-family: "Rethink Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  font-weight: 400;
}

@font-face {
  font-family: "Rethink Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  font-weight: 500;
}

@font-face {
  font-family: "Rethink Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  font-weight: 600;
}

@font-face {
  font-family: "Rethink Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  font-weight: 700;
}

@font-face {
  font-family: "Rethink Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  font-weight: 800;
}

@font-face {
  font-family: "Atmospheric";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype");
}

.courgette {
  font-family: "Courgette";
}

body {
  font-family: "Breef serif";
  overflow: overlay;
}

input::placeholder,
textarea::placeholder {
  opacity: 0.7 !important;
}

input:focus-visible {
  outline: none;
}

input:focus::placeholder {
  color: transparent;
}

/* p {
  letter-spacing: 2px;
  margin-bottom: 0;
} */

a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  color: initial;
}

.btn {
  font-size: 17px;
  font-weight: 500;
}

::selection {
  background-color: var(--dark);
  color: var(--white);
}

ul {
  list-style-type: none;
}

.btn:focus {
  box-shadow: none;
}

.primary-btn {
  background: var(--primary);
  color: var(--white);
}

.login-btn-color {
  color: var(--dark) !important;
}

.container-withdrawl {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  gap: 40px;
}

.balance-withdrawl {
  font-size: 30px !important;
}

.content-withdrawl {
  flex: 1 1;
}

.primary-btn:hover {
  background: transparent;
  border: 1px solid var(--primary) !important;
  color: var(--primary);
}

.secondary-btn {
  background: var(--white);
  color: var(--primary);
}

.secondary-btn:hover {
  background: var(--secondary);
  color: var(--primary);
}

.banner-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-color: #000000;
  background-attachment: fixed;
  background-position: center;
  position: relative;
  z-index: 0;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%;
}

.bottom-solid {
  border-bottom: 2px solid var(--light-gray);
}

.banner-inner {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.absolute-text {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
}

.banner-section img {
  width: 100%;
}

.banner-text {
  /* position: absolute;
    bottom: 0; */
  color: var(--white);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* right: 0;
    left: 0; */
  font-size: 99px;
  font-family: "josefin Sans";
}

.common-heading {
  letter-spacing: normal;
  line-height: 1.2em;
  font-size: 32px;
  font-family: "josefin Sans";
}

.highlight {
  color: var(--primary) !important;
  font-weight: 600;
}

.underlined-text {
  text-decoration: underline;
}

.custom-card {
  width: 350px;
  margin: 1rem auto;
}

.custom-card img {
  width: 100%;
}

.custom-card h3 {
  color: var(--secondary);
  text-align: center;
  margin-top: 1rem;
}

.section {
  margin-top: 5rem;
}

.section2 {
  position: relative;
  padding-bottom: 5rem;
}

.normal-padding {
  padding-top: 5rem;
}

.section-background {
  position: absolute;
  width: 100%;
  z-index: -1;
  top: 0;
  bottom: 0;
  height: 100%;
}

.custom-card-two {
  width: 357px;
  margin: 1rem auto;
}

.custom-card-two img {
  width: 100%;
}

.custom-card-two h3 {
  font-size: 20px;
  color: var(--white);
  text-align: center;
}

.secondary-text {
  color: var(--secondary);
}

.card-title {
  color: var(--primary);
  font-family: "Breef Serif";
  font-weight: 600;
}

.card-lg h4 {
  line-height: 1.2em;
  font-size: 32px;
  letter-spacing: 2px;
}

.card-lg p {
  line-height: 1.7em;
  font-size: 17px;
  letter-spacing: 2px;
  margin: 2.5rem 0;
  color: var(--secondary);
  text-align: justify;
}

.card-lg:nth-child(1) {
  width: 450px;
  margin: 3rem auto;
}

.card-image-two {
  position: absolute;
  width: 105%;
  left: -12px;
  height: 550px;
  top: 0;
  bottom: 0;
}

.custom-input {
  border-radius: 5px;
  background: var(--black);
  border: none;
  height: 40px;
  color: #fff;
}

.custom-control::placeholder {
  color: var(--dark);
}

.custom-control,
.custom-control input#phone {
  all: unset;
  background: var(--lightest);
  padding: 0.7em 1em;
  color: var(--dark);
  border-radius: 3px;
  display: block;
  width: -webkit-fill-available;
  width: -moz-available;
}

.phone-input {
  border: none !important;
  background: var(--lightest) !important;
  width: -webkit-fill-available !important;
}

.phone-input-button {
  border: none !important;
  background-color: var(--light) !important;
}

::placeholder {
  color: var(--white);
  font-weight: 500;
}

.Background-fixed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-color: #000000;
  background-attachment: fixed;
  background-position: center;
}

.ImageBackgroundWrap {
  position: relative;
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
}

.background-text {
  padding: 13%;
  color: white;
  text-align: center;
}

.card-lg-smos-img {
  /* position: sticky;
    width: 105%;
    left: -12px;
    top: 0;
    bottom: 40px; */
  width: 100%;
}

.col-without-padding .col-lg-6 {
  padding: 0;
}

.first-section-with-title {
  padding-top: 4rem;
  text-align: center;
}

.heading-section-border {
  padding: 2rem 0;
  border: 3px solid var(--dark-gray);
  border-left: none;
  border-right: none;
}

.heading-section-border h2 {
  margin: 0;
  color: var(--primary);
}

.items {
  display: flex;
  margin-top: 1rem;
}

.items img {
  width: 250px;
}

.items .title-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.items .title-section .first {
  width: 90%;
  display: flex;
  align-items: center;
  border-bottom: 5px dotted var(--primary);
  color: var(--primary);
}

.items .title-section .first svg {
  fill: var(--primary);
  margin-right: 0.5rem;
}

.items .title-section sub {
  font-size: 20px;
}

.items p {
  font-size: 20px;
  margin-top: 1rem;
}

.items .title-section h3 {
  margin: 0;
}

.image-section {
  overflow: hidden;
  min-height: 150px;
}

.shop-item a .image-section:hover > img {
  transform: scale(1.1);
}

.shop-item a {
  text-decoration: none;
  overflow: hidden !important;
  display: inline-block;
  color: var(--black);
}

.shop-item img {
  transition: all 1s;
}

.shop-item .shop-title {
  font-family: 300 !important;
  font-size: 25px;
}

.primary-text {
  color: var(--primary);
}

.branch-card {
  padding: 1rem 2rem;
  border-radius: 8px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 3px 5px -3px #a2a2a2;
}

.branch-card img {
  width: 80%;
  margin: auto;
}

.offices-section {
  height: 100vh;
  display: flex;
  align-items: center;
}

.branch-card .section-title {
  font-size: 24px;
}

.branch-card .address {
  text-align: justify;
  text-align-last: center;
}

.branch-card .section-title::first-letter {
  color: var(--primary);
}

/* .branch-card p {
  font-size: 22px;
  color: var(--secondary);
  margin: 1rem 0;
} */

/* =========================.investment-section========================= */

.invest-options-modal .modal-content {
  border-radius: 0;
  background: var(--light);
  color: var(--dark);
}

.invest-options-modal .modal-content button {
  color: var(--light);
  font-size: 14px;
}

.invest-options-modal .modal-content button:hover {
  color: var(--dark);
}

#investements {
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#investements::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: cover;
  background-position: center;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0.9;
}

.investment-section {
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.investment-section .banner-text {
  font-family: inherit;
}

.investment-section h4 {
  font-size: 24px;
  color: var(--white);
}

.investment-section h2 {
  font-size: 70px;

  color: var(--primary);
  font-family: "Breef Serif";
}

.investment-section p {
  text-align: right;
  font-size: 26px;
  color: var(--secondary);
}

.invest-second {
  padding: 2rem 0;
  position: relative;
  background: #fafafa96;
}

.invest-bg {
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  height: 800px;
  z-index: -1;
  opacity: 0.3;
}

.primary {
  color: var(--primary) !important;
}

.light {
  color: var(--light);
}

.investment-second {
  margin-top: 50px;
}

.investment-second h3 {
  font-size: 34px;
  color: var(--secondary);
}

.investment-second h2 {
  font-size: 70px;
  color: var(--primary);
}

.investment-second p {
  font-size: 18px;
  color: var(--secondary);
}

.invest-second .invest-search-input {
  flex-basis: 100%;
}

.store-select-wrapper {
  width: 200px !important;
}

.stores-list {
  box-shadow: none !important;
}

.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root {
  background-color: #fff !important;
  padding-right: 0.5rem !important;
}

.store-select .MuiPaper-root::-webkit-scrollbar {
  width: 6px !important;
}

.invest-second .invest-search-input input {
  padding: 14px;
  margin-right: 24px;
  width: 590px;
  color: var(--secondary);
  border-radius: 4px;
  border-color: var(--primary);
}

.invest-second .invest-search-input input:focus {
  border-color: var(--secondary);
  outline: none;
}

::placeholder {
  color: var(--primary);
}

.simple-input::placeholder {
  color: var(--dark) !important;
}

.flex-input {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 1rem;
  border-radius: 5px;
  gap: 5px;
}

.flex-input input {
  flex-grow: 1;
}

.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border-color: var(--primary) !important;
  border-width: 2px;
}

.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
  color: var(--primary) !important;
}

.MuiMenu-list {
  background-color: var(--light);
  color: var(--dark);
}

.MuiMenu-paper::-webkit-scrollbar {
  width: 4px;
  background: var(--light);
}

.MuiMenu-paper::-webkit-scrollbar-thumb {
  background-color: var(--dark-gray);
}

.MuiPaper-root {
  height: auto;
}

.invest-second .btn {
  padding: 14px 20px;
  margin-left: 5px;
}

.invest-second .bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  border-radius: 10px;
}

.symbol-text {
  font-size: 14px;
  color: var(--secondary);
}

#investment-simulation .bg-image .content h3 {
  margin: 0px;
  font-size: 24px;
  padding: 10px 0px;
}

#investment-simulation .image img {
  width: 100%;
}

#investment-simulation .content p {
  font-size: 22px;
}

.table-images-txt {
  padding: 10% 0px !important;
}

.section2 .img img {
  width: 60%;
}

.section-documentation .section2 {
  padding: 0;
}

.section-documentation {
  color: var(--secondary);
}

.section-documentation h3,
.section-documentation h4 {
  color: var(--primary);
}

#section-bg-atteched .background-text .images img {
  width: 100%;
}

/* ===================invest-now-card============================= */

.invest-now-card {
  margin: 0.5rem;
  border-radius: 10px;
  padding: 0.5rem;
}

.invest-now-card .image-section figure {
  position: relative;
  margin: 0 auto;
}

.invest-now-card .image-section figure img {
  transition: all 1s;
  /*width: 100%;*/
}

.invest-now-card .image-section figure figcaption img {
  width: 25px;
}

.invest-now-card .image-section figure figcaption {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5);
  color: #f1f1f1;
  padding: 10px;
  top: 0;
}
.home-sec-seven .title {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #252525;
  margin: 0px;
}
.invest-now-card .image-section figure figcaption span {
  /* margin-left: 10px; */
  line-height: 1em;
  padding: 0;
}

.invest-now-card
  .image-section:hover
  .invest-now-card
  .image-section
  figure
  img {
  transform: scale(1.1);
}

.invest-now-card .line {
  width: 100%;
  height: 10px;
  background: #ff4141;
  border-radius: 12px;
  margin-bottom: 15px;
}

.invest-now-card h4 {
  font-size: 1.3rem;
  margin: 10px 0px 0px 5px;
  color: var(--dark);
}

.invest-now-card .invest-card-desc {
  color: var(--dark);
  margin-bottom: 5px;
  font-size: 0.9rem;
  line-height: 1.3em;
  padding: 0.3em 1em 0 5px;
  text-align: start;
  letter-spacing: 0;
}

.invest-card-desc.less {
  height: 2.6em;
  overflow: hidden;
}

.show-more {
  display: inline-block;
}

.show-more p {
  margin-bottom: 0;
  font-size: 0.8rem;
  margin-left: 5px;
  letter-spacing: 0;
}

/* .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
  padding: 9.5px 14px;
} */
.state-ul {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
}

.state-ul li {
  padding: 0.3rem 0;
}

.state-ul li a {
  color: var(--secondary);
  text-decoration: none;
  font-size: 20px;
}

.state-ul li a:hover {
  color: var(--secondary);
}

.race-item a {
  color: var(--primary);
  font-size: 22px;
}

.race-item p {
  font-size: 20px;
}

.team-img {
  width: 100%;
}

.form-heading {
  color: var(--primary);
}

.card-icons {
  display: flex;
  gap: 1em;
}

.investor-card .card-icon {
  border-radius: 50%;
  aspect-ratio: 1;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.investor-card .card-icon.instagram {
  background: #e11f1c88;
}

.investor-card .card-icon.in {
  background: #e11f1ccc;
}

.investor-card .card-icon.twitter {
  background: #e11f1c;
}

.t-card-img {
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  aspect-ratio: 1;
}

.t-card-img img {
  width: 100%;
  min-height: 100%;
}

.t-card-desc {
  font-size: 0.9rem;
  letter-spacing: 1px;
  line-height: 1.4rem;
  overflow: hidden;
}

.t-card-desc.limit {
  height: 4.2rem;
}

.t-card-desc.expandable {
  height: 4.2rem;
  overflow: hidden;
}

.responsive-text {
  width: clamp(300px, 50%, 768px);
  margin: auto;
}

.investor-card .custom-card-title {
  font-size: 1rem;
}

.custom-card-title.small {
  font-size: 20px;
}

.t-card-wrapper {
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* background: var(--white); */
  padding: 1em;
  /* box-shadow: 1px 1px 1px 1px var(--light-gray); */
}

/* .custom-section:not(.grey-bg) .t-card-wrapper {
  box-shadow: 0px 0px 10px 1px var(--light-gray);
} */

.team-section .section-title {
  margin-bottom: 1rem;
}

.read-more-btn {
  all: unset;
  color: var(--primary);
  cursor: pointer;
}

.contact-right {
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info-item {
  display: flex;
  align-items: start;
  margin-bottom: 0.5em;
}

.info-item-body {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.info-title {
  font-weight: 500;
  padding-left: 10px;
  margin-bottom: 0;
}

.info-desc {
  padding-left: 10px;
  font-size: 14px;
  width: 70%;
  margin-left: auto;
  letter-spacing: 0;
}

.info-desc:not(:first-child) {
  word-wrap: break-word;
}

.social-icons {
  width: 30%;
  display: flex;
  justify-content: space-between;
  margin: 0.5em 0;
}

.social-icons i {
  font-size: 1.2rem;
  color: var(--dark);
  opacity: 0.7;
}

.contact-map {
  width: 100%;
  height: 100%;
}

.contact-form {
  padding: 1em;
}

.contact-form input,
.contact-form textarea {
  margin-bottom: 1rem;
  border: 1px solid var(--light);
  background-color: var(--light);
  padding: 0.5em 1em;
}

.contact-form input:hover,
.contact-form textarea:hover {
  border: 1px solid var(--primary);
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none !important;
  box-shadow: none;
  border-color: var(--primary);
  background-color: var(--light);
}

.contact-image {
  width: 400px;
  text-align: center;
}

.last-section h2 {
  font-family: "josefin Sans";
}

.blog-creater {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blog-creater .inner {
  display: flex;
  align-items: center;
}

.blog-creater img {
  border-radius: 50px;
  width: 50px;
  height: 50px;
  margin-right: 0.5rem;
}

.blog-creater span {
  font-size: 14px;
}

.blog-body h3 {
  font-size: 40px;
  font-weight: 600;
  font-family: arial;
  margin-top: 1rem;
}

.blog-body p {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.blog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blog-footer div span:not(:first-child) {
  margin-left: 2rem;
}

.blog-footer i {
  color: var(--primary);
}

.blog-img {
  width: 100%;
}

.custom-card .tag {
  fill: var(--primary);
  width: 90px;
  position: absolute;
  top: -26px;
  right: -22px;
}

.custom-card .tag div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-card .tag div span {
  position: absolute;
  font-size: 25px;
  color: var(--white);
  font-family: "josefin Sans";
}

/* ============================dashboard-style==================== */
.css-o5srbh-MuiPaper-root-MuiAppBar-root {
  background-color: #ff4141 !important;
}

.dashboard-logo {
  margin-top: 8px;
  width: 100px !important;
}

/* ---------------------dashboard-design----------------------- */
.css-1o1hm4z-MuiDrawer-docked .MuiDrawer-paper {
  z-index: 222222;
}

.dashboard-box {
  border-radius: 20px !important;
  padding: 16px !important;
  background-color: #fff5f5 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  height: 95%;
  margin: auto;
  box-shadow: none !important;
  gap: 10px;
  margin: 0;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;
  height: 143px;
  margin-bottom: 16px;
  position: relative;
  z-index: 10;
}
.boxwithdrawlReqPagebox {
  width: 140px;
  height: 140px;
  background-color: #fff;
  position: relative;
  border-radius: 100%;
}
.boxwithdrawlReqPagebox svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dashboard-box-withdrawlReq {
  border-radius: 20px !important;
  padding: 16px !important;
  background-color: #fff5f5 !important;
  display: flex;
  align-items: center;
  width: 95%;
  height: 95%;
  margin: auto;
  box-shadow: none !important;
  /* gap: 10px; */
  margin: 0;
  cursor: pointer;
  position: relative;
  z-index: 10;
}
.dashboard-box-withdrawlReq h3 {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  color: #e0221e;
  margin-top: 30px;
}
.dashboard-box-withdrawlReq h4 {
  font-family: "Poppins", sans-serif;
  font-size: 60px;
  font-weight: 700;
  line-height: 35px;
  text-align: center;
  color: #e0221e;
}

.dashboard-box:hover {
  background: linear-gradient(244.48deg, #e0221e 33.84%, #8f0000 92.38%);
  /* transform: scale(1.05); */
}
.dashboard-box:hover h3,
.dashboard-box:hover h4,
.dashboard-box:hover h6 {
  color: #fff;
}

.dashboard-box h3 {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  color: #e0221e;
  transition: color 0.3s ease;
}
.dashboard-box h6 {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #e0221e;
  transition: color 0.3s ease;
}
.dashboard-box h4 {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 25px;
  line-height: 30px;
  color: #e0221e;
  word-break: break-all;
  transition: color 0.3s ease;
}
.dashboard-box .img-con {
  border-radius: 100px;
  background: #ffffff;
  width: 68px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dashboard-box img {
  width: auto;
  object-fit: contain;
  padding: 6px;
}

.chevron-icon {
  display: none !important;
}

/* ========================404================= */
.not-found-image {
  position: relative;
}

.not-found-image img {
  width: 100%;
}

.not-found-image .button {
  position: absolute;
  bottom: 0;
}

.not-found-image .button a {
  color: var(--primary);
  text-decoration: none;
}

#custom::-webkit-input-placeholder {
  color: #fff !important;
}

.css-1j9kmqg-MuiDataGrid-toolbarContainer {
  gap: 1em;
}

/* .MuiDataGrid-cell[data-field='actions'] svg:nth-child(2){
  color: red !important;
} */

.search-icon svg {
  color: var(--light);
}

/* new about page */
.about-logo {
  width: 80%;
}

.page-banner {
  position: relative;
  overflow: hidden;
}

.page-banner-body {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
}

.page-banner-title {
  font-size: 2rem;
  font-weight: 500;
  color: white;
}

.page-banner .background-img {
  position: absolute;
  bottom: 0;
  z-index: -1;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  filter: brightness(0.5);
  width: 100%;
  min-height: 100%;
}

/* new contact page */
.map-iframe {
  border-radius: 1em;
  overflow: hidden;
  height: 100%;
  min-height: 350px;
}

.video-iframe iframe {
  border-radius: 1em;
  width: 100%;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.map-iframe iframe {
  width: 100%;
  height: 100%;
}

.center-x {
  width: 100%;
  display: flex;
  justify-content: center;
}

.center-xy {
  display: grid;
  place-items: center;
}

.scroll-x {
  overflow-x: auto;
  padding: 25px;
}

/* new landing page css */

.investor-card {
  padding-block: 5%;
}

.investor-card-img {
  width: 80%;
  margin: auto;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid #00000033;
  display: flex;
  align-items: center;
  justify-content: center;
}

.investor-card-img:hover img {
  filter: grayscale(0);
}

.investor-card-body {
  padding-inline: 1em;
}

.investor-card-img-inner {
  border-radius: 50%;
  overflow: hidden;
  width: 90%;
  height: 90%;
  display: flex;
  align-items: center;
}

.investor-card-img-inner img {
  width: 100%;
  min-height: 100%;
  border-radius: 50%;
  /* filter: grayscale(1); */
  transition: all 0.3s ease;
  object-fit: contain;
}

.investor-card:hover .investor-card-img img {
  filter: grayscale(0);
}

.section-dots {
  display: flex;
  align-items: center;
  gap: 0.5em;
  width: 100%;
  justify-content: center;
  padding-block: 0.5em;
}

.section-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #e11f1c;
}

.dot-1 {
  opacity: 0.2;
}

.dot-2 {
  opacity: 0.4;
}

.dot-3 {
  opacity: 0.6;
}

.dot-4 {
  opacity: 0.8;
}

.dot-5 {
  opacity: 1;
}

.recent-investors {
  margin-top: 1em;
  margin-bottom: 1em;
}

.mobile-header {
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 3;
  gap: 1rem;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  background-color: var(--dark);
  width: clamp(300px, 100%, 576px);
  transform: translateX(101%);
  transition: all 0.3s ease;
}

.mobile-header .simple-btn.login {
  margin-right: 0;
}

.mobile-header.show {
  transform: translateX(0);
}

.mobile-header nav {
  height: 100%;
}

.mobile-header ul {
  display: flex;
  align-items: center;
  padding: 1em;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 1em;
}

.header-button {
  all: unset;
  color: var(--light);
  font-size: 1.5rem !important;
  height: 72px;
}

.header-button.close {
  position: fixed;
  right: 1em;
}

.main-header {
  height: 72px;
  /* background: rgba(228, 228, 228, 0.15) !important; */
  display: flex;
  align-items: center;
  top: 0;
  left: 78px;
  right: 0;
  z-index: 1;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  z-index: 1;
  padding: 1rem;
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);
  position: fixed;
  background: #404040;
  z-index: 9999;
}

.main-header.bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) !important;
}

.main-header-link {
  margin-left: 1em;
  color: var(--light);
  font-weight: 300;
  white-space: nowrap;
}

.mobile-header-link {
  color: var(--light);
  text-align: center;
}

.main-header-link:hover {
  color: var(--primary);
}

.header-line {
  width: 1px;
  height: 45px;
  background-color: var(--lighter);
  margin-left: 1em;
  margin-right: 1em;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left .search-icon {
  background: rgba(228, 228, 228, 0.15);
  border-radius: 6px;
  padding: 0em 10px;
  cursor: pointer;
}

.main-logo {
  width: 98px;
  height: 36px;
}

.main-logo img {
  width: 100%;
  height: 100%;
}

.section-logo {
  display: flex;
  justify-content: center;
  padding: 1em 0;
}

.search-box {
  display: flex;
  align-items: center;
}

.stat-box {
  border-radius: 1em;
  padding: 1em;
  display: flex;
  flex-direction: column;
  background: rgba(39, 39, 39, 0.8);
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.4);
  justify-content: center;
  position: absolute;
}

.stat-box.order-1 {
  top: 10%;
  left: 0;
  transform: translateX(-66%);
}

.stat-box.order-2 {
  top: 10%;
  right: 0;
  transform: translateX(71%);
}

.stat-box.order-3 {
  top: 37%;
  left: 22px;
  transform: translateX(-59%);
}

.stat-box.order-4 {
  top: 66%;
  left: 0;
  transform: translateX(-69%);
}

.stat-box.order-5 {
  top: 58%;
  right: 0;
  transform: translateX(65%);
}

.stat-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-number {
  margin-bottom: 0;
  padding-bottom: 0 !important;
  font-weight: 700;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  color: var(--light);
  line-height: 1em;
  padding-right: 9px;
}

.stat-icon {
  font-size: 1.8rem;
  margin-bottom: 0.3em;
  color: var(--light);
  width: 40px;
  margin-left: 10px;
}

.stat-icon img {
  width: 100%;
}

.stat-label {
  font-family: "Raleway";
  font-weight: 500;
  font-size: 12px;
  color: var(--light);
  margin-bottom: 0;
  line-height: 1.1em;
  margin-top: 0.5em;
  max-width: 120px;
}

.stat-label .bg-label {
  background: #343434;
  border-radius: 30px;
  padding: 4px 10px;
}

.get-started-section .section-title {
  margin-bottom: 10px;
  font-weight: bold;
}

.get-started-body {
  width: 80%;
}

.get-started-section small {
  margin-top: 10px;
}

.get-started-img {
  width: 100%;
  aspect-ratio: 6/5;
  overflow: hidden;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}

.get-started-img img {
  width: 100%;
  min-height: 100%;
}

.landing-page {
  font-family: "Bebas neue";
}

.lp-invest-i-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.lp-invest-img {
  margin-bottom: 10px;
}

.normal-p,
.normal-p * {
  font-size: 1rem;
  color: #404040;
}

.para {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--dark);
  margin-bottom: 0;
}

input[type="radio"] {
  accent-color: var(--primary);
}

.normal-p.light-p {
  font-weight: 300;
  font-size: 20px;
  color: var(--white);
  line-height: 1.4em;
  letter-spacing: 1px;
}

.simple-text {
  letter-spacing: 1px;
  color: var(--dark);
}

.dark-text {
  color: #404040;
}

.red-text {
  color: #e11f1c;
}

.primary {
  color: var(--primary);
}

.dark {
  color: var(--dark);
}

.recharts-legend-wrapper .dark {
  font-weight: 500;
}

.failure {
  color: #ff6961;
}

.success {
  color: #4bb543;
}

.section-title {
  font-size: 35px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 3rem;
  letter-spacing: 0;
  line-height: 1.2em;
  font-family: "Raleway", sans-serif;
  color: var(--dark);
}

.section-subtitle {
  font-size: 25px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1em;
  font-family: "Raleway", sans-serif;
  color: var(--dark);
}

.title {
  font-size: 25px;
  font-weight: 500;
  margin-bottom: 1em;
  letter-spacing: 1px;
  color: var(--dark);
}

.section-title.light-title {
  font-weight: 500;
  font-size: 30px;
  color: var(--white);
}

.section-title.main-section-title {
  font-size: 50px;
}

/* 
.section-title::first-letter {
  color: var(--primary);
} */

.dashboard-title {
  font-family: "Poppins", sans-serif;
  color: var(--dark);
  font-weight: 500;
  font-size: 1.8rem;
  margin-bottom: 1em;
  margin-bottom: 0;
}

.custom-section {
  padding: 5rem 0;
}

.clip-section {
  position: relative;
}

.clip-section .triangle {
  position: absolute;
  background-color: var(--light);
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  clip-path: polygon(100% 1%, 0% 100%, 100% 100%);
}

.ceo-message-box {
  border-left: 4px solid var(--primary);
  padding: 3em;
  background: white;
  box-shadow: inset -1px -1px 0px 0px var(--light-gray);
  border-radius: 10px;
}

.ceo-message-box .quote-icon {
  font-size: 3rem;
}

.ceo-message-box p {
  font-style: italic;
}

.large-p {
  font-size: 50px;
  font-weight: 600;
}

.grey-bg {
  background-color: #f3f3f3;
}

.lighter-gray-bg {
  background-color: var(--lighter-gray);
}

.lighter-gray-item {
  background-color: var(--lighter-gray);
  padding: 0.5em 1em;
  border-radius: 5px;
  margin: auto;
  text-align: center;
}

.darker-gray-item {
  background-color: #303030;
  padding: 0.5em 1em;
  border-radius: 5px;
  margin: auto;
  text-align: center;
  color: var(--light);
}

.pre-line {
  white-space: pre-line;
}

.icon {
  width: 20px;
}

.small-shade {
  box-shadow: 1px 1px 4px -2px gray;
}

.accordion-item {
  font-family: "Raleway";
  box-shadow: 1px 1px 1px 0px var(--light-gray);
}

.main-text {
  text-align: justify;
  text-align-last: center;
  width: 50%;
  margin: auto;
}

.accordion-button {
  background-color: #f3f3f3 !important;
  font-weight: 600;
  color: #404040;
  font-size: 18px;
}

.accordion-button:focus {
  box-shadow: none;
  color: #404040;
}

.accordion-body {
  border: 7px solid #f3f3f3;
}

.accordion-button:not(.collapsed) {
  box-shadow: none;
}

.accordion-button:not(.collapsed)::after {
  content: "\\2212";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  background-image: unset;
}

.accordion-button:not(.collapsed) {
  color: #404040;
}

.accordion-button.collapsed::after {
  content: "\\002b";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  background-image: unset;
}

.accordion-item {
  margin-bottom: 1rem;
  border: none;
  border-radius: 8px;
  overflow: hidden;
}

.accordion-body {
  font-size: 20px;
  color: #404040;
}

.accordion-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.accordion-section {
  padding: 3rem 0 5rem;
}

.target-img {
  display: flex;
  justify-content: center;
}

.target-img img {
  width: 80%;
}

.main-section-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  /* min-height: 100vh; */
  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.main-section {
  top: 0;
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  width: 100%;
  background-size: cover;
  background-position: bottom center;
  transition: all 0.5s ease;
  background-size: cover;
  background-position: center;
  position: fixed;
  z-index: 9999;
}

.header-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center;
}

.text-section p {
  margin-bottom: 0;
}

.text-section .section-title {
  font-size: 40px;
  margin-bottom: 2rem;
}

.courgette {
  font-family: "Courgette";
}

.lp-invest-i-wrapper {
  text-align: center;
}

.grid-section p,
.grid-section2 p:not(.large-p) {
  padding: 0 2rem 2rem;
}

.grid-section2 .large-p {
  margin-bottom: 0;
  font-size: 30px;
  text-transform: uppercase;
  letter-spacing: 0;
}

.red-bg {
  background-color: var(--primary);
}

.head-box {
  background-color: var(--primary);
  width: 100%;
  height: 200px;
  position: relative;
}

.white-box {
  background: white;
  padding: 1em;
  border-radius: 1em;
}

.head-box-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 100px;
}

.main-section-text {
  padding-right: 78px;
}

.main-section .row p:last-child {
  font-family: "Raleway";
  font-weight: 500;
  font-size: 12px;
  line-height: 33px;
  letter-spacing: 1px;
}

.rounded-input-group {
  background: rgba(228, 228, 228, 0.15);
  border-radius: 30px;
  width: 85%;
  height: 40px;
  display: flex;
}

.rounded-input-group button {
  margin-left: auto;
  height: 100%;
  min-width: fit-content;
}

.rounded-input {
  background: rgba(228, 228, 228, 0);
  border-radius: 30px;
  border: none;
  padding: 0.2em 1em;
  color: var(--light-gray);
  min-width: 0;
}

.rounded-input::placeholder {
  color: var(--light);
}

.main-section .normal-p *,
.main-section .normal-p {
  color: var(--light);
}

.main-section .section-title {
  color: var(--light) !important;
}

.main-section .row p:first-child {
  padding-bottom: 0.5rem;
}

.lp-shop-crop {
  width: 100%;
  height: 100%;
}

.lp-phone-img-wrapper {
  aspect-ratio: 5/11;
  width: 50%;
  position: relative;
}

.language-btn {
  border-radius: 30px;
  margin-right: 10px;
}

.language-btn button {
  border: none;
  margin: 1px;
  padding: 0 1em;
}

.language-btn button:first-child {
  border-radius: 30px 0 0 30px;
}

.language-btn button:last-child {
  border-radius: 0 30px 30px 0;
}

.language-btn .active-lng {
  background-color: var(--primary);
  color: #fff;
}
.language-btnn {
  border-radius: 30px;
  margin-right: 10px;
}

.language-btnn button {
  border: none;
  margin: 1px;
  padding: 0 1em;
}

.language-btnn button:first-child {
  border-radius: 30px 0 0 30px;
}

.language-btnn button:last-child {
  border-radius: 0 30px 30px 0;
}

.language-btnn .active-lng {
  background-color: var(--primary);
  color: #fff;
}

.button-group {
  display: flex;
  align-items: center;
}

.lp-btn-header {
  background-color: var(--primary);
  border-radius: 30px;
  padding: 0.2em 1.2em;
  color: var(--white);
  cursor: pointer;
  border: 1px solid var(--primary);
  text-decoration: none;
  min-width: 80px;
}

.lp-btn {
  background-color: var(--primary);
  border-radius: 30px;
  padding: 0.2em 1.2em;
  color: var(--white);
  cursor: pointer;
  border: 1px solid var(--primary);
  text-decoration: none;
  min-width: 80px;
}
.lp-btn.adduser {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  padding: 12px 20px;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
}
.lp-btn-invest {
  background-color: var(--primary);
  border-radius: 30px;
  padding: 0.2em 1.2em;
  color: var(--white);
  cursor: pointer;
  border: 1px solid var(--primary);
  text-decoration: none;
  min-width: 80px;
}

.lp-btn-invest:hover {
  background-color: var(--primary);

  border: 1px solid var(--primary);
}

.lp-news-btn {
  background-color: var(--primary);
  padding: 0.2em 1.2em;
  color: var(--white);
  border: 1px solid var(--primary);
  text-decoration: none;
  /* min-width: 80px; */
  font-weight: 700;
}
.join-banner-news {
  display: flex;
  /* flex-direction: column; */
}
.join-banner-news .lp-news-btn:hover {
  color: white; /* Change text color on hover */
}

.join-banner-news img {
  width: 300px;
  object-fit: contain;
}
.lp-btn.square-btn {
  border-radius: 5px;
}

.lp-btn-invest.inverted-btn {
  background-color: var(--dark);
  border: 1px solid var(--dark);
  color: var(--light);
}

.lp-btn.inverted-btn {
  background-color: var(--dark);
  border: 1px solid var(--dark);
  color: var(--light);
}

.lp-btn.full-btn {
  border-radius: 10px;
  width: 100%;
}
.lp-btn-invest.full-btn {
  border-radius: 10px;
  width: 100%;
}
.lp-btnn {
  background-color: var(--primary);
  border-radius: 30px;
  padding: 0.2em 1.2em;
  color: var(--white);
  cursor: pointer;
  border: 1px solid var(--primary);
  text-decoration: none;
  min-width: 80px;
}

.lp-btnn.square-btn {
  border-radius: 5px;
}

.lp-btnn:hover {
  color: inherit;
}

.lp-btnn.inverted-btn {
  background-color: var(--dark);
  border: 1px solid var(--dark);
  color: var(--light);
}

.lp-btnn.full-btn {
  border-radius: 10px;
  width: 100%;
}

.dark-canvas .lp-btn:hover {
  color: var(--white);
  border-color: var(--white);
}

.center-wrapper {
  display: flex;
  justify-content: center;
}

.profile-card {
  background-color: var(--light) !important;
}

.simple-btn,
.simple-input {
  border: none;
  border-radius: 30px;
  background-color: inherit;
}

.simple-input {
  color: var(--dark);
}

.simple-button {
  all: unset;
  cursor: pointer;
}

.simple-btn.login {
  /* padding: 15px 35px 15px 35px; */
  padding: 10px 22px 10px 22px;
  border-radius: 5px;
  background-color: #e11f1c;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.83px;
  text-align: left;
  border: none;
  outline: none;
  color: #fff;
  border: none;
  outline: none;
  padding: 0.2em 1.2em;
  border-radius: 30px;
  border: 1px solid #e11f1c;
}
.simple-btn.login:hover {
  background-color: inherit;
  color: #000;
}

.main-header .lp-btn:hover {
  color: var(--light);
}

.form-control:focus {
  color: var(--dark);
  background-color: #fff;
  border-color: var(--dark);
  outline: 0;
  box-shadow: none;
}

.simple-square-btn {
  border: 1px solid;
  padding: 10px 12px !important;
  border-radius: 30px;
  margin: 5px 5px 5px 5px;
  background: inherit;
  color: var(--primary);
}

.simple-square-btn:hover {
  color: var(--dark);
}

.red {
  color: var(--primary);
}

.lp-btn:hover {
  background-color: inherit;
  color: var(--black);
}

.lp-btnn:hover {
  background-color: inherit;
  color: var(--black);
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #e11f1c;
  border-radius: 10px;
}

.custom-scroll::-webkit-scrollbar {
  width: 4px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #e11f1c;
  border-radius: 10px;
}

.open-sidebar .main-section {
  left: 172px !important;
}

.scroll-icon-wrapper {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 20px;
  right: 22px;
  transform: translateY(-130%);
  z-index: 1;
  cursor: pointer;
}

.scroll-icon-wrapper img {
  width: 100%;
  height: 100%;
}

.pure-section-text {
  width: 75%;
  margin: auto;
  text-align: center;
}

.custom-section.pure-section {
  padding: 4rem;
}

.pure-section .section-title {
  padding-bottom: 0rem;
  margin-bottom: 1rem;
}

/* investment page changes */
.user-invest-main {
  padding: 5px 0 !important;
}

.investment-page .section-title {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-size: 28px;
}

.investment-section .section-title {
  color: var(--white);
  font-size: 3rem;
  width: 80%;
  text-align: center !important;
  margin-bottom: 1rem !important;
  text-shadow: 1px 1px grey;
}

.investment-section .normal-p {
  color: var(--white);
  text-align: center;
  width: 80%;
  text-shadow: 1px 1px grey;
}

.investment-page .pure-section-text {
  text-align: justify;
  text-align-last: center;
}

.pure-card h3 {
  padding-bottom: 2rem;
}

.pure-card p {
  text-align: justify;
}

.light-bg {
  background-color: var(--light) !important;
}

.lighter-bg {
  background-color: var(--light-gray);
}

.normal-lh,
.normal-lh * {
  line-height: 1.5rem;
}

.tree-bg {
  background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5),
      rgba(12, 12, 12, 0.5)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  background-size: cover;
}

/* fazal css  */
.dashboard-main {
  /* display: flex; */
  /* margin-left: 78px; */
  display: flex;
  overflow: hidden;
}

.tooltip.bs-tooltip-top {
  background-color: red !important;
}

.sidebar {
  z-index: 999;
  left: 0 !important;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden !important;
  /* position: unset; */
}

.open-admin-sidebar {
  left: 0;
}

.dashboard-section-main {
  margin-left: 78px;
  display: block !important;
  width: 100%;
  /* background: var(--light); */
  background-color: #f3f3f3;
}

.dashboard-section-main .MuiGrid-item:not(.db-chart) {
  /* margin: 0.7em; */
  padding: 0;
}

.custom-box {
  background-color: #fff;
  box-shadow: 0px 4px 20px 0px #00000026;
  border-radius: 30px;
  padding: 50px;
}

.custom-box.cutting-box {
  width: 80%;
  padding: 2em;
  width: 100%;
  transform: translateY(-100px);
}

.light-img-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) !important;
}

.custom-box.login {
  padding: 4em 1em;
  border-radius: 0.6em;
}

.dashboard-section-main .MuiGrid-container:not(.db-container) {
  /* background-color: #fff; */
  /* box-shadow: 0 3px 5px -3px #a2a2a2; */
  /* border-radius: 5px; */
  /* padding: 1rem; */
}

.deshboard-header-wrapper {
  /* display: flex; */
  justify-content: space-between;
  align-items: center;
}

.jtc-share {
  background-color: #e0201c;
  color: #ffffff;
  padding: 10px;
  border-radius: 6px;
  margin-top: 20px;
}

.jtc-share h2 {
  font-family: "Poppins", sans-serif;
  color: var(--white);
  font-weight: 500;
  font-size: 1.5rem;
  margin-bottom: 1em;
  margin-bottom: 0;
  text-align: center;
}

.dashboard-share-box {
  background-color: transparent !important;
  box-shadow: none !important;
}

.dashboard-share-box .text {
  padding: 0.5rem;
  margin-bottom: 5px;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-share-box .text.index1 {
  margin-right: 5px;
}

.dashboard-share-box .text.index2 {
  margin-left: 5px;
}

.dashboard-share-box .text.index3 {
  margin-right: 5px;
}

.dashboard-share-box .text.index4 {
  margin-left: 5px;
}

.dashboard-share-box .text h3 {
  margin: 0px;
  font-family: "Poppins", sans-serif;
  color: #212529;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.dashboard-share-box .text h4 {
  margin: 0px;
  font-family: "Poppins", sans-serif;
  color: #212529;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.dashboard-section-main header {
  background: rgba(255, 255, 255, 1);
  box-shadow: none;
}

.db-container {
  justify-content: center;
}

.dashboard-chart .apexcharts-toolbar {
  display: none;
}

.filter-drop-down {
  display: flex;
  justify-content: end;
  position: relative;
}

.filter-drop-down .select {
  display: flex;
  padding: 0.5rem 0.5rem 0.5rem 0.8rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  cursor: pointer;
}

.filter-drop-down h3 {
  text-transform: capitalize;
  margin: 0px;
  font-family: "Poppins", sans-serif;
  color: #212529;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.filter-drop-down svg {
  font-size: 24px;
  color: #e0201c;
}

.filter-drop-down .options {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  position: absolute;
  width: 100%;
  z-index: 10;
  height: 0px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
  animation: dropdownAnimationn 0.5s ease forwards;
  cursor: pointer;
}

@keyframes dropdownAnimationn {
  0% {
    height: 300%;
    overflow: unset;
    opacity: 1;
  }

  100% {
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
}

@keyframes dropdownAnimation {
  0% {
    height: 0;
    overflow: hidden;
    opacity: 0;
  }

  100% {
    height: 300%;
    overflow: unset;
    opacity: 1;
  }
}

.filter-drop-down .options.active {
  transition: opacity 0.3s ease;
  animation: dropdownAnimation 0.5s ease forwards;
}

.filter-drop-down .options ul {
  padding: 0;
  margin: 0;
}

.filter-drop-down .options li {
  padding: 0.5rem 0.5rem 0.5rem 0.8rem;
  list-style: none;
}

/* body{
  overflow: hidden;
} */
.modal-li-flex {
  display: flex;
  align-items: center;
}

.MuiDataGrid-root.MuiDataGrid-root--densityStandard {
  border: none !important;
}

.MuiDataGrid-row.even {
  background-color: var(--light);
}

.MuiTablePagination-displayedRows,
.MuiTablePagination-selectLabel {
  margin-bottom: 0;
}

.MuiDataGrid-row .MuiGrid-container {
  background-color: inherit;
  box-shadow: none;
}

.MuiDataGrid-columnHeaderDraggableContainer {
  background-color: white !important;
}

.MuiDataGrid-cell {
}

.MuiDataGrid-cell:nth-child(even) {
}

.flex-with-title {
  display: flex;
  justify-content: end;
  align-items: center;
  padding-left: 10px;
  flex-wrap: wrap;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #a6a6a6;
}

.landing-main {
  display: flex;
}

.landing-main-page {
  height: 100vh !important;
  width: 100%;
}

/* login form */

/* Investor Slider----------------------------------------------------------------------- */
.rounded-square-img {
  width: 100%;
  aspect-ratio: 5/5;
  display: flex;
  align-items: center;
  border-radius: 3px;
  overflow: hidden;
}

.investor-slider {
  overflow: hidden;
}

.investor-slider .slick-list {
  border-right: 1px solid #fff;
}

.rounded-square-img img {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
}

.person-item-desc {
  font-size: 0.8rem;
  margin-bottom: 5px;
  letter-spacing: 1px;
  color: var(--dark);
}

.person-item-days {
  display: flex;
  gap: 15px;
  align-items: center;
}

.person-item-wrapper {
  border-right: 1px solid var(--light-gray);
}

/* Investor Slider End----------------------------------------------------------------------- */

/* Open section -------------------------------------------------------------------- */

.pitch-card-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 6/7;
  border-radius: 5px;
  margin-top: 4.8rem;
}

.card-text {
  letter-spacing: 1px;
  font-size: 0.9rem;
  line-height: 1.3rem;
  margin-bottom: 0.5em;
}

.card-subtitle {
  font-size: 18px;
  font-weight: 500;
}

.pitch-card {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: all 0.5s ease;
  border-radius: 5px;
}

.pitch-card-item {
  padding: 1em;
  background-color: rgba(255, 255, 255, 0.15);
  margin-bottom: 1em;
  border-radius: 5px;
}

.flex-p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  font-size: 0.9rem;
  color: inherit;
}

.white {
  color: var(--white);
  color: #e11f1c;
  cursor: pointer;
}

.flex-p span:first-child {
  font-weight: 500;
  letter-spacing: 1px;
  opacity: 0.8;
}

.muted-text {
  opacity: 0.8;
}

.muted-md {
  opacity: 0.75;
}

.white-muted {
  color: var(--white);
  opacity: 0.8;
}

.pitch-card-front {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  padding: 1em;
  border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 0px 1px #a6a6a688;
}

.pitch-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  padding: 1em;
  border-radius: 5px;
  backdrop-filter: brightness(0.5);
  -webkit-backdrop-filter: brightness(0.5);
  border-radius: 5px;
}

.pitch-card-front img {
  width: 100%;
  height: 100%;
}

.pitch-card:hover {
  transform: rotateY(180deg);
}

.open-header {
  /* padding-right: 1em; */
  padding-top: 2rem !important;
}

.open-header ul:not(.open-header-sub-menu) > li {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);
}

.open-header ul {
  display: flex;
  padding-left: 0;
  margin-bottom: 0;
  flex-direction: column;
}

.open-pitch ul {
  display: block;
}

.open-pitch {
  padding-right: 1em;
}

.open-pitch section dl div p:nth-child(1) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
}

.open-pitch section dl div p:nth-child(2) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(3) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(4) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(5) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(6) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(7) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(8) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(9) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(10) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(11) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(12) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(13) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(14) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(15) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(16) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(17) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(18) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(19) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(20) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(21) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(22) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(23) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(24) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(25) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(26) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(27) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(28) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(29) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(30) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(31) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(32) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(33) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(34) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(35) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(36) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(37) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(38) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-pitch section dl div p:nth-child(39) {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
}

.open-pitch section dl div p:nth-child(40) {
  color: #fff;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.open-section {
  min-height: 100vh;
}

.open-section dt {
  font-size: 1.3rem;
  color: var(--dark);
  margin-bottom: 0.5em;
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);
}

.open-section .section-title {
  padding: 2rem 0 0.7em;
  text-align: start;
  font-size: 24px;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 0;
}

.open-header li {
  /* padding-bottom: 50px; */
  margin-bottom: 1em;
  font-weight: 700;
  color: var(--dark-gray);
  cursor: pointer;
}

.open-header-sub-menu {
  margin-left: 0.5em;
  box-shadow: inset 1px 0 rgba(0, 0, 0, 0.1);
  transition: all 1s ease;
  margin-bottom: 1em !important;
}

.open-header-sub-menu li {
  padding-bottom: 0;
  padding-left: 0.5em;
}

.open-header-sub-menu li:last-child {
  margin-bottom: 0 !important;
}

.open-header-sub-menu li.active {
  color: var(--primary);
  border-bottom: none !important;
}

.open-header li.active {
  border-bottom: 3px solid var(--primary);
  color: var(--primary);
}

.open-header li:hover {
  color: var(--primary);
}

.deal-term-wrapper {
  background: var(--grey-bg);
  padding: 1em;
  border-radius: 5px;
  border: 1px solid var(--light-gray);
}

.deal-term {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.08);
  padding-bottom: 1em;
  margin-bottom: 1em;
  color: var(--dark);
}

.deal-term p {
  margin: 0;
  letter-spacing: 1px;
}

.deal-term-header {
  display: flex;
  justify-content: space-between;
}

.deal-term-title,
.deal-term-desc {
  font-size: 0.9rem;
}

.deal-term-stat {
  font-size: 1.2rem;
  font-weight: 600;
}

.deal-term-body {
  max-height: 0;
  overflow: hidden;
  transition: all 1s ease-in-out;
}

.deal-term:hover .deal-term-body {
  max-height: 1000px;
}

/* @keyframes slideup {
  0%{
    max-height: 0;
  }
  100%{
    max-height: 1000px;
  }
} */
.deal-term:hover .icon svg {
  color: var(--primary);
}

.section-img {
  aspect-ratio: 5/3;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 1em;
}

.section-img img {
  width: 100%;
  min-height: 100%;
}

.open-pitch-video {
  width: 100%;
  aspect-ratio: 5/4;
  border-radius: 10px;
  overflow: hidden;
}

/* Open section End-------------------------------------------------------------------- */

/* Blog section of landing page */

.blog-card {
  background-color: var(--white);
  border-radius: 0.3rem;
  overflow: hidden;
  box-shadow: 1px 1px 1px 1px var(--light-gray);
  height: 450px;
  position: relative;
}

.blog-card-footer p {
  margin-bottom: 0;
}

.line-ellipse {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer-img {
  width: 100%;
}

.footer-img img {
  width: 100%;
  border-radius: 5px;
  opacity: 0.9;
}

.blog-card-img {
  height: 100%;
}

.blog-card-img img {
  width: 100%;
  height: 250px;
}

.blog-card-title {
  font-size: 1.3rem;
  color: var(--dark);
  margin-bottom: 0.3em;
  font-weight: 600;
  line-height: 1.5em;
  letter-spacing: 0px;
}

.blog-card-body-wrapper {
  padding: 1em;
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--white);
  width: 100%;
}

.t-card-item .card-title {
  font-family: "Poppins";
  color: var(--dark);
  padding-bottom: 3px;
}

.icon-img {
  min-width: 45px;
  max-width: 45px;
  min-height: 45px;
  max-height: 45px;
  overflow: hidden;
  border-radius: 50%;
}

.icon-img img {
  width: 100%;
  height: 100%;
}

.blog-card-footer {
  display: flex;
  gap: 1em;
}

.card-person {
  font-weight: 600;
  line-height: 1.4rem;
  letter-spacing: 1px;
}

.card-time {
  font-size: 0.7rem;
}

.card-desc {
  font-size: 0.9rem;
  letter-spacing: 1px;
  line-height: 1rem;
  max-height: 3rem;
  overflow: hidden;
}

.blog-section .slick-arrow::before {
  color: var(--primary);
  font-size: 1.5rem;
}

.blog-section .slick-next,
.team-section .slick-next,
.testimonial-section .slick-next,
.investors-section .slick-next {
  right: -5px;
}

.blog-section .slick-prev,
.team-section .slick-prev,
.testimonial-section .slick-prev,
.investors-section .slick-prev {
  left: -9px;
}

.text-body {
  white-space: pre-line;
  letter-spacing: 0;
}

.team-section .slick-arrow::before {
  color: var(--primary);
  font-size: 1.5rem;
}

.team-title {
  line-height: 1.4em;
  display: flex;
  align-items: center;
}

.member-open-card {
  min-height: 500px;
  border-radius: 1em 1em 0px 0px;
}

.testimonial-card {
  background: var(--white);
  padding: 1em;
  border-radius: 0.3rem;
  box-shadow: 1px 1px 1px 0px var(--light-gray);
  position: relative;
}

.testimonial-card .quote-icon {
  position: absolute;
  font-size: 3rem;
  color: var(--dark);
}

.testimonial-card .quote-icon:first-child {
  top: 0;
  left: 0;
  right: 0;
  margin-inline: auto;
  transform: translateY(-50%);
}

.testimonial-card .quote-icon:nth-child(2) {
  bottom: 0;
  left: 0;
  right: 0;
  margin-inline: auto;
  transform: translateY(50%);
}

.testimonial-card .row {
  align-items: center;
}

.testimonial-card .image-wrapper {
  aspect-ratio: 1/1;
  border-radius: 50%;
  width: 70%;
  overflow: hidden;
  margin: auto;
}

.image-wrapper {
  display: flex;
  align-items: center;
}

.image-wrapper img {
  width: 100%;
  min-height: 100%;
}

.custom-card-title {
  margin-block: 0.5rem;
  text-align: start;
  font-size: 24px;
  text-transform: uppercase;
  font-weight: 700;
}

.icon {
  width: 30px;
  height: 30px;
  font-size: 1.5rem;
}

.text-icon {
  font-size: 1.5rem;
}

.card-line {
  width: 10%;
  height: 5px;
  background: var(--primary);
}

.rating-stars {
  display: flex;
  gap: 0.5em;
}

.rating-stars svg {
  font-size: 1.5rem;
  color: #ce9f56;
}

.testimonial-section .slick-arrow::before {
  color: var(--primary);
  font-size: 1.5rem;
}

/* Blog page */
.blog-title {
  text-align: start;
  font-size: 24px;
  font-weight: 700;
  color: var(--dark);
  position: relative;
  letter-spacing: 0px;
  font-weight: 500;
  line-height: 2.5rem;
}

.blog-desc {
  padding-top: 10px;
}

.blog-title::after {
  position: absolute;
  content: "";
  width: 5%;
  height: 5px;
  background-color: var(--primary);
  left: 0;
  bottom: -10px;
}

.blog-main-img {
  /* overflow: hidden; */
  display: flex;
  aspect-ratio: 5/2;
  align-items: center;
}

.blog-main-img img {
  width: 100%;
  min-height: 100%;
}

.blog-page .blog-card-wrapper {
  padding-inline: 0 !important;
}

.blog-desc,
.blog-page dd {
  font-size: 1rem;
  letter-spacing: 1px;
  font-weight: 500;
  line-height: 1.5rem;
  text-align: justify;
}

.blog-page dt {
  font-size: 1.3rem;
  color: var(--dark);
  margin-bottom: 0.5em;
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);
  display: inline-block;
}

.blog-page ul {
  list-style-type: disc;
  line-height: 2em;
}

.blog-page .blog-card {
  box-shadow: none;
  border: 1px solid var(--light-gray);
}

.blog-main {
  padding: 1em;
}

/* notice section */

.MuiGrid-root.MuiGrid-container.css-11lq3yg-MuiGrid-root {
  /* background-color: transparent; */
  padding: 10px;
  justify-content: center !important;
  flex-wrap: wrap !important;
  border-radius: 10px;
}

.share-type {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
  gap: 10px;
}

.dashboard-section-main .share-type {
  justify-content: start;
  padding-inline: 0px;
  gap: 10px;
}

.active_type {
  background-color: #dc3545;
  color: #ffff;
}

.form-control-radio {
  font-size: 20px;
  line-height: 1.1;
  color: #000000;
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
}

.footer-icons img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.content-wrapper-landing {
  display: block;
  line-height: 1rem;
  max-height: 4rem;
  overflow: hidden;
}

/* investors pitch */

.header-logo {
  width: 70%;
}

.banner-header {
  /* background: url('./../images/header_bg.png'); */
  padding: 2%;
  margin-top: 72px;
}

.banner-header-row {
  background-color: #181818;
  /* margin: 20px; */
  border-radius: 20px;
  padding: 1%;
}

.primary-tabs-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 3em;
  margin: 0 3%;
  padding-left: 0;
  justify-content: flex-start;
}

.primary-tab {
  font-weight: 500;
  font-size: 1.1rem;
  opacity: 0.4;
  border-bottom: 3px solid transparent;
  /* color: #A4A4A4; */
  font-family: "poppins";
  width: max-content;
}

.primary-tab.active {
  border-color: var(--primary);
  color: var(--primary) !important;
  opacity: 1;
  font-weight: 600;
}

.flex-wrap-items {
  display: flex;
  gap: 1em;
  align-items: center;
}

.flex-wrap-items.flex-sm {
  gap: 0.5em;
}

.flex-space {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.md-icon {
  font-size: 3rem;
}

.md-icon.img-icon {
  height: 50px;
}

.primary-box {
  background-color: var(--lighter-gray);
  padding: 1.5em;
  border-radius: 0.5em;
}

.dark-box {
  background-color: var(--dark);
  padding: 1.5em;
  border-radius: 0.5em;
}

.dark-box .para {
  color: var(--light);
}

.custom-table {
  width: 100%;
}

.custom-table thead {
  background-color: var(--dark);
}

.custom-table:not(.square-table) tr td:first-child,
.custom-table:not(.square-table) tr th:first-child {
  border-radius: 30px 0 0 30px;
}

.custom-table:not(.square-table) tr td:last-child,
.custom-table:not(.square-table) tr th:last-child {
  border-radius: 0 30px 30px 0;
}

.custom-table:not(.square-table) tr td:only-child,
.custom-table:not(.square-table) tr th:only-child {
  border-radius: 30px !important;
}

.square-table tr td:first-child,
.square-table tr th:first-child {
  border-radius: 15px 0 0 15px;
}

.square-table tr td:last-child,
.square-table tr th:last-child {
  border-radius: 0 15px 15px 0;
}

.square-table tr td:only-child,
.square-table tr th:only-child {
  border-radius: 15px !important;
}

.custom-table tr.active {
  background-color: var(--primary) !important;
  color: var(--light);
  position: relative;
}

.custom-table tr.active-dark {
  background-color: var(--dark) !important;
  color: var(--light);
}

.custom-table td.active-dark td {
  padding: 0.8em;
}

.custom-table td.active-light {
  background-color: var(--light);
}

.custom-table.active-light td {
  padding: 0.8em;
}

/* .custom-table tr td:nth-last-child(2).active,
.custom-table tr td:nth-last-child(2).active-dark {
  border-radius: 15px 0 0 15px;
} */

.start-cell {
  border-radius: 30px 0 0 30px;
}

.end-cell {
  border-radius: 0 30px 30px 0;
}

.only-cell {
  border-radius: 15px !important;
}

.only-cell.active {
  padding: 0.8em;
  border-radius: 15px;
  padding-inline: 3em;
}

.custom-table tr.active + tr:not(.active) {
  background-color: transparent !important;
}

.custom-table tr td.active,
.custom-table tr th.active {
  background-color: var(--primary);
  color: var(--light);
}

.custom-table tr {
  border-top: 10px solid var(--light);
  border-bottom: 10px solid var(--light);
}

.custom-table.table-white tr,
.custom-table.plain-table tr {
  border-color: #fff;
}

.custom-table tr td.active-dark,
.custom-table tr th.active-dark {
  background-color: var(--dark);
  color: var(--light);
}

.custom-table tr.active td {
  padding: 0.8em;
}

.custom-table td.full-cell {
  border-radius: 15px !important;
}

.custom-table .lead-row td {
  font-weight: 700;
  opacity: 0.9;
}

.custom-table .lead-cell {
  font-weight: 700;
  opacity: 0.9;
}

.custom-table thead th {
  color: var(--light);
  font-weight: 400;
  padding: 1em;
  white-space: nowrap;
}

.table-white {
  background-color: #fff;
  border-radius: 15px;
}

/* 
.custom-table tbody tr:first-child:not(.active, .active-dark) td {
  padding-top: 1em;
} */

.custom-table tbody td {
  font-weight: 400;
  padding: 0.3em 1em;
  white-space: nowrap;
}

.custom-table:not(.plain-table) tbody tr:nth-child(even) {
  background-color: var(--light-gray);
}

.custom-table.plain-table .light-row {
  background-color: var(--light-gray);
}

.border-bottom {
  border-bottom: 1px solid #727272;
}

.row-badge-wrapper {
  position: relative;
}

.chart-container {
  background-color: #fff;
  padding: 1em 1em 0 0;
}

.row-badge {
  position: absolute;
  left: -35px;
  top: -16px;
  padding: 0.6em;
  aspect-ratio: 1;
  background-color: var(--white);
  border-radius: 50%;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: 4px 4px 7px rgba(0, 0, 0, 0.35);
}

.badge-cell {
  margin-left: 1.3em;
}

.financial-chart .recharts-legend-wrapper {
  left: 0 !important;
}

.color-sector {
  clip-path: circle(79.1% at 22% 84%);
  width: 65px;
  height: 65px;
}

.color-sector.gray-sector {
  background-color: #d3d3d3;
}

.color-sector.dark-sector {
  background-color: #3e3e3e;
}

.color-sector.red-sector {
  background-color: #dc2023;
}

.color-sector.pink-sector {
  background-color: #ff6d6a;
}

.dark-cell {
  background-color: var(--dark);
}

.custom-th {
  font-size: 1.1rem;
  font-weight: 500;
  height: 60px;
  border-radius: 10px;
  padding-inline: 1em;
  gap: 0.5em;
  display: flex;
  align-items: center;
  color: var(--light);
}

.primary-cell {
  background-color: var(--primary);
}

.dark-cell-sm {
  padding: 0.3em 1em;
  background-color: var(--dark);
  border-radius: 10px;
  color: var(--light);
  margin: 2px 0;
}

.light-cell-sm {
  padding: 0.3em 1em;
  background-color: var(--light-gray);
  border-radius: 10px;
  margin: 2px 0;
}

.primary-cell-sm {
  padding: 0.3em 1em;
  background-color: var(--primary);
  color: var(--light);
  border-radius: 10px;
  margin: 2px 0;
}

.shrink-table .custom-row {
  padding-block: 0.5em;
}

.custom-row {
  padding-block: 1.5em;
}

.custom-row .row-badge {
  font-size: 0.8rem;
  top: -5px;
  left: 0;
}

.primary-selector .dropdown-toggle,
.primary-selector .dropdown-toggle:active,
.primary-selector .dropdown-toggle:focus-visible {
  background: var(--primary);
  border: none;
  box-shadow: none;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.4em;
}

.primary-selector .dropdown-menu {
  max-height: 220px;
  overflow: auto;
}

.primary-selector.grayscale .dropdown-toggle,
.primary-selector.grayscale .dropdown-toggle:active,
.primary-selector.grayscale .dropdown-toggle:focus-visible {
  background: var(--lighter);
  color: var(--dark);
  flex-direction: row-reverse;
}

.primary-selector .dropdown-toggle::after {
  display: none;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.5rem;
}

.pagination-button {
  background-color: var(--light-gray);
  border: none;
  color: var(--dark);
  font-size: 1rem;
  padding: 0.25rem;
  border-radius: 0.25rem;
  aspect-ratio: 1/1;
  width: 2.1rem;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.primary-selector .dropdown-item.active,
.primary-selector .dropdown-item:active {
  background-color: var(--primary);
}

input[type="checkbox"] {
  accent-color: var(--primary);
  border-color: var(--primary);
}

.center-cells tr th,
.center-cells tr td {
  text-align: center;
}

.line-blog {
  line-height: 2.5rem;
}

.square-dot {
  width: 12px;
  height: 12px;
}

.legend-cell {
  color: var(--dark);
  text-align: center;
  font-weight: 600;
  font-size: 0.7rem;
  letter-spacing: 1px;
}

.Sale-vs-ebitda {
  color: var(--dark);
  font-weight: 600;
  font-size: 0.7rem;
  letter-spacing: 1px;
}

.legend-cell_1 {
  color: var(--dark);
  text-align: center;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 1px;
}

.legend-entry {
  display: flex;
  align-items: center;
  gap: 0.5em;
  font-size: 0.9rem;
}

.legend-entry:not(.last) {
  border-bottom: 1px solid var(--dark-gray);
}

.join-banner {
  /* background: rgba(228, 228, 228, 0.15); */
  width: 100%;
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1em;
  border-top: 1px solid #dadada;
  margin-top: 72px;
  background-color: #404040;
}

.join-banner p {
  font-size: 14px;
  color: var(--light);
  text-align: start;
  letter-spacing: 0;
}

.join-banner-news {
  /* background: rgba(228, 228, 228, 0.15); */
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 1em;
  border-top: 1px solid #dadada;
  /* margin-top: 72px; */
  background-color: #000000;
}

.join-banner-news p {
  font-size: 14px;
  /* color: yellow; */
  color: #fff;
  text-align: start;
  letter-spacing: 0;
  /* margin-bottom: 12px !important; */
}
.join-banner-news marquee {
  font-size: 15px;
  /* color: yellow; */
  color: #fff;
  text-align: start;
  letter-spacing: 0;
  /* margin-bottom: 12px !important; */
}

.sales-growth-chart p {
  background: #2f80f5;
  color: var(--light);
  padding: 0.3em;
}

.chart-stroke {
  border: 1px solid #e7e7e7;
}

.layout_container {
  font-family: "Roobert";
  min-height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.card-1 {
  width: 500px;
  height: 480px;
  padding: 3rem;
  box-sizing: border-box;
  background: #322727;
  overflow: hidden;
  color: #fff;
}

.card-2 {
  width: 400px;
  height: 480px;
  box-sizing: border-box;
  background: #e11f1c;
  overflow: hidden;
  color: #fff;
  padding: 1rem 1rem 1rem 2rem;
}

.layout_container > .row {
  margin-top: 2.8rem;
}

.layout-text-profit {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 3.2rem;
  color: #fff;
}

.layout_currency-text {
  font-size: 19px;
  width: auto;
  border-radius: 20px;
  height: auto;
  margin-top: -10px;
  background-color: #e11f1c;
  padding: 6px 16px;
}

.primary-btn-profit {
  display: inline-block;
  padding: 13px 25px;
  background: #e11f1c;
  border-radius: 40px;
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  color: white;
  text-transform: capitalize;
  text-align: center;
  transition: all 0.5s;
  width: fit-content;
  border: none;
}

.primary-btn-profit:hover {
  background: white;
  color: #e11f1c;
}

.select-option-profit {
  background-color: #e11f1c;
  color: #fff;
  border: none;
  margin-top: -14px;
  /* width: 110px;
  height: 40px; */
  font-weight: 600;
  border-radius: 10px;
  padding-left: 10px;
}

.custome-slider-widget {
  margin-left: 15px;
}

.line-red {
  background-color: #e11f1c;
  width: 4px;
  height: 70%;
  margin-left: 30px;
}

.red-text-reg {
  color: #e11f1c;
  font-size: 1rem;
  font-weight: 700;
}

.black-text-reg {
  font-size: 1rem;
  font-weight: 700;
}

/* Content Page Css */

.Content-Main-Heading-container {
  margin: 2% 3%;
  background-color: #d71f26;
  border-radius: 20px;
  position: relative;
  height: 200px;
}

.Double-heading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Content-main-heading-1 {
  font-family: "Poppins", sans-serif;
  font-size: 3.75rem;
  font-weight: 600;
  color: #ffffff;
  text-shadow: -15px -10px 0 rgba(255, 255, 255, 0.1);
}

.Table-of-content-main {
  margin: 3%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 2% 2% 2% 0;
  display: flex;
  flex-wrap: wrap;
}

.Table-of-content-inner {
  flex: 1 1;
}

.TOC-rows {
  display: flex;
}

.TOC-Row {
  /* flex-wrap: wrap; */
  /* min-width: 280px; */
}

.TOC-rows-num {
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: #3e3e3e;
  /* width: 90px; */
  padding: 0 6%;
  display: flex;
  align-items: center;
  height: 50px;
}

.TOC-rows-title {
  padding: 4px;
}

.TOC-row-h {
  color: #d71f26 !important;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.15px;
  cursor: pointer;
}

.TOC-row-d {
  color: #3e3e3e;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.15px;
}

.separator {
  width: 90%;
  color: #cecece;
  margin: 5px auto;
}

.Heading-row {
  display: flex;
  background-color: #3e3e3e;
  color: white;
  margin: 3%;
  padding: 1% 2%;
  border-radius: 10px;
}

.Heading-row {
  flex: 1 1;
}

.Heading-row > table {
  flex: 1 1;
}

.link-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.Investors-pitch-nav {
  padding: 0 4%;
  margin-bottom: -1px !important;
}

.navbar-toggler {
  margin: 10px 0;
  border: none;
}

.Business-value-main-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.Business-value-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 10px;
  justify-content: flex-start;
}

.Business-value-box {
  margin: 10px;
}

/* new login form v2*/
.New-login-form-main {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /* background-position: center; */
  background-position: bottom center !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #f9f9f9;
  height: 100vh;
}

.New-login-form-inner {
  display: flex;
  flex-wrap: wrap;
  padding: 2% 6%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.New-login-form-Content {
  flex: 1.5 1;
  justify-content: center;
  flex-wrap: nowrap !important;
  align-items: center;
}

.New-login-bold-text {
  font-weight: 600;
  font-size: 20px;
  font-family: "poppins";
  letter-spacing: 0.5px;
}

.New-login-normal-text {
  font-weight: 400;
  font-size: 18px;
  font-family: "poppins";
  letter-spacing: 0.5px;
  margin-bottom: 5%;
}

.login-youtube-video {
  border-radius: 10px;
}

.Centre-the-content {
  text-align: center;
}

.New-login-form-form {
  flex: 1 1;
  background-color: white;
  border-radius: 10px;
  padding: 3% 3% 0 3%;
  height: fit-content;
  box-shadow: 0px 0px 25px rgb(211, 211, 211);
  margin-left: 7%;
  margin-right: 2%;
}

.New-login-form-logo {
  margin: 0 auto;
  width: 150px;
  cursor: pointer;
}

.New-login-form-heading {
  font-family: "poppins";
  font-weight: 400;
  font-size: 20px;
  letter-spacing: -0.5px;
}

.New-login-form-heading-2 {
  font-family: "poppins";
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.5px;
}

.Login-type-btn-container {
  margin: 25px 0 0 0;
}

.Login-type-btn {
  border: none;
  margin: 5px;
  background-color: transparent;
  color: #a7a6a6;
  font-size: 16px;
  font-weight: 500;
  font-family: "poppins";
}

.forget-password-btn {
  background-color: transparent;
  border: none;
  color: var(--primary);
  font-size: 14px;
  font-weight: 500;
  font-family: "poppins";
}

.Form-checkbox-holder {
  display: flex;
  justify-content: space-between;
}

.Login-btn-container {
  text-align: center;
}

.Login-btn-container > button {
  padding: 2%;
  width: 100%;
  background-color: var(--primary);
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: 500;
  font-family: "poppins";
  margin-top: 25px;
}

.signup-text-login-form {
  color: var(--primary);
  font-weight: 500;
  font-size: 16px;
  border: none;
  background-color: transparent;
}

.Input-custom-for-login {
  background-color: #ededed;
  border-radius: 5px;
  border: none;
  height: 55px;
  color: #3e3e3e;
  font-size: 16px;
  font-weight: 500;
  font-family: "poppins";
}

.Input-custom-for-login:focus {
  background-color: #ededed;
}

.Input-field-icons-body {
  border: none;
  background-color: #ededed;
  color: #3e3e3e;
}

.Input-field-icons {
  width: 20px !important;
}

.button-red-active {
  font-size: 16px !important;
  font-weight: 600 !important;
  font-family: "poppins";
  color: var(--primary) !important;
}

.pageloader {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.pageloader div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card-shares-investor {
  border-radius: 20px;
  margin: 30px;
  background-color: #ebebeb;
}

.circle-checkout {
  margin-right: 10px;
  margin-top: -6px;
}

.content-checkout {
  margin-top: 0px;
}

.checkout-field-box {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #ebebeb;
  border-radius: 7px;
}

.checkout-field-box > span {
  color: #565656;
  font-weight: 600;
  font-size: 16px;
}

.info-detail-step > h6 {
  color: #565656;
}

.checkout-terms {
  font-size: 1.3rem;
  color: #a5a5a5;
  font-family: "Raleway";
  font-weight: 600;
}

.black-checkout-name {
  color: #121212;
  font-weight: 600;
}

.cart-box {
  background-color: #e0201c;
  color: #ffffff;
  padding: 10px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.cart-box > span {
  color: #ffffff;
}

.terms-condition {
  padding: 10px;
  border-radius: 7px;
  background-color: #ebebeb;
}

.terms-condition > span {
  color: #a5a5a5;
}

.copy-clabe {
  color: #d71f26;
  margin-left: 10px;
  font-weight: 600;
  cursor: pointer;
}

.transition-div {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: max-content;
  min-width: 96px;
  min-height: 0;
  padding: 8px 12px;
  background-color: rgba(50, 50, 51, 0.88);
  border-radius: 8px;
  z-index: 9999;
}

.transition-div p {
  color: #fff !important;
  font-size: 14px !important;
  line-height: 20px;
  white-space: pre-wrap;
  text-align: center;
  word-wrap: break-word;
  margin: 0 !important;
}

.transition-div.show {
  opacity: 1;
}

/* Ali Work */

.doc-card {
  margin: 20px 20px;
  height: 350px;
}

.other-details {
  display: flex;
  padding-left: 20px;
  flex-direction: column;
}

.other-details h4 {
  font-family: "Raleway";
  font-size: 28px;
  font-weight: 700;
  line-height: 33px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 40px;
}

.other-details p {
  font-family: "Raleway";
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 40px;
}

.doc-with-title {
  padding-left: 20px;
}

.doc-with-title .doc-title {
  font-family: "Bebas Neue";
  font-size: 70px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 0em;
  text-align: left;
}

.NFT-image-upload-txt {
  display: flex;
  justify-content: space-between;
  background: #404040;
  padding: 17px 16px;
  border-radius: 10px;
}

.box-verified {
  display: flex;
  justify-content: space-between;
  background: #404040;
  padding: 17px 16px;
  border-radius: 10px;
}

.NFT-image-upload-txt button {
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  background: transparent;
  border: none;
  outline: none;
}

.box-verified button {
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  border: none;
  outline: none;
}

.NFT-image-upload-txt button svg {
  font-size: 26px;
  margin-bottom: 4px;
}

.NFT-image-upload-txt p {
  color: #9c9c9c;
  text-align: center;
  font-size: 14px;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0px;
}

.profile-nft-row1 .footer-descc {
  color: #404040;
  text-align: center;
  font-size: 16px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 15px 0px !important;
}

.doc-card .doc-card-status {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 10px;
  padding: 4px 8px;
}

.doc-card .doc-card-status.accepted {
  background: #00b855;
}

.doc-card .doc-card-status.rejected {
  background: #d71f26;
}

.doc-card .doc-card-status.pending {
  background: #ff8a00;
}

.doc-card .doc-card-status.processing {
  background: blue;
}

.NFT-image-holder {
  text-align: center;
  /* padding: 30px; */
  background: #f5f5f5;
  border-radius: 10px;
}

.NFT-image-holder img {
  width: 100%;
}

.doc-card-wrap {
  height: 100%;
}

.profile-nft-row1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 380px;
}

.email-verification-img {
  width: 180px;
  height: 130px;
}

.signature-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.signature-active {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  overflow: hidden;
  border-radius: 6px;
  border: 2px solid #e11f1c;
}

.signature-option img {
  width: 150px;
  margin-top: -32px;
  /* margin-left: 50px; */
}

.signature-option {
  overflow: hidden;
  width: 150px;
  margin-top: -32px;
  /* margin-left: 50px; */
}

.signature-sec {
  padding-inline: 20px;
}

.signature-sec .top .top-1 {
  display: flex;
  gap: 15px;
}

.signature-sec .bottom div:nth-child(1) {
  flex-direction: column;
}

.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(1) {
  margin: 10px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(2) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(3) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(4) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(5) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(1) {
  margin: 10px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(2) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(3) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(4) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(5) {
  margin: 3px 0px 3px 0px;
  width: 183px;
  overflow: hidden;
}

.signature-sec .bottom div:nth-child(1) button {
  display: inline-block;
  padding: 5px 10px;
  background: #e11f1c;
  border-radius: 6px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: white;
  text-transform: capitalize;
  text-align: center;
  transition: all 0.5s;
  width: fit-content;
  border: none;
  margin-top: 10px;
}

.signature-sec .top .top-1 {
  display: flex;
  gap: 15px;
}

.signature-sec .top .top-1 label input {
  margin-right: 5px;
}

.signature-sec .top .top-1 label {
  font-size: 14px;
  font-weight: 600;
}

.top .top-2 button:nth-child(2) {
  display: inline-block;
  padding: 5px 10px;
  background: #e11f1c;
  border-radius: 6px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: white;
  text-transform: capitalize;
  text-align: center;
  transition: all 0.5s;
  width: fit-content;
  border: none;
  margin-right: 10px;
}

.top .top-2 button:nth-child(3) {
  display: inline-block;
  padding: 5px 10px;
  background: #e11f1c;
  border-radius: 6px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: white;
  text-transform: capitalize;
  text-align: center;
  transition: all 0.5s;
  width: fit-content;
  border: none;
}

.top .top-2 #convas {
  border: 1px solid #dee2e6 !important;
  touch-action: none !important;
  width: 100% !important;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  box-shadow: rgb(244 0 0 / 25%) 0px 2px 5px -1px,
    rgb(255 0 0 / 30%) 0px 1px 3px -1px;
}

.top .top-3 {
}

.top .top-3 input {
  padding: 5px 10px;
  width: 100%;
  margin: 10px 0px;
  border-radius: 6px;
  border: 1px solid #525659;
}

.top .top-3 button {
  display: inline-block;
  padding: 5px 10px;
  background: #e11f1c;
  border-radius: 6px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: white;
  text-transform: capitalize;
  text-align: center;
  transition: all 0.5s;
  width: fit-content;
  border: none;
}

.pdf-container {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
  height: 480px;
  border: 2px solid grey;
}

/* new landing */

.main-container-new {
  /* height: 100vh; */
  position: relative;
  padding-bottom: 101px;
}

.main-container-new .bg-video {
  position: absolute;
  filter: brightness(1.6);
  width: 100% !important;
  /* height: 100%; */
  top: 0;
  z-index: 0;
}

.main-container-new .bg-overlay {
  position: absolute;
  filter: brightness(0.5);
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1;
}

.main-container-new .content {
  position: relative;
  z-index: 2;
}

.main-container-new .content h1 {
  font-family: "Poppins";
  font-size: 52px;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  width: 100%;
  margin-inline: auto;
  padding-top: 195px;
  max-width: 70%;
}

.main-container-new .content h1 span {
  color: rgba(225, 31, 28, 1);
}

.main-container-new .content p {
  font-family: "Poppins";
  font-size: 30px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  margin: 15px 0px 63px 0px;
  width: 100%;
  margin-inline: auto;
}

.main-container-new .content .button {
  text-align: center;
}

.main-container-new .content .button button {
  width: 171px;
  height: 49px;
  border-radius: 30px;
  background-color: rgba(225, 31, 28, 1);
  font-family: "Poppins";
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(225, 31, 28, 1);
}

.invester-new {
  max-width: 1140px;
  margin-inline: auto;
  background-color: #000;
  border-radius: 30px;
  margin-top: 180px;
  /* margin-bottom: 71px; */
}

.invester-new .person-item-wrapper {
  border: none !important;
  margin-inline: 10px;
  padding: 16px 22px;
}

.invester-new .person-item {
  display: flex;
  padding: 0;
  border: none !important;
  gap: 13px;
  align-items: center;
}

.invester-new .person-item .rounded-square-img {
}

.invester-new .person-item .rounded-square-img img {
  width: 48px;
  height: 48px;
  border-radius: 25px;
}

.invester-new .person-item .person-item-desc {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
  margin: 0;
}

.invester-new .person-item .person-item-days span:nth-child(2) {
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: right;
}

.invester-new .person-item .person-item-days {
  width: 100%;
  margin: 0;
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.invester-new .slick-prev {
  /* font-size: 0; */
  line-height: 5;
  position: absolute;
  top: 50%;
  display: block;
  width: auto;
  height: auto;
  padding: 0;
  transform: translate(13px, -53.5%);
  cursor: pointer;
  /* color: #424242; */
  border: none;
  outline: none;
  background: #e32626;
  border-radius: 25px;
  font-size: 24px;
  color: #fff;
  opacity: 0.5;
}

.invester-new .slick-next {
  /* font-size: 0; */
  line-height: 5;
  position: absolute;
  top: 50%;
  display: block;
  width: auto;
  height: auto;
  padding: 0;
  transform: translate(-13px, -53.5%);
  cursor: pointer;
  /* color: #424242; */
  border: none;
  outline: none;
  background: #e32626;
  border-radius: 25px;
  font-size: 24px;
  color: #fff;
  opacity: 0.5;
}

.invester-new .slick-prev:hover,
.invester-new .slick-prev:focus,
.invester-new .slick-next:hover,
.invester-new .slick-next:focus {
  opacity: 1;
  background: #e32626;
  color: #fff;
}

.invester-new .slick-prev:before,
.invester-new .slick-next:before {
  font-family: "slick";
  font-size: 22px;
  line-height: 1.1;
  /* opacity: .75; */
  color: white;
  margin-right: 7px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  opacity: 1;
}

.sec-two {
  border-radius: 30px;
  margin-top: -30px;
  background: #fff;
  position: relative;
}

.sec-two .text-start {
  width: 100%;
  margin-inline: auto;
  font-weight: 700;
  line-height: 60px;
  font-size: 32px;
  margin-bottom: 20px !important;
  text-align: center !important;
}

.sec-two .text-start p {
  text-align: center;
}

.sec-two .normal-p {
  width: 100%;
  margin-inline: auto;
  margin-bottom: 30px;
  font-weight: 500;
  color: #2b2b2b;
  text-align: start;
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

.sec-two .two {
  width: 50%;
  margin-inline: auto;
}

.sec-two .lp-phone-img-wrapper {
  margin-inline: auto;
}

.sec-three {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0px;
}

.sec-three h2 {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
  color: #fff;
  margin-bottom: 20px;
  line-height: 45px;
}

.sec-three h2 span {
  color: rgba(225, 31, 28, 1);
}

.sec-three p {
  font-family: "Poppins";
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
  color: #fff;
  margin-bottom: 30px;
}

.sec-three .button {
  text-align: left;
}

.sec-three .button button {
  /* width: 143px; */
  height: 41px;
  border-radius: 30px;
  background-color: rgba(225, 31, 28, 1);
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(225, 31, 28, 1);
  padding-inline: 20px;
}

.sec-three .video {
  position: relative;
}

.sec-three .video video {
  width: 80%;
  border-radius: 20px;
}

.sec-three .background {
  position: absolute;
  width: 80%;
  height: 100%;
  background-color: rgba(29, 29, 29, 0.521);
  top: 0;

  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sec-three .background img {
  width: 102px;
  height: 113px;
}

.sec-four {
  padding-bottom: 71px;
  padding-top: 0px;
}

.sec-four .sec10-container {
  display: flex;
  justify-content: center;
  /* max-width: 890px; */
  /* width: 80%; */
  margin-bottom: 36px;
}

.sec-four .sec10-container .sec10-list {
  border: 3px solid black;
  border-radius: 16px;
  padding: 0px;
  width: 100%;
}

.sec-four .sec10-container .sec10-list .sec10-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  color: #2b2b2b !important;
  border-radius: 10px;
  margin: 0px;
  width: 100%;
  /* border-bottom: 1px solid #000;
  border-top: 1px solid #000; */
}

.sec-four .sec10-container .sec10-list .sec10-title-b {
  border-bottom: 3px solid black;
}

.sec-four .sec10-container .sec10-list .sec10-title h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 0px;
}

.sec-four .sec10-container .sec10-list .sec10-title .sec10-icon {
  cursor: pointer;
  font-size: 20px;
  color: red;
  min-width: 20px;
}

.sec-four .sec10-container .sec10-list .sec10-para {
  padding: 10px;
  color: #2b2b2b !important;
}

.sec-four h2 {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: center;
  width: 67%;
  color: #000;
  margin-bottom: 20px;
  margin-inline: auto;
  margin-bottom: 40px;
}

.sec-four p {
}

.sec-five .layout-text-profit {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: start;
  margin: 0;
  color: #000;
}

.sec-five .layout-text-profit img {
  width: 169px;
}

.sec-five .layout-text-profit h3 {
  color: #2b2b2b;
  font-family: "Poppins";
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  width: 52%;
  margin-top: 15px;
  margin-bottom: 10px;
}

.sec-five .layout-text-profit h3 span {
  color: #e11f1c;
}

.sec-five .layout-text-profit p {
  color: #2b2b2b;
  text-align: center;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 32px !important;
}

.sec-five .layout-text-profit button {
  /* width: 143px; */
  height: 41px;
  border-radius: 30px;
  background-color: rgba(225, 31, 28, 1);
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(225, 31, 28, 1);
  padding-inline: 20px;
}

.sec-five .card-11 {
  padding: 67px 31px 67px 62px;
  box-sizing: border-box;
  /* border-radius: 20px; */
  /* background: linear-gradient(213deg, #e11f1c 0.96%, #660e0c 98.4%); */
  /* box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.6); */
  overflow: hidden;
  color: #fff;
}

.sec-five .card-22 {
  box-sizing: border-box;
  /* border-radius: 20px; */
  /* background: #f4f4f4; */
  overflow: hidden;
  color: #fff;
  padding: 67px 62px 67px 31px;
}

.sec-five .currency {
  color: #fff;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px;
}

.sec-five .money {
  color: #fff;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 21px;
}

.sec-five .layout_currency-text {
  font-size: 19px;
  margin-top: 0px;
  background-color: #a10707;
  /* padding: 6px 16px;
  width: 78px;
  height: 37px; */
  border-radius: 10px;
}

.sec-five .justify-content-between {
  align-items: center;
}

.sec-five .css-eg0mwd-MuiSlider-thumb {
  color: #fff;
}

.sec-five .css-eg0mwd-MuiSlider-thumb:hover {
  box-shadow: none;
}

.sec-five .css-14pt78w-MuiSlider-rail {
  /* color: #8c1414; */
  color: #fff;
  opacity: 1;
}
.close-icon-sec7 {
  position: absolute;
  top: 0px;
  right: 150px;
  font-size: 25px;
  color: #e11f1c;
  cursor: pointer;
}
.sec-five .range {
  color: #fff;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  opacity: 0.7;
}

.sec-five .custome-slider-widget {
  /* margin-left: 15px; */
  width: 96%;
  margin-inline: 10px;
}

.sec-five .css-187mznn-MuiSlider-root {
  padding: 8px 0px;
}

.sec-five .selected-range {
  color: #fff;
  text-align: center;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: #252525;
  border-radius: 10px;
  padding: 15px;
  width: 96%;
  margin-inline: auto;
  margin-top: 23px;
  margin-bottom: 27px;
  position: relative;
  z-index: 1;
}

.sec-five .years {
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0px;
}

.sec-five .select-option-profit {
  background-color: #252525;
  border-radius: 10px;
  cursor: pointer;
  padding: 15px 25px;
}

.sec-five .button {
  text-align: center;
}

.sec-five .button .calculate {
  border-radius: 30px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 136px;
  height: 37px;
  color: #e11f1c;
  text-align: center;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
}

.sec-five .result h6 {
  color: #fff;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 0;
  margin: 0px;
}

.sec-five .result h3 {
  color: #fff;
  font-family: "Poppins";
  font-size: 35px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  padding: 0;
}

.sec-five .result h5 {
  color: #fff;
  text-align: right;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sec-five .result .boder-bottom {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.sec-five .css-1gv0vcd-MuiSlider-track {
  color: #fff !important;
}

.sec-five {
  padding: 63px 0px;
}

.sec-six {
  display: flex;
}

.sec-six .left {
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sec-six .left .new-para {
  position: absolute;
  /* top: 10px; */
  color: #000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-weight: bold;
  font-family: "open-sans", sans-serif;
  letter-spacing: 1.2px;
}

.sec-six .left .new-para span:nth-child(1) {
  background-color: #fff;
  border-radius: 6px;
  padding: 4px 12px;
}

.sec-six .left .new-para span:nth-child(2) {
  background-color: #fff;
  border-radius: 0 0 6px 6px;
  padding: 4px 12px;
}

.sec-six .left img {
  height: 100vh;
  width: 100%;
}

.sec-six .right {
  flex: 1 1;
  background: rgba(35, 35, 35, 1);
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  padding-left: 90px;
}

.sec-six h3 {
  color: #fff;
  font-family: "Poppins";
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  width: 80%;
  margin: 0;
}

.sec-six h3 span {
  color: rgba(225, 31, 28, 1);
}

.sec-six p {
  color: #fff;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
  margin: 0px;
  width: 80%;
  margin-top: 22px;
  margin-bottom: 28px;
}

.sec-six button {
  /* width: 143px; */
  height: 41px;
  border-radius: 30px;
  background-color: rgba(225, 31, 28, 1);
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(225, 31, 28, 1);
  padding-inline: 20px;
}

.sec-seven {
  padding: 81px 0px;
}

.sec-seven .title {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: center;
  width: 70%;
  color: #000;
  margin-bottom: 20px;
  margin-inline: auto;
  margin-bottom: 20px;
}

.sec-seven .title span {
  color: rgba(225, 31, 28, 1);
}

.sec-seven .desc {
  color: #000;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
  width: 100%;
  margin-bottom: 28px;
  margin-inline: auto;
  text-align: center;
}

.sec-seven .card-wrap {
  background: #fff;
  height: 100%;
  padding: 28px 39px;
  position: relative;
}

.sec-seven .card-wrap:hover {
  box-shadow: 15px 15px 25px 0px rgba(0, 0, 0, 0.15);
}

.sec-seven .card-wrap h4 {
  font-family: "Poppins";
  font-size: 22px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(86, 86, 86, 1);
  margin-top: 22px;
  margin-bottom: 6px;
}

.sec-seven .card-wrap p {
  font-family: "Raleway";
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(115, 115, 115, 1);
}

.sec-seven .card-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  /* Initially, the border width is 0% */
  height: 2px;
  /* Adjust the height as needed */
  background-color: #e11f1c;
  /* Adjust the border color */
  opacity: 0;
  /* Initially, the opacity is 0 */
}

.card-wrap:hover .card-border {
  transition: opacity 0.3s;
  /* Opacity transition for smoother fade-in on hover */
  animation: borderAnimation 0.3s forwards;
  /* Apply the keyframe animation */
}

@keyframes borderAnimation {
  0% {
    width: 0%;
    opacity: 0;
  }

  100% {
    width: 100%;
    opacity: 1;
  }
}

.sec-eight {
}

.sec-eight .sec-eight-wrap {
}

.sec-eight .sec-eight-wrap .inner {
  display: flex;
}

.sec-eight .sec-eight-wrap .inner .left {
  width: 30%;
  background: #232323;
  padding-bottom: 60px;
}

.sec-eight .sec-eight-wrap .inner .left .parent-p {
  padding-left: 76px;
}

.sec-eight .sec-eight-wrap .inner .left .parent .parent-p {
  color: #e11f1c;
  font-family: "Poppins";
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 10px 0px 10px 50px;
  /* border-bottom: 2px solid #fff; */
  border-top: 2px solid #393939;
}

.sec-eight .sec-eight-wrap .inner .left ul li {
}

.sec-eight .sec-eight-wrap .inner .right {
  width: 70%;
}

.sec-eight .sec-eight-wrap .inner .left .open-header li {
  color: #c7c7c7;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 5px;
}

.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu {
  margin: 0;
}

.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu li {
  padding-left: 80px;
}

.sec-eight .sec-eight-wrap .inner .left .open-header li.active {
  border-bottom: none;
  box-shadow: none;
  color: var(--primary);
}

.sec-eight
  .sec-eight-wrap
  .inner
  .left
  .open-header
  ul:not(.open-header-sub-menu)
  > li {
  box-shadow: none;
  margin: 0;
}

.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu {
  box-shadow: none;
}

.sec-eight .sec-eight-wrap .inner .left .parent li:nth-child(1) {
  border: none;
}

.sec-eight .right {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 22px 99px 22px 38px;
}

.sec-eight .right .p-c-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.sec-eight .right .p-c-wrapper .leftt {
  /* width: 100%; */
}

.sec-eight .right .p-c-wrapper .leftt img {
  width: 247px;
}

.sec-eight .right .p-c-wrapper {
}

.sec-eight .right .p-c-wrapper {
}

.sec-eight .right .p-c-wrapper .rightt {
}

.sec-eight .right .p-c-wrapper .rightt {
  color: #fff;
  font-family: "Poppins";
  padding: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
}

.sec-eight .sec10-container {
  display: flex;
  justify-content: center;
  /* max-width: 890px; */
  /* width: 80%; */
  margin-bottom: 28px;
}

.sec-eight .sec10-container .sec10-list {
  border: 3px solid rgba(87, 87, 87, 0.5);
  border-radius: 20px;
  padding: 0px;
  width: 100%;
}

.sec-eight .sec10-container .sec10-list .sec10-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  color: #2b2b2b !important;
  border-radius: 10px;
  margin: 0px;
  width: 100%;
  /* border-bottom: 1px solid #000;
  border-top: 1px solid #000; */
}

.sec-eight .sec10-container .sec10-list .sec10-title-b {
  border-bottom: 3px solid rgba(87, 87, 87, 0.5);
}

.sec-eight .sec10-container .sec10-list .sec10-title h3 {
  color: #bababa;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}

.sec-eight .sec10-container .sec10-list .sec10-title .sec10-icon {
  cursor: pointer;
  font-size: 20px;
  color: #575757;
}

.sec-eight .sec10-container .sec10-list .sec10-para {
  padding: 10px;
  color: #2b2b2b !important;
}

.sec-eight .sec10-container .sec10-list .sec10-para p {
  color: #bababa;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sec-eight .right .pitch-cardd {
  margin-bottom: 15px;
  position: relative;
}

.sec-eight .right .accrodian {
  position: relative;
}

.sec-eight .right .bg-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
}

.sec-nine {
  padding-top: 81px;
  overflow: hidden;
}

.sec-nine .title {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin: 0;
}

.sec-nine .title span {
  color: rgba(225, 31, 28, 1);
}

.sec-nine .desc {
  color: #000;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
  width: 47%;
  margin-bottom: 28px;
  margin-inline: auto;
  text-align: center;
}

.sec-nine .investor-card {
  display: flex;
  padding: 0px;
}

.sec-nine .investor-card .investor-card-img {
  width: auto;
  margin: auto;
  border-radius: 0%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: unset;
}

.sec-nine .investor-card .investor-card-img-inner {
  border-radius: 0%;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.sec-nine .investor-card .investor-card-img img {
  width: 415px;
  border-radius: 0%;
  filter: none;
  transition: all 0.3s ease;
  height: 333px;
}

.sec-nine .investor-card-body {
  padding: 0px 136px 0px 56px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}

.sec-nine .investor-card-body .bt1 {
  margin-bottom: 10px;
}

.sec-nine .investor-card-body .bt2 {
  margin-left: auto;
  margin-top: 5px;
}

.sec-nine .investor-card-body .investor-title {
  font-family: "Poppins";
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
  color: #2b2b2b;
  margin-bottom: 9px;
}

.sec-nine .investor-card-body .investor-desc {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
  color: #797979;
}

.sec-nine .slick-prev {
  left: 20px;
  color: rgba(225, 31, 28, 0.5);
  width: 100px;
  height: 100px;
  z-index: 20;
}

.sec-nine .slick-prev:hover {
  color: rgba(225, 31, 28, 1);
}

.sec-nine .slick-next {
  right: 20px;
  color: rgba(225, 31, 28, 0.5);
  width: 100px;
  height: 100px;
  z-index: 20;
}

.sec-nine .slick-next:hover {
  color: rgba(225, 31, 28, 1);
}

.sec-nine {
}

.sec-ten {
  padding-top: 91px;
  padding-inline: 62px;
}

.sec-ten .title {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin: 0;
}

.sec-ten .title span {
  color: rgba(225, 31, 28, 1);
}

.sec-ten .blog-card {
  border-radius: 20px;
  background-color: #fafafa;
  height: 100%;
  box-shadow: none;
}

.sec-ten .blog-card:hover {
  background: #fafafa;
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.2);
}

.sec-ten .blog-card-body-wrapper {
  position: static;
  background: transparent;
}

.sec-ten .blog-card-wrapper {
  padding: 30px 16px 30px 16px;
}

.sec-ten .blog-card-title {
  color: #2b2b2b;
  font-family: "Poppins";
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0px;
}

.sec-ten .card-desc {
  color: #797979;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  /* 122.222% */
  margin-bottom: 10px;
}

.sec-ten .card-person {
  color: #2b2b2b;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 122.222% */
}

.sec-ten .card-time {
  color: #2b2b2b;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
}

.sec-ten .blog-card-footer {
  align-items: center;
  justify-content: space-between;
}

.sec-ten .blog-card-footer .right {
}

.sec-ten .blog-card-footer .left {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sec-eleven {
  padding-top: 40px;
  padding-bottom: 80px;
}

.sec-eleven .title span {
  color: rgba(225, 31, 28, 1);
}

.sec-eleven .title {
  color: #343434;
  font-family: "Poppins";
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: center;
}

.sec-eleven .desc {
  color: #343434;
  text-align: left;
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  font-weight: bold;
  /* width: 85%; */
}

.sec-eleven .desc span {
  color: #e53e51;
}

.sec-eleven form {
  padding: 40px 32px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 7px 7px 15px 0px rgba(0, 0, 0, 0.25);
}

.sec-eleven form h3 {
  color: #a7a6a6;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sec-eleven form input {
  border-radius: 5px;
  background: #f3f3f3;
  height: 55px;
  width: 100%;
  border: none;
  color: #3e3e3e;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 24px;
  padding: 0px 18px;
}

.sec-eleven form textarea {
  border-radius: 5px;
  background: #f3f3f3;
  color: #3e3e3e;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 100%;
  border: none;
  padding: 18px;
}

.sec-eleven form .type {
  display: flex;
  gap: 5px;
}

.sec-eleven form .type .left {
  flex: 1 1;
  display: flex;
  height: 55px;
  align-items: center;
  background: #f3f3f3;
  padding: 0px 10px;
  border-radius: 5px;
  justify-content: space-between;
  cursor: pointer;
}

.sec-eleven form .type .right {
  flex: 1 1;
  display: flex;
  height: 55px;
  align-items: center;
  background: #f3f3f3;
  padding: 0px 10px;
  border-radius: 5px;
  justify-content: space-between;
  cursor: pointer;
}

.sec-eleven form .type .right p {
  color: #3e3e3e;
  text-align: right;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sec-eleven form .type .left p {
  color: #3e3e3e;
  text-align: right;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sec-eleven form .type .left svg {
  color: #d9d9d9;
  font-size: 12px;
}

.sec-eleven form .type .right svg {
  color: #d9d9d9;
  font-size: 12px;
}

.sec-eleven form button {
  border-radius: 15px;
  background: #e11f1c;
  width: 171px;
  height: 57px;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  margin-top: 31px;
}

.sec-eleven form input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #acacac;
  opacity: 1;
  /* Firefox */
}

.sec-eleven form textarea::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #acacac;
  opacity: 1;
  /* Firefox */
}

.sec-eleven form textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #acacac;
}

.sec-eleven form textarea::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #acacac;
}

.sec-eleven form .type .right.active {
  background: #e11f1c;
  box-shadow: 4px 4px 7px 0px rgba(0, 0, 0, 0.5);
}

.sec-eleven form .type .left.active {
  background: #e11f1c;
  box-shadow: 4px 4px 7px 0px rgba(0, 0, 0, 0.5);
}

.sec-eleven form .type .right.active p {
  color: #fff;
}

.sec-eleven form .type .left.active p {
  color: #fff;
}

.sec-eleven form .type .left.active svg {
  color: #fff;
  font-size: 12px;
}

.sec-eleven form .type .right.active svg {
  color: #fff;
  font-size: 12px;
}

.form-form {
  display: inline-block;
  padding: 10px 12px;
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  background: rgba(225, 31, 28, 1);
  border-radius: 15px 0px 0px 15px;
  position: fixed;
  z-index: 9999;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}

.css-1t2bqnt {
  color: #fff !important;
}

.cta {
  padding: 15px 25px;
  border-radius: 5px;
  border: 1px solid white;
  background-color: #fff !important;
  color: #252525;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  width: 100%;
}

.bg-video-landing {
  width: 100%;
}

.notification-card {
  position: absolute;
  border-radius: 10px;
  top: 60px;
  right: 386px;
  z-index: 999999;
  background-color: white;
  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.541);
  height: 330px;
  overflow: hidden;
  width: 300px;
}

.notification-card-main {
  position: absolute;
  border-radius: 10px;
  top: 68px;
  right: 100px;
  z-index: 999999;
  background-color: white;
  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.541);
  height: 330px;
  overflow: hidden;
  width: 300px;
}

.Notification-in-header {
  padding: 5px 10px;
  display: flex;
  font-family: "Jost";
  color: #121212;
  background: #fff;
}

.Notification-in-header.is_seen {
  background: rgba(112, 181, 249, 0.2);
}

.Notification-in-header:hover {
  background: linear-gradient(90deg, #e11f1c 100%, #b600d1 100.01%);
  color: white !important;
  cursor: pointer;
}

.Notification-in-header .image-holder {
  width: 40px;
  align-items: center;
  display: flex;
}

.Notification-in-header .image-holder img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.Notification-in-header .text-area {
  margin-left: 10px;
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: center;
}

.Notification-in-header .text-area .name-txt span {
  font-size: 16px;
  font-weight: 600;
  margin-right: 5px;
  text-transform: capitalize;
}

.Notification-in-header .text-area .name-txt {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  width: 200px;
}

.Notification-in-header .text-area .msg-txt {
  font-size: 14px;
  font-weight: 500;
  width: 150px;
}

.header-empty-record {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-empty-record span {
  font-weight: 600;
  font-size: 22px;
  font-family: "Jost";
  color: #b600d1;
}

.not-top-icon {
  position: absolute;
  top: 22px;
  right: 500px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  border-radius: 50%;
  background: #e11f1c;
  text-align: center;
  font-size: 10px;
  color: #ffff;
}

.not-top-main-icon {
  position: relative;
  top: -11px;
  /* right: 90px; */
  left: 40px;
  width: 100%;
  line-height: 16px;
  border-radius: 50%;
  background: #e11f1c;
  text-align: center;
  font-size: 11px;
  color: #ffff;
  padding: 0px 4px;
  margin-right: -34px;
  margin-top: 27px;
}

.not-button {
  display: flex;
  justify-content: end;
  align-items: end;
  width: 100%;
}

.notification-history-card {
  border: 1px solid #ddd;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.notification-history-card h4 {
  font-size: 20px;
  margin: 0;
  color: #333;
  width: 100%;
  word-break: break-all;
}

.notification-history-card p {
  font-size: 16px;
  color: #666;
  width: 100%;
  word-break: break-all;
}

.image-holder-detail-notification img {
  width: 280px;
  height: 40px;
  object-fit: contain;
}

/* referral */

.referral-area .invite-friends h4 {
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  text-transform: capitalize;
}

.setting-bg {
  background-color: var(--card-background-color);
  padding: 20px;
}

.referral-area .invite-friends .input-group {
  position: relative;
  width: 100%;
  font-size: large;
}

.invite-friends .input-group .copy-url-btn {
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary);
  font-size: 20px;
  z-index: 9;
  width: 30px !important;
}

.invite-friends .input-group .form-control {
  width: 100%;
  height: 70px;
  border-radius: 5px;
  /* border: 1px solid black; */
  color: black;
  background-color: #ebebeb;
}

/* referral-area */
.referral-area table.dataTable thead tr th {
  background: var(--black);
  border-bottom: 1px solid var(--black);
}

.referral-area table.dataTable tbody tr td {
  background: black;
}

.rewards-inviter {
  display: flex;
  justify-content: space-between;
}

.rewards-inviter .single-item {
  margin-bottom: 30px;
}

.rewards-inviter .single-item h4 {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
  color: var(--black);
}

.rewards-inviter .single-item h2 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: var(--black);
  display: flex;
  justify-content: center;
}

.checkout-field-referral-box {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #ebebeb;
  border-radius: 7px;
  flex-wrap: wrap;
  overflow: scroll;
  gap: 25px;
  margin: 20px;
  justify-content: space-between !important;
}

.checkout-field-referral-box > span {
  color: #565656;
  font-weight: 500;
  font-size: 16px;
  word-break: break-all;
}

header {
  background-color: #fff;
  padding-top: 15px;
}

header .header-wrap {
  display: flex;
  padding-inline: 120px;
  justify-content: space-between;
  align-items: center;
}

header .header-wrap .left {
}

header .header-wrap .left img {
  width: 120px;
}

header .header-wrap .center {
}

header .header-wrap .center ul {
  display: flex;
  box-shadow: 0px 33px 30px 0px #00000026;
  background-color: #fff;
  margin: 0;
  padding: 0 35px;
  border-radius: 36px;
  gap: 35px;
}

header .header-wrap .center ul li {
  display: flex;
  /* box-shadow: 0px 33px 30px 0px #00000026; */
  background-color: #fff;
  margin: 0;
  padding: 16px 0px;
  border-radius: 36px;
}
header .header-wrap .center ul a.active {
  border-bottom: 1px solid #e11f1c;
  border-radius: 0;
  color: #e11f1c;
}

/* .header-wrap .center ul li:hover{
  color: #e11f1c;
}
.header-wrap .center ul li:hover:after {
  content: '';
  display: block;
  border-bottom: 2px solid #E11F1C; 
  margin-top: 2px; 

} */
header .header-wrap .center ul li a {
}

header .header-wrap .right {
  display: flex;
  align-items: center;
  gap: 8px;
}

header .header-wrap .right {
}

header .header-wrap .right .switch-lang {
}

header .header-wrap .right .login-btn {
}

header .header-wrap .right .login-btn button {
  padding: 15px 35px 15px 35px;
  border-radius: 5px;
  background-color: #e11f1c;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.83px;
  text-align: left;
  border: none;
  outline: none;
  color: #fff;
  border: none;
  outline: none;
}

header .header-wrap .right .switch-lang .notifivation {
}

.home-sec-1 {
  padding: 200px 0px;
  position: relative;
  /* background-image: url(/src/assets/images/banner-img-sec1.jpg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: initial;
  margin-top: 55px !important;
}

.home-sec-1 .bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;
}

.home-sec-1 .home-sec-1-left {
}

.home-sec-1 .home-sec-1-left h1 {
  font-size: 52px;
  font-weight: 400;
  line-height: 72.63px;
  text-align: left;
  margin-bottom: 20px !important;
  color: #fff;
}

.home-sec-1 .home-sec-1-left h1 span {
  font-weight: 800;
  color: #e11f1c;
}

.home-sec-1 .home-sec-1-left p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 25px !important;
  color: #fff;
}

.home-sec-1 .home-sec-1-left .button {
  display: flex;
  align-items: center;
  gap: 20px;
}

.home-sec-1 .home-sec-1-left .button button:nth-child(1) {
  padding: 15px 25px;
  color: #fff;
  background-color: #252525;
  border-radius: 5px;
  border: none;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.83px;
  text-align: left;
}

.home-sec-1 .home-sec-1-left .button button:nth-child(2) {
  padding: 15px 25px;
  color: #252525;
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid #e11f1c;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.83px;
  text-align: left;
}

.home-sec-1 .home-sec-1-right {
}

.home-sec-two {
  padding-inline: 139px;
  margin-top: -150px;
}

.home-sec-two .home-sec-twe-wrap {
  padding-bottom: 40px;
}

.home-sec-two .home-sec-twe-wrap .person-item-wrapper {
}

.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item {
  display: flex;
  gap: 17px;
}

.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item .left {
}

.home-sec-two
  .home-sec-twe-wrap
  .person-item-wrapper
  .person-item
  .left
  .rounded-square-img {
}

.home-sec-two
  .home-sec-twe-wrap
  .person-item-wrapper
  .person-item
  .left
  .rounded-square-img
  img {
  width: 76px;
  height: 76px;
  border-radius: 100%;
}

.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item .right {
}

.slick-slider .slick-list {
}

.slick-slider .slick-list .slick-track {
}

.slick-slider .slick-list .slick-track div.slick-slide:nth-child(1) {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background-color: #fff;
  padding: 21px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper {
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper {
  background: #fff;
  border: 2px solid #fff;
  border-radius: 16px;
  padding: 23px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  margin: 10px;
  position: relative;
  top: 40px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper
  .right
  h3 {
  font-size: 24.81px;
  font-weight: 700;
  line-height: 32.31px;
  color: #252525;
  margin-bottom: 5px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper
  .right
  h4 {
  font-size: 12.42px;
  font-weight: 400;
  line-height: 19.23px;
  color: #252525;
  margin-bottom: 3px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper
  .right
  .person-item-desc {
  font-size: 12.42px;
  font-weight: 600;
  line-height: 19.23px;
  text-align: left;
  color: #252525;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1) {
  font-size: 23.29px;
  font-weight: 700;
  line-height: 30.32px;
  color: #e11f1c;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(1)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(3)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(4)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(6)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(7)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(9)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(10)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(12)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(13)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(15)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(16)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(18)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(19)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(21)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(22)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(24)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(25)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(27)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(28)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2) {
  font-size: 12.42px;
  font-weight: 600;
  line-height: 19.23px;
  text-align: left;
  color: #252525;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper {
  background: #252525;
  border: 2px solid #fff;
  border-radius: 16px;
  padding: 23px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  margin: 10px 10px 40px 10px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper
  .right
  h3,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper
  .right
  h3 {
  font-size: 24.81px;
  font-weight: 700;
  line-height: 32.31px;
  color: #fff;
  margin-bottom: 5px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper
  .right
  h4,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper
  .right
  h4 {
  font-size: 12.42px;
  font-weight: 400;
  line-height: 19.23px;
  color: #fff;
  margin-bottom: 3px;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper
  .right
  .person-item-desc,
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper
  .right
  .person-item-desc {
  font-size: 12.42px;
  font-weight: 600;
  line-height: 19.23px;
  text-align: left;
  color: #fff;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(1) {
  font-size: 23.29px;
  font-weight: 700;
  line-height: 30.32px;
  color: #e11f1c;
}

.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(2)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(5)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(8)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(11)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(14)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(17)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(20)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(23)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(26)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(29)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(32)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(35)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(38)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(41)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(44)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(47)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(50)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(53)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(56)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(59)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(62)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(65)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2),
.home-sec-two
  .slick-slider
  .slick-list
  .slick-track
  .slick-slide:nth-child(68)
  div
  .person-item-wrapper
  .right
  .person-item-days
  span:nth-child(2) {
  font-size: 12.42px;
  font-weight: 600;
  line-height: 19.23px;
  text-align: left;
  color: #fff;
}

.home-sec-two .slick-slider .slick-list .slick-track .slick-slide:nth-child(2) {
  background-color: gray;
}

.home-sec-two .slick-prev,
.home-sec-two .slick-next {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 50px;
  height: 50px;
  padding: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  color: #252525;
  border: none;
  outline: none;
  background: transparent;
}

.home-sec-two .slick-prev {
  left: -45px;
}

.home-sec-two .slick-next {
  right: -45px;
}

.home-sec-two .slick-dots {
  position: absolute;
  bottom: -5px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
}

.home-sec-two .slick-dots li {
  background: #d2d2d2;
  margin: 0px !important;
  width: 36px !important;
  height: 5px !important;
}

.home-sec-two .slick-dots li.slick-active {
  background-color: #252525;
  border-radius: 21px;
}

.home-sec-two .slick-dots li button {
  display: none !important;
}

.home-sec-two .slick-dots li button {
}

.home-sec-two .slick-dots li button:before {
}

.home-sec-two .slick-dots li:first-child {
  border-radius: 21px 0px 0px 21px;
}

.home-sec-two .slick-dots li:last-child {
  border-radius: 0px 21px 21px 0px;
}

.home-sec-two .slick-dots {
  bottom: -5px !important;
}

.home-sec-two .slick-prev:hover,
.home-sec-two .slick-prev:focus,
.home-sec-two .slick-next:hover,
.home-sec-two .slick-next:focus {
  color: #252525 !important;
  outline: none;
  background: transparent;
}

.home-sec-three {
  padding: 80px 0px;
}

.home-sec-three .home-sec-three-left {
}

.home-sec-three .home-sec-three-left img {
  width: 100%;
}

.home-sec-three .home-sec-three-right {
}

.home-sec-three .home-sec-three-right h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 10px;
}

.home-sec-three .home-sec-three-right h3 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #252525;
  margin-bottom: 12px;
}

.home-sec-three .home-sec-three-right h3 span {
  color: #e11f1c;
}

.home-sec-three .home-sec-three-right p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
}

.home-sec-three .home-sec-three-right .p1 {
  padding-bottom: 40px !important;
}

.home-sec-three .home-sec-three-right .p2 {
  padding-bottom: 25px !important;
}

.home-sec-three .home-sec-three-right .button {
}

.home-sec-three .home-sec-three-right .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
}
.home-sec-three .button {
  margin-top: 25px;
}
.home-sec-three .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
}

.home-sec-four {
  padding: 80px 0px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.home-sec-four .home-sec-four-right {
}

.home-sec-four .home-sec-four-right img {
  width: 100%;
  border-radius: 8px;
}

.home-sec-four .home-sec-four-left {
}

.home-sec-four .home-sec-four-left h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: left;
  color: #fff;
  margin-bottom: 10px;
}

.home-sec-four .home-sec-four-left h3 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #fff;
  margin-bottom: 12px;
}

.home-sec-four .home-sec-four-left h3 span {
  color: #e11f1c;
}

.home-sec-four .home-sec-four-left p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #fff;
}

.home-sec-four .home-sec-four-left .p1 {
  padding-bottom: 40px !important;
}

.home-sec-four .home-sec-four-left .p2 {
  padding-bottom: 25px !important;
}

.home-sec-four .home-sec-four-left .button {
}

.home-sec-four .home-sec-four-left .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #252525;
  background-color: #fff;
  border: 0px;
}

.home-sec-four .home-sec-four-left .button button svg path {
  fill: #252525;
}

.home-sec-five {
  padding: 80px 0px;
}

.home-sec-five h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: center;
  color: #252525;
  margin-bottom: 10px;
}

.home-sec-five h3 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: center;
  color: #252525;
  margin-bottom: 20px;
  width: 50%;
  margin-inline: auto;
}

.home-sec-five h3 span {
  color: #e11f1c;
}

.home-sec-five .left,
.home-sec-five .right {
  display: flex;
  flex-direction: column;
  gap: 45px;
}

.home-sec-five .left .home-sec-five-left-one {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 31px 17px 13px;
  position: relative;
}

.home-sec-five .right .home-sec-five-right-one {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 13px 17px 31px;
  position: relative;
}

.home-sec-five .left h4 {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: right;
  color: #e11f1c;
  padding-right: 15px;
}

.home-sec-five .right h4 {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: left;
  color: #e11f1c;
  padding-left: 15px;
}

.home-sec-five .left p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.83px;
  text-align: right;
  color: #000;
}

.home-sec-five .right p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.83px;
  text-align: left;
  color: #000;
}

.home-sec-five .left .home-sec-five-left-two {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 31px 17px 13px;
  position: relative;
  margin-right: -30px;
  margin-left: 30px;
}

.home-sec-five .right .home-sec-five-right-two {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 33px 17px 31px;
  position: relative;
  margin-left: -30px;
  margin-right: 30px;
}

.home-sec-five .left .home-sec-five-left-three {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 31px 17px 13px;
  position: relative;
  margin-right: -80px;
  margin-left: 80px;
}

.home-sec-five .right .home-sec-five-right-three {
  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;
  background: #fff;
  padding: 17px 13px 17px 31px;
  position: relative;
  margin-left: -80px;
  margin-right: 80px;
}

.home-sec-five .left .number {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: center;
  color: #fff;
  background-color: #e11f1c;
  position: absolute;
  right: 0;
  top: 0;
  width: 38px;
  height: 35px;
  border-radius: 0px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-sec-five .right .number {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: center;
  color: #fff;
  background-color: #e11f1c;
  position: absolute;
  left: 0;
  top: 0;
  width: 38px;
  height: 35px;
  border-radius: 16px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-sec-five .center {
}

.home-sec-five .home-sec-five-center {
}

.home-sec-five .home-sec-five-center img {
  width: 100%;
}

.home-sec-five .right {
}

.home-sec-six {
  padding: 80px 0px;
}

.home-sec-six .home-sec-six-right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.home-sec-six .home-sec-six-right img {
  width: 100%;
}

.home-sec-six .home-sec-six-left {
}

.home-sec-six .home-sec-six-left h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 10px;
}

.home-sec-six .home-sec-six-left h3 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #252525;
  margin-bottom: 12px;
}

.home-sec-six .home-sec-six-left h3 span {
  color: #e11f1c;
}

.home-sec-six .home-sec-six-left p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
}

.home-sec-six .home-sec-six-left .p1 {
  padding-bottom: 40px !important;
}

.home-sec-six .home-sec-six-left .p2 {
  padding-bottom: 25px !important;
}

.home-sec-six .home-sec-six-left .button {
}

.home-sec-six .home-sec-six-left .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
}

.home-sec-seven {
  padding: 80px 0px;
}

.home-sec-seven h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: center;
  color: #252525;
  margin-bottom: 10px;
}

.home-sec-seven h3 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: center;
  color: #252525;
  margin-bottom: 36px;
  width: 50%;
  margin-inline: auto;
}

.home-sec-seven h3 span {
  color: #e11f1c;
}

.home-sec-seven .video {
  position: relative;
  height: 438px;
}

.home-sec-seven .video .left-img {
  position: absolute;
  left: -130px;
  top: -130px;
  z-index: 10;
}

.home-sec-seven .video .right-img {
  position: absolute;
  right: -77px;
  bottom: -30px;
  z-index: 10;
}

.home-sec-seven .video .background {
  position: absolute;
  top: 0;
  left: 0;
}

.home-sec-seven .video .background img {
  width: 100%;
  border-radius: 8px;
}
.home-sec-seven .video .background svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 78px;
  color: #e11f1c;
  cursor: pointer;
}
.home-sec-seven .video .right-img {
}

.home-sec-eight {
  padding: 80px 0px;
  position: relative;
}
.home-sec-eight .container {
  background: linear-gradient(99.74deg, #e11f1c -7.32%, #7b110f 101.94%);
  border-radius: 20px;
}
.home-sec-eight .home-sec-eight-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 519px;
  height: 188px;
  position: absolute;
  object-fit: contain;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
}
.home-sec-eight .left {
}
.home-sec-eight .left h2 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #fff;
  margin-bottom: 14px;
}

.home-sec-eight .left h6.currency {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: left;
  color: #fff;
}
.home-sec-eight .left p.layout_currency-text {
  padding: 15px 25px;
  background-color: #252525;
}
.home-sec-eight .left .money {
  font-size: 18px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: left;
  color: #fff;
}
.home-sec-eight .left .range {
  font-size: 18px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
  color: #fff;
  opacity: 1;
}
.home-sec-eight .left p {
}
.home-sec-eight {
}

/* MUZAMMIL CSS START */

.home-sec-nine {
  padding: 80px 0px;
}
.home-sec-nine h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 10px;
}
.home-sec-nine .btn-wrapper {
}
.home-sec-nine .btn-wrapper button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
}
.home-sec-nine h1 {
  font-size: 40px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #252525;
  margin-bottom: 12px;
}
.home-sec-nine h1 span {
  color: #e11f1c;
}
.home-sec-nine p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 20px;
}
.home-sec-ten {
  padding: 80px 0;
}
.home-sec-ten h1 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: center;
  color: #252525;
  margin-bottom: 12px;
}
.home-sec-ten h1 span {
  color: #e11f1c;
}
.home-sec-ten p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: center;
  color: #252525;
  margin-bottom: 60px;
  max-width: 767px;
  margin-inline: auto;
}
.home-sec-ten .cardd {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex-direction: column;
  padding: 12px;
  border-radius: 12px;
  gap: 12px;
  min-height: 297px;
}
.home-sec-ten .cardd img {
  width: 55px;
}
.home-sec-ten .cardd h3 {
  font-size: 24.81px;
  font-weight: 700;
  line-height: 32.31px;
  color: #252525;
  margin-bottom: 5px;
  text-align: center;
}
.home-sec-ten .cardd h3 span {
  color: #e11f1c;
}
.home-sec-ten .cardd p {
  font-size: 0.8rem;
  margin-bottom: 5px;
  letter-spacing: 1px;
  color: #404040;
  text-align: center;
  line-height: 20px;
}
.home-sec-ten .button {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.home-sec-ten .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
}

.home-sec-eleven {
  padding: 80px 0;
}
.home-sec-eleven h1 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #252525;
  margin-bottom: 12px;
}
.home-sec-eleven h1 span {
  color: #e11f1c;
}
.home-sec-eleven p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
}
.home-sec-eleven .video {
  position: relative;
}
.home-sec-eleven .video video {
  width: 100%;
  border-radius: 20px;
}
.home-sec-eleven .background {
  position: absolute;
  width: 100%;
  height: 98%;
  /* background-color: rgba(29, 29, 29, 0.521); */
  background-color: #fff;
  top: 0;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-sec-eleven .background img {
  width: 100%;
  /* height: auto; */
  cursor: pointer;
}
.home-sec-twelve {
  position: relative;
  /* padding-bottom: 101px; */
  height: 600px;
  margin: 80px 0px;
}
.home-sec-twelve .bg-video {
  position: absolute;
  filter: brightness(0.8);
  width: 100% !important;
  /* height: 100%; */
  top: 0;
  z-index: 0;
}
.home-sec-twelve .bg-video .bg-video-landing {
  width: 100%;
}
.home-sec-twelve .bg-video .bg-overlay {
  position: absolute;
  width: 100%;
  height: 98%;
  /* background-color: rgba(29, 29, 29, 0.521); */
  top: 0;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-sec-twelve .content {
  position: absolute;
  z-index: 2;
  top: 60px;
  width: 100%;
}
.home-sec-twelve .content h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  /* padding-top: 60px; */
}
.home-sec-twelve .content h1 span {
  color: #e11f1c;
}
.home-sec-twelve .button {
  display: flex;
  justify-content: center;
}
.home-sec-twelve .button button {
  border-radius: 5px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  background-color: #252525;
  border: none;
}
.home-sec-twelve .content-card {
  position: absolute;
  z-index: 2;
  bottom: 20%;
  width: 100%;
}
.home-sec-twelve .content-card h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: left;
  color: #252525;
  margin-bottom: 10px;
  color: #fff;
}
.home-sec-twelve .content-card h1 {
  font-size: 35px;
  font-weight: 800;
  line-height: 45.57px;
  text-align: left;
  color: #e11f1c;
  margin-bottom: 12px;
}
.home-sec-twelve .content-card p {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #fff;
}
.mobile-nav {
  display: none;
}
.hamburger-mobile {
  display: none;
}

.home-sec-twelve .video {
  position: relative;
}
.home-sec-twelve .video video {
  width: 100%;
  border-radius: 12px;
  filter: brightness(0.5);
}
.home-sec-twelve .background {
  position: absolute;
  width: 100%;
  height: 98%;
  /* background-color: rgba(29, 29, 29, 0.521); */
  background-color: #fff;
  top: 0;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-sec-twelve .background img {
  width: 100%;
  /* height: auto; */
  height: 243px;
  object-fit: cover;
  border-radius: 12px;
}
.home-sec-twelve .background svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 78px;
  color: #e11f1c;
  cursor: pointer;
}
/* MUZAMMIL CSS END */

.mobile-nav.active {
  transform: translateX(0%);
}

.data .cardd {
  background: rgba(255, 255, 255, 0.5);
  padding: 20px;
  border-radius: 12px;
  border: 2px solid #fff;
}
.data-0twelve {
  display: none;
}
.home-sec-testimonial {
  padding: 80px 0;
  position: relative;
}
.home-sec-testimonial .home-slider-next {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  cursor: pointer;
}
.home-sec-testimonial .home-slider-prev {
  position: absolute;
  left: 60px;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  cursor: pointer;
}
.home-sec-testimonial {
  padding-inline: 139px;
}
.home-sec-testimonial .slick-prev {
  left: -85px;
}
.home-sec-testimonial .slick-prev {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 50px;
  height: 50px;
  padding: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  color: #252525;
  border: none;
  outline: none;
  background: transparent;
}
.home-sec-testimonial .slick-next {
  right: -85px;
}
.home-sec-testimonial .slick-next {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 50px;
  height: 50px;
  padding: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  color: #252525;
  border: none;
  outline: none;
  background: transparent;
}
.home-sec-testimonial .slick-prev:hover {
  color: #252525 !important;
  outline: none;
  background: transparent;
}
.home-sec-testimonial .slick-next:hover {
  color: #252525 !important;
  outline: none;
  background: transparent;
}
.home-sec-testimonial .testimonial-video {
  width: 100%;
  height: auto;
  border-radius: 12px;
}
.home-sec-testimonial .testimonial-desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: center;
  color: #252525;
  padding: 40px 0;
}
.home-sec-testimonial h1 {
  font-family: "Poppins";
  font-size: 35px;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: center;
  width: 67%;
  color: #000;
  margin-bottom: 20px;
  margin-inline: auto;
  margin-bottom: 40px;
}
.home-sec-testimonial .video {
  position: relative;
}
.home-sec-testimonial .video video {
  width: 100%;
  border-radius: 12px;
}
.home-sec-testimonial .video .background {
  position: absolute;
  width: 100%;
  height: 98%;
  /* background-color: rgba(29, 29, 29, 0.521); */
  background-color: #fff;
  top: 0;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-sec-testimonial .video .background img {
  width: 100%;
  border-radius: 12px;
}
.home-sec-testimonial .video .background svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 78px;
  color: #e11f1c;
  cursor: pointer;
}

.custom-header-new {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-right: 10px;
}
.custom-header-new .left {
}
.custom-header-new .right {
}

.css-i6s8oy {
  display: block !important;
}
.storeSection .content {
  margin-bottom: 40px;
}
.storeSection .content .heading {
  font-family: "Outfit", sans-serif;
  font-size: 81.76px;
  font-weight: 700;
  line-height: 103.01px;
  text-align: left;
  color: #1a1a1a;
  margin: 0;
}
.storeSection .content .sub-heading {
  font-family: "Outfit", sans-serif;
  font-size: 20.44px;
  font-weight: 400;
  line-height: 25.75px;
  text-align: left;
  color: #1a1a1a;
}
.storeSection .content .sub-heading span {
  color: #c96b77;
}
.storeSection .search-con {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  gap: 20px;
}
.storeSection .search-con .left {
  width: 100%;
  border-right: 1px solid #ececec;
  border-width: 4px;
  padding-right: 15px;
}
.storeSection .search-con .left .wrap {
  position: relative;
}
.storeSection .search-con .left input {
  border: none;
  border-radius: 100px;
  width: 100%;
  color: #000;
  font-family: "Outfit", sans-serif;
  font-size: 20.44px;
  font-weight: 400;
  line-height: 25.75px;
  text-align: left;
  padding: 19px 60px;
  background-color: #f8f9fb;
  border: 1px solid #d2d4d7;
}
.storeSection .search-con .left .wrap .search-icon {
  position: absolute;
  left: 3%;
  transform: translate(-50%, -50%);
  top: 50%;
  cursor: pointer;
}
.storeSection .search-con .left input::placeholder {
  color: #d9d9d9;
}
.storeSection .search-con .right {
}

.storeSection .search {
  margin-bottom: 62px;
}
.storeSection .InvestCardCon {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
  margin-bottom: 80px;
}
.storeSection .InvestCardCon .InvestCard {
  border: 1.53px solid #ede6e6;
  border-radius: 12px;
  overflow: hidden;
}
.storeSection .InvestCardCon .InvestCard .top {
  /* height: 200px; */
  height: 250px;
  /* overflow: hidden; */
}
.storeSection .InvestCardCon .InvestCard .top .type-img {
  object-fit: contain;
  border-radius: 12px 12px 0px 0px;
  max-height: 300px;
  width: auto;
  height: 250px;
}

.storeSection .InvestCardCon .InvestCard .top .wrap-video {
  position: relative;
}
.storeSection .InvestCardCon .InvestCard .top video {
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  /* max-height: 300px; */
  /* width: auto; */
  height: 250px;
  position: relative;
  object-fit: cover;
}
.storeSection .InvestCardCon .InvestCard .top .background {
  position: absolute;
  top: 0;
}
.storeSection .InvestCardCon .InvestCard .top .background img:nth-child(1) {
  width: 100%;
  border-radius: 12px;
  height: 250px;
}
.storeSection .InvestCardCon .InvestCard .top .background img:nth-child(2) {
  width: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.storeSection .InvestCardCon .InvestCard .top .wrap-video .playPause {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 60px;
}
.storeSection .InvestCardCon .InvestCard .wrap {
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 38px;
}
.storeSection .InvestCardCon .InvestCard .top .slick-initialized .slick-slide {
  padding: 0px !important;
}
.storeSection .InvestCardCon .InvestCard .bottom {
  padding: 28px;
  margin-top: 20px;
}
.storeSection .InvestCardCon .InvestCard .bottom .box1 {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;
  margin-bottom: 8px;
}
.storeSection .InvestCardCon .InvestCard .bottom .box1 img {
}
.storeSection .InvestCardCon .InvestCard .bottom .box1 h3 {
  font-family: "Outfit", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  text-align: left;
  color: #1a1a1a;
  margin: 0;
}
.storeSection .InvestCardCon .InvestCard .bottom p {
  color: #929094;
  font-family: "Outfit", sans-serif;
  font-size: 18.4px;
  font-weight: 500;
  line-height: 23.18px;
  text-align: left;
  margin-bottom: 25px;
  letter-spacing: 1px;
}

.storeSection .InvestCardCon .InvestCard .bottom .box2 {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  gap: 8px;
  margin-bottom: 29px;
}
.storeSection .InvestCardCon .InvestCard .bottom .box2 img {
}
.storeSection .InvestCardCon .InvestCard .bottom .box2 p {
  font-family: "Outfit", sans-serif;
  font-size: 14.31px;
  font-weight: 500;
  line-height: 18.03px;
  text-align: left;
  color: #929094;
  margin: 0;
}
.storeSection .InvestCardCon .InvestCard .bottom button {
  border: none;
  outline: none;
  width: 100%;
  border-radius: 100px;
  background-color: #e0201c;
  color: #fff;
  padding: 12px 22px;
  position: relative;
  z-index: 10;
}
.storeSection .btn-wrapper-viewMore {
  display: flex;
  justify-content: center;
  align-items: center;
}
.storeSection .btn-wrapper-viewMore button {
  border: none;
  outline: none;
  padding: 6px 22px;
  border-radius: 30px;
  border: 1px solid #e0201c;
  background: none;
  color: #e0201c;
  font-family: "Outfit", sans-serif;
  font-size: 24.75px;
  font-weight: 500;
  line-height: 31.18px;
  text-align: center;
  width: 100%;
  max-width: 280px;
}

/* The slider */
/* .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  background: #fff;
  transition: .4s;
  border-radius: 30px;
  border: 1px solid #ccc;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1.5em;
  width: 1.5em;
  border-radius: 16px;
  left: 6.2px;
  top: 3px;
  bottom: 0;
  background-color: white;
  box-shadow: 0 2px 5px #999999;
  transition: .4s;
} */

/* input:checked+.slider {
  background-color: #5fdd54;
  border: 1px solid transparent;
}

input:checked+.slider:before {
  transform: translateX(1.5em);
} */
.storeSection .InvestCardCon .InvestCard .slider .slick-dots {
  bottom: 20px !important;
}
.storeSection .slick-dots li.slick-active button:before {
  color: #fff !important;
  opacity: 100% !important;
  border: 1px solid #fff;
  border-radius: 100%;
}
.storeSection .slick-dots li button:before {
  color: #fff !important;
  font-size: 14px !important;
  opacity: 70% !important;
}

.storeSectionDetail {
}
.storeSectionDetail .top-heading {
  margin-bottom: 60px;
}
.storeSectionDetail .top-heading h1 {
  font-family: "Outfit", sans-serif;
  font-size: 70px;
  font-weight: 700;
  line-height: 70px;
  color: #1a1a1a;
  margin-bottom: 12px;
  text-align: center;
}
.storeSectionDetail .top-heading p {
  font-family: "Outfit", sans-serif;
  font-size: 20.44px;
  font-weight: 400;
  line-height: 25.75px;
  text-align: center;
  color: #1a1a1a;
}
.storeSectionDetail .top {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-bottom: 50px;
}
.storeSectionDetail .top .left {
  flex: 1.5 1;
}
.storeSectionDetail .top .right {
  flex: 1 1;
}
.storeSectionDetail .top .right .bar {
  background-color: #dfdfdf;
  border-radius: 50px;
  height: 8px;
}
.storeSectionDetail .top .right .bar-wrap {
  background-color: #09bb09;
  border-radius: 50px;
  height: 8px;
}
.storeSectionDetail .top .right .box {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px;
  margin-bottom: 20px;
}
.storeSectionDetail .top .right .progress-barr progress {
}
.storeSectionDetail .progress-barr progress {
  width: 100%;
  height: 12px;
  appearance: none;
}

.storeSectionDetail .progress-barr progress::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 5px;
}

.storeSectionDetail .progress-barr progress::-webkit-progress-value {
  background-color: #e0201c; /* Color of the progress value */
  border-radius: 5px;
}

.storeSectionDetail .progress-barr progress::-moz-progress-bar {
  background-color: #e0201c;
  border-radius: 5px;
}
.storeSectionDetail .top .right .box h1.green {
  color: #e0201c;
  font-family: Outfit, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 35.28px;
  text-align: left;
}
.storeSectionDetail .top .right .box h1 {
  font-family: "Outfit", sans-serif;
  font-size: 35px;
  font-weight: 700;
  line-height: 40px;
  text-align: left;
  margin: 0;
}
.storeSectionDetail .top .right .box p {
  font-family: Outfit, sans-serif;
  font-size: 18.4px;
  font-weight: 500;
  line-height: 23.18px;
  text-align: left;
  color: #929094;
}
.storeSectionDetail .top .right .box button {
  border: none;
  outline: none;
  padding: 2px 22px;
  border-radius: 30px;
  background: #e0201c;
  color: #fff;
  font-family: "Outfit", sans-serif;
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  line-height: 34px;
  width: 100%;
  max-width: 300px;
}
.storeSectionDetail .top .left .slider img {
  border-radius: 12px;
  width: 100% !important;
}

.storeSectionDetail .bottom {
  margin-top: 100px;
}
.storeSectionDetail .bottom .main-heading {
  text-align: center;
  color: #000000;
  font-family: "Outfit", sans-serif;
  font-size: 61.7px;
  font-weight: 700;
  line-height: 77.74px;
  margin-bottom: 100px;
  border-bottom: 1px solid #e0201c;
  width: 152px;
  margin-inline: auto;
  border-width: 5px;
}
.storeSectionDetail .bottom .container {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-bottom: 50px;
}
.storeSectionDetail .bottom .container:last-child {
  margin-bottom: 0;
}
.storeSectionDetail .bottom .container .left {
  flex: 1 1;
}
.storeSectionDetail .bottom .container .left h1 {
  font-family: "Outfit", sans-serif;
  font-size: 54.95px;
  font-weight: 700;
  line-height: 54.95px;
  text-align: left;
  color: #1a1a1a;
  margin-bottom: 40px;
}
.storeSectionDetail .bottom .container .left p {
  font-family: "Outfit", sans-serif;
  font-size: 20.44px;
  font-weight: 400;
  line-height: 25.75px;
  text-align: left;
  color: #1a1a1a;
}
.storeSectionDetail .bottom .container .right {
  flex: 1 1;
}
.storeSectionDetail .bottom .container .right img {
  border-radius: 12px;
  width: 100%;
}
.storeSectionDetail .bottom .btn-wrapper-viewMore {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
}
.storeSectionDetail .bottom .btn-wrapper-viewMore button {
  outline: none;
  padding: 6px 22px;
  border-radius: 30px;
  border: 1px solid #e0201c;
  background: none;
  color: #e0201c;
  font-family: "Outfit", sans-serif;
  font-size: 24.75px;
  font-weight: 500;
  line-height: 31.18px;
  text-align: center;
  width: 100%;
  max-width: 280px;
}
.storeSectionDetail .slick-dots {
  bottom: 20px !important;
}
.storeSectionDetail .slick-dots li button {
}
.storeSectionDetail .slick-dots li.slick-active button:before {
  color: #fff !important;
  opacity: 90%;
  border: 1px solid #fff;
  border-radius: 30px;
}
.storeSectionDetail .slick-dots li button:before {
  color: #fff !important;
  opacity: 70%;
  font-size: 12px !important;
}

.heading-partners {
  margin-top: 70px;
  color: #ff0000;
  font-weight: 700;
  font-size: 24px;
}
.storeSectionDetail .swiper-pagination-bullet-active {
  background-color: #fff;
}
.storeSectionDetail .swiper-slide .type-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  height: 400px;
}
.storeSectionDetail .swiper-slide video {
  width: 100%;
  /* height: 400px; */
  height: auto;
  border-radius: 12px;
  position: relative;
}
.storeSectionDetail .swiper-slide .wrap-video {
  position: relative;
}
.storeSectionDetail .swiper-slide .wrap-video .background {
  position: absolute;
  top: 0;
}
.storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(1) {
  width: 100%;
  border-radius: 12px;
  height: 400px;
}
.storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(2) {
  width: 50px;
}
.storeSectionDetail .swiper-slide .wrap-video .playPause1 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 100%;
}
.storeSectionDetail .swiper-slide .wrap-video .playPause {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 60px;
}
/* .swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;


  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
} */

/* -----------------------offer-modal-body-------------------------- */
.offer-modal {
  height: 90%;
  margin-top: 80px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
}
.offer-modal-sec {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.offer-modal-sec h6 {
  transform: rotate(-5deg);
  margin-top: 10px;
  font-weight: 700;
}
.offer-modal-sec .offer-modal-img img {
  width: 180px;
}

.offer-modal-img {
  position: relative;
}
.offer-modal-img .text {
  position: absolute;
  top: 30px;
  left: 30px;
  align-items: center;
}
.offer-modal-img .text p {
  font-size: 14px;
  color: #fff;
  width: 130px;
  text-align: center;
  transform: rotate(-10deg);
  font-weight: bold;
  line-height: 23px;
}

.offer-modal-img .text p span {
  margin-top: 20px;
  font-size: 15px;
  display: block;
}

.offer-modal-sec .timer-sec {
  padding-top: 30px;
  display: flex;
  gap: 10px;
}

.timer-sec .box {
  width: 60px;
  height: 60px;
  position: relative;
  background-color: #333333;
  border-radius: 5px;
}
.timer-sec .box .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 35px;
}

.timer-sec .box .hr {
  background-color: #ffffff;
  height: 2px;
  margin-top: 30px;
}

.userform-modal {
}
.userform-modal .custom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 12px;
  height: 50px;
}
.userform-modal .custom-header h1 {
  font-family: "poppins", sans-serif;
  font-size: 25px;
  line-height: 33px;
  margin: 0;
}
.userform-modal .custom-header svg {
  cursor: pointer;
}
.userform-modal form .input-wrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}
.userform-modal form .input-wrap.last {
  margin-bottom: 25px;
}
.userform-modal form .input-wrap label {
  font-family: "poppins", sans-serif;
  font-size: 18px;
  color: #222222;
}
.userform-modal form .input-wrap input {
  border: none;
  outline: none;
  width: 100%;
  border: 1px solid #eeeeee;
  padding: 6px 8px;
  border-radius: 6px;
}
.userform-modal form .input-wrap input::placeholder {
  color: #000;
}
.userform-modal .modal-dialog {
  max-width: 500px;
  margin-inline: auto;
}

.userform-modal .btn-wrap {
}
.userform-modal .btn-wrap button {
  border: none;
  outline: none;
  background-color: #e0201c;
  border-radius: 30px;
  font-family: "poppins", sans-serif;
  font-size: 16px;
  color: #222222;
  cursor: pointer;
  color: #fff;
  padding: 8px 20px;
}

/*************************************************************** NEW STYLING ****************************************************/
.custom-header .logo-section p {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  color: rgba(0, 0, 0, 1);
}

.adminContainer {
  box-shadow: 0px 4px 20px 0px #00000026;
  background: #ffffff;
  border-radius: 30px;
  margin-top: 50px !important;
  /* margin: 30px !important; */
}
.adminContainer .wallet-con span {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  text-align: left;
  color: #e0221e;
}

.btn-outline-danger {
  color: #000000;
  padding: 16px 25px !important;
  border-radius: 10px;
  background-color: #000000;
  color: #fff;
  border: none;
  &:hover {
    background: #e0221e;
  }
}
.btn-outline-danger.active_type {
  background-color: #e0221e;
}
.userContainer {
  box-shadow: 0px 4px 20px 0px #00000026;
  background: #ffffff;
  border-radius: 30px;
  padding: 50px;
  padding-bottom: 0px;
  width: 96% !important;
  max-width: none !important;
  position: relative;
}
.mainContainerComp {
  box-shadow: 0px 4px 20px 0px #00000026;
  background: #ffffff;
  border-radius: 30px;
  padding: 50px;
  padding-bottom: 0px;
  width: 96% !important;
  max-width: none !important;
  position: relative;
}
.userContainer .form-label {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  margin-bottom: 16px;
  font-weight: 500;
}
.userContainer .form-control {
  padding: 16px 16px;
  border: 1px solid #d9d9d9;
  position: relative;
  padding-inline-start: 50px;
  color: #666666;
}
.userContainer .form-control::placeholder {
  color: #666666;
}
.userContainer .searchCon {
  background-color: #f5f5f5;
  width: 28px;
  height: 28px;
  border-radius: 28px;

  position: absolute;
  top: 70%;
  left: 22px;
  transform: translate(-50%, -50%);

  display: flex;
  justify-content: center;
  align-items: center;
}
.userContainer .search-icon {
}

.custom-header-table {
  background-color: black !important;
  color: white !important;
  text-align: center;
}
.css-gl260s-MuiDataGrid-columnHeadersInner {
  background-color: #000000;
  color: #fff;
  border-radius: 16px 16px 0px 0px;
}
.css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer {
  background-color: #000000;
  color: #fff;
}
.css-z8fhq1-MuiDataGrid-columnHeaders {
  background-color: #000000 !important;
}

.css-1e2bxag-MuiDataGrid-root .MuiDataGrid-iconSeparator {
  display: none;
}
.css-1e2bxag-MuiDataGrid-root
  .MuiDataGrid-columnHeader:hover
  .MuiDataGrid-menuIcon {
  background-color: #000;
}

.css-11pb1sy-MuiContainer-root {
  /* max-width: 1350px !important; */
  margin-left: 20px;
}

.mainContainerComp .form-control {
  padding: 16px 16px;
  border: 1px solid #d9d9d9;
  position: relative;
  padding-inline-start: 50px;
  color: #666666;
  border-radius: 11px;
}
.mainContainerComp .form-select {
  padding: 16px 16px;
  border: 1px solid #d9d9d9;
  position: relative;
  padding-inline-start: 50px;
  color: #666666;
  border-radius: 11px;
}
.mainContainerComp .searchCon {
  background-color: #f5f5f5;
  width: 28px;
  height: 28px;
  border-radius: 28px;
  position: absolute;
  top: 70%;
  left: 22px;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.lp-btn.annualProgressBtn {
  border-radius: 8px;
  background-color: #e0221e;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    color: #fff;
  }
}

.mainContainerComp .btn-excel-download {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e0221e;
  border-radius: 8px;
  padding: 12px 20px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
}
.mainContainerComp .form-label {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
  margin-bottom: 16px;
  font-weight: 500;
}
.mainContainerComp .send-notification-btn {
  min-width: 461px;
  background-color: #e0221e;
}

.css-2u6ojp-MuiContainer-root {
  max-width: none !important;
}
.css-17jjc08-MuiDataGrid-footerContainer {
  /* border-top: 2px solid #E0221E !important; */
}
.mainContainerComp .table-head tr th {
  background-color: #000000;
  color: #fff;
  padding: 12px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
}
.mainContainerComp .table-head tr th:first-child {
}
.mainContainerComp .table-head tr th:last-child {
}
.mainContainerComp .table-body tr td {
  padding: 12px;
}
.mainContainerComp .table-body tr:nth-child(even) td {
  background-color: #f6f6f6;
}
.sidebar-content-name-con {
  margin: 40px 0px;
}
.sidebar-content-name-con.hidden {
  display: none;
}

.sidebar-content-name-con h3 {
  color: #fff;
  font-family: "Atmospheric", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  text-align: left;
  margin-left: 16px;
}
.wallet-con-wrap {
}
.wallet-con-wrap .img-con {
  border-radius: 100px;
  background: #ffffff;
  width: 68px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-left: 20px;
}
.wallet-cardd {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
}
.wallet-flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
}
.kyc_btn {
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  border: none;
  outline: none;
  padding: 14px 25px;

  &:hover {
    color: #fff;
  }
}

.kyc_btn.pending {
  background-color: #ff8f2e;
}
.kyc_btn.pending.btn-borderr {
  border: 2px solid #000;
  background-color: #fff;
  color: #000;
}

.kyc_btn.approved {
  background-color: #23cd5c;
}
.kyc_btn.approved.btn-borderr {
  border: 2px solid #000;
  background-color: #fff;
  color: #000;
}
.kyc_btn.rejected {
  background-color: #e0221e;
}
.kyc_btn.rejected.btn-borderr {
  border: 2px solid #000;
  background-color: #fff;
  color: #000;
}

.css-iclwpf .MuiDataGrid-columnHeaderTitleContainer {
  background-color: #000000 !important;
  color: #fff !important;
}
.MuiDataGrid-columnHeaderTitleContainer {
  background-color: #000000 !important;
  color: #fff !important;
}

.MuiDataGrid-columnHeadersInner {
  background-color: #000000 !important;
  color: #fff !important;
}
.css-vcjdx3 {
  background-color: #000000 !important;
  color: #fff !important;
}
.css-iclwpf {
  /* display: none !important; */
}
.MuiDataGrid-menuIcon {
  display: none !important;
}
.css-iclwpf {
  /* display: none !important; */
}
.MuiDataGrid-columnSeparator {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAMA,gFAAgF;AAChF;EACE,sBAAsB;EACtB,+DAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,+DAAqE;AACvE;;AAEA;EACE,yBAAyB;EACzB,+DAAyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,+DAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,+DAAsE;AACxE;;AAEA;EACE,uBAAuB;EACvB,+DAAqE;AACvE;;AAEA;EACE,sBAAsB;EACtB,+DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,2BAA2B;EAC3B,+DAAyE;AAC3E;;AAEA;EACE,sBAAsB;EACtB,+DAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,gEAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,6CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,6CAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6CAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6CAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAAiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAAmE;EACnE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gEAAiE;AACnE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0DAAiD;EACjD,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;gBACc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;cACY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,MAAM;EACN,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0DAAmD;EACnD,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;;;;mBAIiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;GAIG;;AAEH,0EAA0E;;AAE1E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0DAAmD;EACnD,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAYA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0DAA+C;EAC/C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,oEAAoE;;AAEpE;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,MAAM;AACR;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,mDAAmD;AACrD;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,SAAS;EACT,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,4BAA4B;AAC9B;AACA;;;EAGE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,yBAAyB;;AAEzB;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,+DAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oDAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gCAAgC;;EAEhC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,YAAY,EAAE,+BAA+B;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;;;;;4CAKgC;EAChC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,+DAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA,eAAe;;AAEf,2FAA2F;AAC3F;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,+FAA+F;;AAE/F,sFAAsF;;AAEtF;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EAKZ,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EAKZ,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;GAOG;AACH;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yFAAyF;;AAEzF,iCAAiC;;AAEjC;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;;AAEnB;EACE,mCAAmC;EACnC,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;;AAEpB;EACE,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,OAAO;AACT;;AAEA;;;EAGE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,QAAQ;EACR,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAKlB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;iBACe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,0DAA8D;EAC9D,iCAAiC;EACjC,6CAA6C;EAC7C,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;;AAEb;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;0CACwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB;uCACqC;AACvC;;AAEA;AACA;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;;AAEhB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0DAA2D;EAC3D,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,MAAM;;EAEN,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX;+BAC6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,uEAAuE;EACvE,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB;;iBAEe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;EACrD,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;AACA;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0DAA2D;EAC3D,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX;+BAC6B;AAC/B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAYA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iEAAiE;EACjE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;GASG;AACH;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0DAA2D;EAC3D,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;AACA;;AAEA;;;;;;AAMA;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;;;;;AAOA;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqIE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2KE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2KE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2KE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8LE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8LE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiKE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+ME,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+ME,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+ME,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsOE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsOE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA;;AAEA;EACE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,0DAA8D;EAC9D,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0DAA6D;EAC7D,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;AACA;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;AACA;EACE,0DAA+D;EAC/D,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,SAAS;AACX;AACA;AACA;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;AACA;AACA;AACA;AACA;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;AACA;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,qBAAqB;;AAErB;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;AACA;AACA;AACA;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;AACA;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;AACA;AACA;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;AACA;AACA;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;;;;;;;GAOG;AACH;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;AACA;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAS;AACX;AACA;EACE,SAAO;AACT;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;AACA;AACA;AACA;EACE,WAAW;EACX,YAAY;EAEZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAO;AACT;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAO;AACT;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;AACA;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;AACA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,sEAAsE;AACtE;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;AACA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;AACA;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,iIAAiI;AACjI;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ;IACE,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;;EAEhC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;AACA;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;AACA;AACA;AACA;AACA;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;;EAElB;IACE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n  --primary: #e11f1c;\n  --secondary: rgb(74, 52, 11);\n  --white: #fff;\n  --black: #000000;\n  --gray: gray;\n  --dark-gray: #a6a6a6;\n  --darkest-gray: #606060;\n  --dark: #404040;\n  --darker: #40404088;\n  --light: #f3f3f3;\n  --lighter: #dadada;\n  --lightest: #ebebeb;\n  --grey-bg: #f3f3f3;\n  --highlight: #c4743f;\n  --light-gray: #d3d3d3;\n  --lighter-gray: #d3d3d399;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n/* @import url('https://fonts.googleapis.com/css2?family=Chewy&display=swap'); */\n@font-face {\n  font-family: \"exposit\";\n  src: URL(\"../fonts/Exposit-Bold.otf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Pacifico\";\n  src: URL(\"../fonts/Pacifico/Pacifico-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Parisienne\";\n  src: URL(\"../fonts/Parisienne/Parisienne-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Shrikhand\";\n  src: URL(\"../fonts/Shrikhand/Shrikhand-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Rock_Salt\";\n  src: URL(\"../fonts/Rock_Salt/RockSalt-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Arizonia\";\n  src: URL(\"../fonts/Arizonia/Arizonia-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"deftone\";\n  src: URL(\"../fonts/deftone\\ stylus.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Bebas Neue\";\n  src: URL(\"../fonts/Bebas_Neue_Pro_Book.otf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"josefin Sans\";\n  src: URL(\"../fonts/JosefinSans-VariableFont_wght.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Mistral\";\n  src: URL(\"../fonts/mistral.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Breef serif\";\n  src: URL(\"../fonts/BreeSerif-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Courgette\";\n  src: url(\"../fonts/Courgette-Regular.ttf\");\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  src: url(\"../fonts/Raleway/static/Raleway-Regular.ttf\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  src: url(\"../fonts/Raleway/static/Raleway-SemiBold.ttf\");\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  src: url(\"../fonts/Raleway/static/Raleway-ExtraBold.ttf\");\n  font-weight: 800;\n}\n\n@font-face {\n  font-family: \"Rethink Sans\";\n  src: url(\"/src/assets/fonts/Rethink_Sans/RethinkSans-Regular.ttf\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Rethink Sans\";\n  src: url(\"/src/assets/fonts/Rethink_Sans/RethinkSans-Medium.ttf\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Rethink Sans\";\n  src: url(\"/src/assets/fonts/Rethink_Sans/RethinkSans-SemiBold.ttf\");\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: \"Rethink Sans\";\n  src: url(\"/src/assets/fonts/Rethink_Sans/RethinkSans-Bold.ttf\");\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Rethink Sans\";\n  src: url(\"/src/assets/fonts/Rethink_Sans/RethinkSans-ExtraBold.ttf\");\n  font-weight: 800;\n}\n\n@font-face {\n  font-family: \"Atmospheric\";\n  src: url(\"/src/assets/fonts/aAtmospheric.ttf\") format(\"truetype\");\n}\n\n.courgette {\n  font-family: \"Courgette\";\n}\n\nbody {\n  font-family: \"Breef serif\";\n  overflow: overlay;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 0.7 !important;\n}\n\ninput:focus-visible {\n  outline: none;\n}\n\ninput:focus::placeholder {\n  color: transparent;\n}\n\n/* p {\n  letter-spacing: 2px;\n  margin-bottom: 0;\n} */\n\na {\n  color: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n\na:hover {\n  color: initial;\n}\n\n.btn {\n  font-size: 17px;\n  font-weight: 500;\n}\n\n::selection {\n  background-color: var(--dark);\n  color: var(--white);\n}\n\nul {\n  list-style-type: none;\n}\n\n.btn:focus {\n  box-shadow: none;\n}\n\n.primary-btn {\n  background: var(--primary);\n  color: var(--white);\n}\n\n.login-btn-color {\n  color: var(--dark) !important;\n}\n\n.container-withdrawl {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  flex-direction: row-reverse;\n  gap: 40px;\n}\n\n.balance-withdrawl {\n  font-size: 30px !important;\n}\n\n.content-withdrawl {\n  flex: 1;\n}\n\n.primary-btn:hover {\n  background: transparent;\n  border: 1px solid var(--primary) !important;\n  color: var(--primary);\n}\n\n.secondary-btn {\n  background: var(--white);\n  color: var(--primary);\n}\n\n.secondary-btn:hover {\n  background: var(--secondary);\n  color: var(--primary);\n}\n\n.banner-section {\n  background-image: url(\"../images/banner-img.jpg\");\n  background-color: #000000;\n  background-attachment: fixed;\n  background-position: center;\n  position: relative;\n  z-index: 0;\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 56.25%;\n}\n\n.bottom-solid {\n  border-bottom: 2px solid var(--light-gray);\n}\n\n.banner-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.absolute-text {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 50px;\n}\n\n.banner-section img {\n  width: 100%;\n}\n\n.banner-text {\n  /* position: absolute;\n    bottom: 0; */\n  color: var(--white);\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* right: 0;\n    left: 0; */\n  font-size: 99px;\n  font-family: \"josefin Sans\";\n}\n\n.common-heading {\n  letter-spacing: normal;\n  line-height: 1.2em;\n  font-size: 32px;\n  font-family: \"josefin Sans\";\n}\n\n.highlight {\n  color: var(--primary) !important;\n  font-weight: 600;\n}\n\n.underlined-text {\n  text-decoration: underline;\n}\n\n.custom-card {\n  width: 350px;\n  margin: 1rem auto;\n}\n\n.custom-card img {\n  width: 100%;\n}\n\n.custom-card h3 {\n  color: var(--secondary);\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.section {\n  margin-top: 5rem;\n}\n\n.section2 {\n  position: relative;\n  padding-bottom: 5rem;\n}\n\n.normal-padding {\n  padding-top: 5rem;\n}\n\n.section-background {\n  position: absolute;\n  width: 100%;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  height: 100%;\n}\n\n.custom-card-two {\n  width: 357px;\n  margin: 1rem auto;\n}\n\n.custom-card-two img {\n  width: 100%;\n}\n\n.custom-card-two h3 {\n  font-size: 20px;\n  color: var(--white);\n  text-align: center;\n}\n\n.secondary-text {\n  color: var(--secondary);\n}\n\n.card-title {\n  color: var(--primary);\n  font-family: \"Breef Serif\";\n  font-weight: 600;\n}\n\n.card-lg h4 {\n  line-height: 1.2em;\n  font-size: 32px;\n  letter-spacing: 2px;\n}\n\n.card-lg p {\n  line-height: 1.7em;\n  font-size: 17px;\n  letter-spacing: 2px;\n  margin: 2.5rem 0;\n  color: var(--secondary);\n  text-align: justify;\n}\n\n.card-lg:nth-child(1) {\n  width: 450px;\n  margin: 3rem auto;\n}\n\n.card-image-two {\n  position: absolute;\n  width: 105%;\n  left: -12px;\n  height: 550px;\n  top: 0;\n  bottom: 0;\n}\n\n.custom-input {\n  border-radius: 5px;\n  background: var(--black);\n  border: none;\n  height: 40px;\n  color: #fff;\n}\n\n.custom-control::placeholder {\n  color: var(--dark);\n}\n\n.custom-control,\n.custom-control input#phone {\n  all: unset;\n  background: var(--lightest);\n  padding: 0.7em 1em;\n  color: var(--dark);\n  border-radius: 3px;\n  display: block;\n  width: -webkit-fill-available;\n  width: -moz-available;\n}\n\n.phone-input {\n  border: none !important;\n  background: var(--lightest) !important;\n  width: -webkit-fill-available !important;\n}\n\n.phone-input-button {\n  border: none !important;\n  background-color: var(--light) !important;\n}\n\n::placeholder {\n  color: var(--white);\n  font-weight: 500;\n}\n\n.Background-fixed {\n  background-image: url(\"../images/lastsection.jpeg\");\n  background-color: #000000;\n  background-attachment: fixed;\n  background-position: center;\n}\n\n.ImageBackgroundWrap {\n  position: relative;\n  z-index: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.background-text {\n  padding: 13%;\n  color: white;\n  text-align: center;\n}\n\n.card-lg-smos-img {\n  /* position: sticky;\n    width: 105%;\n    left: -12px;\n    top: 0;\n    bottom: 40px; */\n  width: 100%;\n}\n\n.col-without-padding .col-lg-6 {\n  padding: 0;\n}\n\n.first-section-with-title {\n  padding-top: 4rem;\n  text-align: center;\n}\n\n.heading-section-border {\n  padding: 2rem 0;\n  border: 3px solid var(--dark-gray);\n  border-left: none;\n  border-right: none;\n}\n\n.heading-section-border h2 {\n  margin: 0;\n  color: var(--primary);\n}\n\n.items {\n  display: flex;\n  margin-top: 1rem;\n}\n\n.items img {\n  width: 250px;\n}\n\n.items .title-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.items .title-section .first {\n  width: 90%;\n  display: flex;\n  align-items: center;\n  border-bottom: 5px dotted var(--primary);\n  color: var(--primary);\n}\n\n.items .title-section .first svg {\n  fill: var(--primary);\n  margin-right: 0.5rem;\n}\n\n.items .title-section sub {\n  font-size: 20px;\n}\n\n.items p {\n  font-size: 20px;\n  margin-top: 1rem;\n}\n\n.items .title-section h3 {\n  margin: 0;\n}\n\n.image-section {\n  overflow: hidden;\n  min-height: 150px;\n}\n\n.shop-item a .image-section:hover > img {\n  transform: scale(1.1);\n}\n\n.shop-item a {\n  text-decoration: none;\n  overflow: hidden !important;\n  display: inline-block;\n  color: var(--black);\n}\n\n.shop-item img {\n  transition: all 1s;\n}\n\n.shop-item .shop-title {\n  font-family: 300 !important;\n  font-size: 25px;\n}\n\n.primary-text {\n  color: var(--primary);\n}\n\n.branch-card {\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  text-align: center;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: #fff;\n  box-shadow: 0 3px 5px -3px #a2a2a2;\n}\n\n.branch-card img {\n  width: 80%;\n  margin: auto;\n}\n\n.offices-section {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n.branch-card .section-title {\n  font-size: 24px;\n}\n\n.branch-card .address {\n  text-align: justify;\n  text-align-last: center;\n}\n\n.branch-card .section-title::first-letter {\n  color: var(--primary);\n}\n\n/* .branch-card p {\n  font-size: 22px;\n  color: var(--secondary);\n  margin: 1rem 0;\n} */\n\n/* =========================.investment-section========================= */\n\n.invest-options-modal .modal-content {\n  border-radius: 0;\n  background: var(--light);\n  color: var(--dark);\n}\n\n.invest-options-modal .modal-content button {\n  color: var(--light);\n  font-size: 14px;\n}\n\n.invest-options-modal .modal-content button:hover {\n  color: var(--dark);\n}\n\n#investements {\n  position: relative;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#investements::before {\n  background-image: url(\"../images/coffe-banner.jpg\");\n  background-size: cover;\n  background-position: center;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  opacity: 0.9;\n}\n\n.investment-section {\n  text-align: center;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.investment-section .banner-text {\n  font-family: inherit;\n}\n\n.investment-section h4 {\n  font-size: 24px;\n  color: var(--white);\n}\n\n.investment-section h2 {\n  font-size: 70px;\n\n  color: var(--primary);\n  font-family: \"Breef Serif\";\n}\n\n.investment-section p {\n  text-align: right;\n  font-size: 26px;\n  color: var(--secondary);\n}\n\n.invest-second {\n  padding: 2rem 0;\n  position: relative;\n  background: #fafafa96;\n}\n\n.invest-bg {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  height: 800px;\n  z-index: -1;\n  opacity: 0.3;\n}\n\n.primary {\n  color: var(--primary) !important;\n}\n\n.light {\n  color: var(--light);\n}\n\n.investment-second {\n  margin-top: 50px;\n}\n\n.investment-second h3 {\n  font-size: 34px;\n  color: var(--secondary);\n}\n\n.investment-second h2 {\n  font-size: 70px;\n  color: var(--primary);\n}\n\n.investment-second p {\n  font-size: 18px;\n  color: var(--secondary);\n}\n\n.invest-second .invest-search-input {\n  flex-basis: 100%;\n}\n\n.store-select-wrapper {\n  width: 200px !important;\n}\n\n.stores-list {\n  box-shadow: none !important;\n}\n\n.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root {\n  background-color: #fff !important;\n  padding-right: 0.5rem !important;\n}\n\n.store-select .MuiPaper-root::-webkit-scrollbar {\n  width: 6px !important;\n}\n\n.invest-second .invest-search-input input {\n  padding: 14px;\n  margin-right: 24px;\n  width: 590px;\n  color: var(--secondary);\n  border-radius: 4px;\n  border-color: var(--primary);\n}\n\n.invest-second .invest-search-input input:focus {\n  border-color: var(--secondary);\n  outline: none;\n}\n\n::-webkit-input-placeholder {\n  /* Edge */\n  color: var(--primary);\n}\n\n:-ms-input-placeholder {\n  /* Internet Explorer */\n  color: var(--primary);\n}\n\n::placeholder {\n  color: var(--primary);\n}\n\n.simple-input::placeholder {\n  color: var(--dark) !important;\n}\n\n.flex-input {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.3rem 1rem;\n  border-radius: 5px;\n  gap: 5px;\n}\n\n.flex-input input {\n  flex-grow: 1;\n}\n\n.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border-color: var(--primary) !important;\n  border-width: 2px;\n}\n\n.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\n  color: var(--primary) !important;\n}\n\n.MuiMenu-list {\n  background-color: var(--light);\n  color: var(--dark);\n}\n\n.MuiMenu-paper::-webkit-scrollbar {\n  width: 4px;\n  background: var(--light);\n}\n\n.MuiMenu-paper::-webkit-scrollbar-thumb {\n  background-color: var(--dark-gray);\n}\n\n.MuiPaper-root {\n  height: auto;\n}\n\n.invest-second .btn {\n  padding: 14px 20px;\n  margin-left: 5px;\n}\n\n.invest-second .bg-image {\n  background-image: url(\"../images/Textura.webp\");\n  background-size: cover;\n  border-radius: 10px;\n}\n\n.symbol-text {\n  font-size: 14px;\n  color: var(--secondary);\n}\n\n#investment-simulation .bg-image .content h3 {\n  margin: 0px;\n  font-size: 24px;\n  padding: 10px 0px;\n}\n\n#investment-simulation .image img {\n  width: 100%;\n}\n\n#investment-simulation .content p {\n  font-size: 22px;\n}\n\n.table-images-txt {\n  padding: 10% 0px !important;\n}\n\n.section2 .img img {\n  width: 60%;\n}\n\n.section-documentation .section2 {\n  padding: 0;\n}\n\n.section-documentation {\n  color: var(--secondary);\n}\n\n.section-documentation h3,\n.section-documentation h4 {\n  color: var(--primary);\n}\n\n#section-bg-atteched .background-text .images img {\n  width: 100%;\n}\n\n/* ===================invest-now-card============================= */\n\n.invest-now-card {\n  margin: 0.5rem;\n  border-radius: 10px;\n  padding: 0.5rem;\n}\n\n.invest-now-card .image-section figure {\n  position: relative;\n  margin: 0 auto;\n}\n\n.invest-now-card .image-section figure img {\n  transition: all 1s;\n  /*width: 100%;*/\n}\n\n.invest-now-card .image-section figure figcaption img {\n  width: 25px;\n}\n\n.invest-now-card .image-section figure figcaption {\n  position: absolute;\n  bottom: 0;\n  background: rgb(0, 0, 0);\n  background: rgba(0, 0, 0, 0.5);\n  color: #f1f1f1;\n  padding: 10px;\n  top: 0;\n}\n.home-sec-seven .title {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #252525;\n  margin: 0px;\n}\n.invest-now-card .image-section figure figcaption span {\n  /* margin-left: 10px; */\n  line-height: 1em;\n  padding: 0;\n}\n\n.invest-now-card\n  .image-section:hover\n  .invest-now-card\n  .image-section\n  figure\n  img {\n  transform: scale(1.1);\n}\n\n.invest-now-card .line {\n  width: 100%;\n  height: 10px;\n  background: #ff4141;\n  border-radius: 12px;\n  margin-bottom: 15px;\n}\n\n.invest-now-card h4 {\n  font-size: 1.3rem;\n  margin: 10px 0px 0px 5px;\n  color: var(--dark);\n}\n\n.invest-now-card .invest-card-desc {\n  color: var(--dark);\n  margin-bottom: 5px;\n  font-size: 0.9rem;\n  line-height: 1.3em;\n  padding: 0.3em 1em 0 5px;\n  text-align: start;\n  letter-spacing: 0;\n}\n\n.invest-card-desc.less {\n  height: 2.6em;\n  overflow: hidden;\n}\n\n.show-more {\n  display: inline-block;\n}\n\n.show-more p {\n  margin-bottom: 0;\n  font-size: 0.8rem;\n  margin-left: 5px;\n  letter-spacing: 0;\n}\n\n/* .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {\n  padding: 9.5px 14px;\n} */\n.state-ul {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0;\n}\n\n.state-ul li {\n  padding: 0.3rem 0;\n}\n\n.state-ul li a {\n  color: var(--secondary);\n  text-decoration: none;\n  font-size: 20px;\n}\n\n.state-ul li a:hover {\n  color: var(--secondary);\n}\n\n.race-item a {\n  color: var(--primary);\n  font-size: 22px;\n}\n\n.race-item p {\n  font-size: 20px;\n}\n\n.team-img {\n  width: 100%;\n}\n\n.form-heading {\n  color: var(--primary);\n}\n\n.card-icons {\n  display: flex;\n  gap: 1em;\n}\n\n.investor-card .card-icon {\n  border-radius: 50%;\n  aspect-ratio: 1;\n  width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.investor-card .card-icon.instagram {\n  background: #e11f1c88;\n}\n\n.investor-card .card-icon.in {\n  background: #e11f1ccc;\n}\n\n.investor-card .card-icon.twitter {\n  background: #e11f1c;\n}\n\n.t-card-img {\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 90%;\n  aspect-ratio: 1;\n}\n\n.t-card-img img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.t-card-desc {\n  font-size: 0.9rem;\n  letter-spacing: 1px;\n  line-height: 1.4rem;\n  overflow: hidden;\n}\n\n.t-card-desc.limit {\n  height: 4.2rem;\n}\n\n.t-card-desc.expandable {\n  height: 4.2rem;\n  overflow: hidden;\n}\n\n.responsive-text {\n  width: clamp(300px, 50%, 768px);\n  margin: auto;\n}\n\n.investor-card .custom-card-title {\n  font-size: 1rem;\n}\n\n.custom-card-title.small {\n  font-size: 20px;\n}\n\n.t-card-wrapper {\n  border-radius: 0.3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  /* background: var(--white); */\n  padding: 1em;\n  /* box-shadow: 1px 1px 1px 1px var(--light-gray); */\n}\n\n/* .custom-section:not(.grey-bg) .t-card-wrapper {\n  box-shadow: 0px 0px 10px 1px var(--light-gray);\n} */\n\n.team-section .section-title {\n  margin-bottom: 1rem;\n}\n\n.read-more-btn {\n  all: unset;\n  color: var(--primary);\n  cursor: pointer;\n}\n\n.contact-right {\n  padding: 2em;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.info-item {\n  display: flex;\n  align-items: start;\n  margin-bottom: 0.5em;\n}\n\n.info-item-body {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.info-title {\n  font-weight: 500;\n  padding-left: 10px;\n  margin-bottom: 0;\n}\n\n.info-desc {\n  padding-left: 10px;\n  font-size: 14px;\n  width: 70%;\n  margin-left: auto;\n  letter-spacing: 0;\n}\n\n.info-desc:not(:first-child) {\n  word-wrap: break-word;\n}\n\n.social-icons {\n  width: 30%;\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5em 0;\n}\n\n.social-icons i {\n  font-size: 1.2rem;\n  color: var(--dark);\n  opacity: 0.7;\n}\n\n.contact-map {\n  width: 100%;\n  height: 100%;\n}\n\n.contact-form {\n  padding: 1em;\n}\n\n.contact-form input,\n.contact-form textarea {\n  margin-bottom: 1rem;\n  border: 1px solid var(--light);\n  background-color: var(--light);\n  padding: 0.5em 1em;\n}\n\n.contact-form input:hover,\n.contact-form textarea:hover {\n  border: 1px solid var(--primary);\n}\n\n.contact-form input:focus,\n.contact-form textarea:focus {\n  outline: none !important;\n  box-shadow: none;\n  border-color: var(--primary);\n  background-color: var(--light);\n}\n\n.contact-image {\n  width: 400px;\n  text-align: center;\n}\n\n.last-section h2 {\n  font-family: \"josefin Sans\";\n}\n\n.blog-creater {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blog-creater .inner {\n  display: flex;\n  align-items: center;\n}\n\n.blog-creater img {\n  border-radius: 50px;\n  width: 50px;\n  height: 50px;\n  margin-right: 0.5rem;\n}\n\n.blog-creater span {\n  font-size: 14px;\n}\n\n.blog-body h3 {\n  font-size: 40px;\n  font-weight: 600;\n  font-family: arial;\n  margin-top: 1rem;\n}\n\n.blog-body p {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.blog-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blog-footer div span:not(:first-child) {\n  margin-left: 2rem;\n}\n\n.blog-footer i {\n  color: var(--primary);\n}\n\n.blog-img {\n  width: 100%;\n}\n\n.custom-card .tag {\n  fill: var(--primary);\n  width: 90px;\n  position: absolute;\n  top: -26px;\n  right: -22px;\n}\n\n.custom-card .tag div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-card .tag div span {\n  position: absolute;\n  font-size: 25px;\n  color: var(--white);\n  font-family: \"josefin Sans\";\n}\n\n/* ============================dashboard-style==================== */\n.css-o5srbh-MuiPaper-root-MuiAppBar-root {\n  background-color: #ff4141 !important;\n}\n\n.dashboard-logo {\n  margin-top: 8px;\n  width: 100px !important;\n}\n\n/* ---------------------dashboard-design----------------------- */\n.css-1o1hm4z-MuiDrawer-docked .MuiDrawer-paper {\n  z-index: 222222;\n}\n\n.dashboard-box {\n  border-radius: 20px !important;\n  padding: 16px !important;\n  background-color: #fff5f5 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 95%;\n  height: 95%;\n  margin: auto;\n  box-shadow: none !important;\n  gap: 10px;\n  margin: 0;\n  cursor: pointer;\n  transition: background 0.3s ease, color 0.3s ease;\n  height: 143px;\n  margin-bottom: 16px;\n  position: relative;\n  z-index: 10;\n}\n.boxwithdrawlReqPagebox {\n  width: 140px;\n  height: 140px;\n  background-color: #fff;\n  position: relative;\n  border-radius: 100%;\n}\n.boxwithdrawlReqPagebox svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.dashboard-box-withdrawlReq {\n  border-radius: 20px !important;\n  padding: 16px !important;\n  background-color: #fff5f5 !important;\n  display: flex;\n  align-items: center;\n  width: 95%;\n  height: 95%;\n  margin: auto;\n  box-shadow: none !important;\n  /* gap: 10px; */\n  margin: 0;\n  cursor: pointer;\n  position: relative;\n  z-index: 10;\n}\n.dashboard-box-withdrawlReq h3 {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  text-align: center;\n  color: #e0221e;\n  margin-top: 30px;\n}\n.dashboard-box-withdrawlReq h4 {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 60px;\n  font-weight: 700;\n  line-height: 35px;\n  text-align: center;\n  color: #e0221e;\n}\n\n.dashboard-box:hover {\n  background: linear-gradient(244.48deg, #e0221e 33.84%, #8f0000 92.38%);\n  /* transform: scale(1.05); */\n}\n.dashboard-box:hover h3,\n.dashboard-box:hover h4,\n.dashboard-box:hover h6 {\n  color: #fff;\n}\n\n.dashboard-box h3 {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 25px;\n  text-align: left;\n  color: #e0221e;\n  transition: color 0.3s ease;\n}\n.dashboard-box h6 {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  color: #e0221e;\n  transition: color 0.3s ease;\n}\n.dashboard-box h4 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 30px;\n  color: #e0221e;\n  word-break: break-all;\n  transition: color 0.3s ease;\n}\n.dashboard-box .img-con {\n  border-radius: 100px;\n  background: #ffffff;\n  width: 68px;\n  height: 68px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.dashboard-box img {\n  width: auto;\n  object-fit: contain;\n  padding: 6px;\n}\n\n.chevron-icon {\n  display: none !important;\n}\n\n/* ========================404================= */\n.not-found-image {\n  position: relative;\n}\n\n.not-found-image img {\n  width: 100%;\n}\n\n.not-found-image .button {\n  position: absolute;\n  bottom: 0;\n}\n\n.not-found-image .button a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n#custom::-webkit-input-placeholder {\n  color: #fff !important;\n}\n\n.css-1j9kmqg-MuiDataGrid-toolbarContainer {\n  gap: 1em;\n}\n\n/* .MuiDataGrid-cell[data-field='actions'] svg:nth-child(2){\n  color: red !important;\n} */\n\n.search-icon svg {\n  color: var(--light);\n}\n\n/* new about page */\n.about-logo {\n  width: 80%;\n}\n\n.page-banner {\n  position: relative;\n  overflow: hidden;\n}\n\n.page-banner-body {\n  min-height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 72px;\n}\n\n.page-banner-title {\n  font-size: 2rem;\n  font-weight: 500;\n  color: white;\n}\n\n.page-banner .background-img {\n  position: absolute;\n  bottom: 0;\n  z-index: -1;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  filter: brightness(0.5);\n  width: 100%;\n  min-height: 100%;\n}\n\n/* new contact page */\n.map-iframe {\n  border-radius: 1em;\n  overflow: hidden;\n  height: 100%;\n  min-height: 350px;\n}\n\n.video-iframe iframe {\n  border-radius: 1em;\n  width: 100%;\n}\n\n.radio-group {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.map-iframe iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.center-x {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.center-xy {\n  display: grid;\n  place-items: center;\n}\n\n.scroll-x {\n  overflow-x: auto;\n  padding: 25px;\n}\n\n/* new landing page css */\n\n.investor-card {\n  padding-block: 5%;\n}\n\n.investor-card-img {\n  width: 80%;\n  margin: auto;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 2px solid #00000033;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.investor-card-img:hover img {\n  filter: grayscale(0);\n}\n\n.investor-card-body {\n  padding-inline: 1em;\n}\n\n.investor-card-img-inner {\n  border-radius: 50%;\n  overflow: hidden;\n  width: 90%;\n  height: 90%;\n  display: flex;\n  align-items: center;\n}\n\n.investor-card-img-inner img {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n  /* filter: grayscale(1); */\n  transition: all 0.3s ease;\n  object-fit: contain;\n}\n\n.investor-card:hover .investor-card-img img {\n  filter: grayscale(0);\n}\n\n.section-dots {\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n  width: 100%;\n  justify-content: center;\n  padding-block: 0.5em;\n}\n\n.section-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #e11f1c;\n}\n\n.dot-1 {\n  opacity: 0.2;\n}\n\n.dot-2 {\n  opacity: 0.4;\n}\n\n.dot-3 {\n  opacity: 0.6;\n}\n\n.dot-4 {\n  opacity: 0.8;\n}\n\n.dot-5 {\n  opacity: 1;\n}\n\n.recent-investors {\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\n\n.mobile-header {\n  position: fixed;\n  right: 0;\n  top: 0;\n  height: 100%;\n  z-index: 3;\n  gap: 1rem;\n  backdrop-filter: blur(50px);\n  -webkit-backdrop-filter: blur(50px);\n  background-color: var(--dark);\n  width: clamp(300px, 100%, 576px);\n  transform: translateX(101%);\n  transition: all 0.3s ease;\n}\n\n.mobile-header .simple-btn.login {\n  margin-right: 0;\n}\n\n.mobile-header.show {\n  transform: translateX(0);\n}\n\n.mobile-header nav {\n  height: 100%;\n}\n\n.mobile-header ul {\n  display: flex;\n  align-items: center;\n  padding: 1em;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  gap: 1em;\n}\n\n.header-button {\n  all: unset;\n  color: var(--light);\n  font-size: 1.5rem !important;\n  height: 72px;\n}\n\n.header-button.close {\n  position: fixed;\n  right: 1em;\n}\n\n.main-header {\n  height: 72px;\n  /* background: rgba(228, 228, 228, 0.15) !important; */\n  display: flex;\n  align-items: center;\n  top: 0;\n  left: 78px;\n  right: 0;\n  z-index: 1;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  padding: 1rem;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  background: #404040;\n  z-index: 9999;\n}\n\n.main-header.bg {\n  background: url(../images/lp-bg.png) !important;\n}\n\n.main-header-link {\n  margin-left: 1em;\n  color: var(--light);\n  font-weight: 300;\n  white-space: nowrap;\n}\n\n.mobile-header-link {\n  color: var(--light);\n  text-align: center;\n}\n\n.main-header-link:hover {\n  color: var(--primary);\n}\n\n.header-line {\n  width: 1px;\n  height: 45px;\n  background-color: var(--lighter);\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.header-left .search-icon {\n  background: rgba(228, 228, 228, 0.15);\n  border-radius: 6px;\n  padding: 0em 10px;\n  cursor: pointer;\n}\n\n.main-logo {\n  width: 98px;\n  height: 36px;\n}\n\n.main-logo img {\n  width: 100%;\n  height: 100%;\n}\n\n.section-logo {\n  display: flex;\n  justify-content: center;\n  padding: 1em 0;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n}\n\n.stat-box {\n  border-radius: 1em;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  background: rgba(39, 39, 39, 0.8);\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.4);\n  justify-content: center;\n  position: absolute;\n}\n\n.stat-box.order-1 {\n  top: 10%;\n  left: 0;\n  transform: translateX(-66%);\n}\n\n.stat-box.order-2 {\n  top: 10%;\n  right: 0;\n  transform: translateX(71%);\n}\n\n.stat-box.order-3 {\n  top: 37%;\n  left: 22px;\n  transform: translateX(-59%);\n}\n\n.stat-box.order-4 {\n  top: 66%;\n  left: 0;\n  transform: translateX(-69%);\n}\n\n.stat-box.order-5 {\n  top: 58%;\n  right: 0;\n  transform: translateX(65%);\n}\n\n.stat-box-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.stat-number {\n  margin-bottom: 0;\n  padding-bottom: 0 !important;\n  font-weight: 700;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 25px;\n  color: var(--light);\n  line-height: 1em;\n  padding-right: 9px;\n}\n\n.stat-icon {\n  font-size: 1.8rem;\n  margin-bottom: 0.3em;\n  color: var(--light);\n  width: 40px;\n  margin-left: 10px;\n}\n\n.stat-icon img {\n  width: 100%;\n}\n\n.stat-label {\n  font-family: \"Raleway\";\n  font-weight: 500;\n  font-size: 12px;\n  color: var(--light);\n  margin-bottom: 0;\n  line-height: 1.1em;\n  margin-top: 0.5em;\n  max-width: 120px;\n}\n\n.stat-label .bg-label {\n  background: #343434;\n  border-radius: 30px;\n  padding: 4px 10px;\n}\n\n.get-started-section .section-title {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.get-started-body {\n  width: 80%;\n}\n\n.get-started-section small {\n  margin-top: 10px;\n}\n\n.get-started-img {\n  width: 100%;\n  aspect-ratio: 6/5;\n  overflow: hidden;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 1em;\n}\n\n.get-started-img img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.landing-page {\n  font-family: \"Bebas neue\";\n}\n\n.lp-invest-i-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.lp-invest-img {\n  margin-bottom: 10px;\n}\n\n.normal-p,\n.normal-p * {\n  font-size: 1rem;\n  color: #404040;\n}\n\n.para {\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: var(--dark);\n  margin-bottom: 0;\n}\n\ninput[type=\"radio\"] {\n  accent-color: var(--primary);\n}\n\n.normal-p.light-p {\n  font-weight: 300;\n  font-size: 20px;\n  color: var(--white);\n  line-height: 1.4em;\n  letter-spacing: 1px;\n}\n\n.simple-text {\n  letter-spacing: 1px;\n  color: var(--dark);\n}\n\n.dark-text {\n  color: #404040;\n}\n\n.red-text {\n  color: #e11f1c;\n}\n\n.primary {\n  color: var(--primary);\n}\n\n.dark {\n  color: var(--dark);\n}\n\n.recharts-legend-wrapper .dark {\n  font-weight: 500;\n}\n\n.failure {\n  color: #ff6961;\n}\n\n.success {\n  color: #4bb543;\n}\n\n.section-title {\n  font-size: 35px;\n  font-weight: 500;\n  text-align: center;\n  margin-bottom: 3rem;\n  letter-spacing: 0;\n  line-height: 1.2em;\n  font-family: \"Raleway\", sans-serif;\n  color: var(--dark);\n}\n\n.section-subtitle {\n  font-size: 25px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 1em;\n  font-family: \"Raleway\", sans-serif;\n  color: var(--dark);\n}\n\n.title {\n  font-size: 25px;\n  font-weight: 500;\n  margin-bottom: 1em;\n  letter-spacing: 1px;\n  color: var(--dark);\n}\n\n.section-title.light-title {\n  font-weight: 500;\n  font-size: 30px;\n  color: var(--white);\n}\n\n.section-title.main-section-title {\n  font-size: 50px;\n}\n\n/* \n.section-title::first-letter {\n  color: var(--primary);\n} */\n\n.dashboard-title {\n  font-family: \"Poppins\", sans-serif;\n  color: var(--dark);\n  font-weight: 500;\n  font-size: 1.8rem;\n  margin-bottom: 1em;\n  margin-bottom: 0;\n}\n\n.custom-section {\n  padding: 5rem 0;\n}\n\n.clip-section {\n  position: relative;\n}\n\n.clip-section .triangle {\n  position: absolute;\n  background-color: var(--light);\n  width: 100%;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  clip-path: polygon(100% 1%, 0% 100%, 100% 100%);\n}\n\n.ceo-message-box {\n  border-left: 4px solid var(--primary);\n  padding: 3em;\n  background: white;\n  box-shadow: inset -1px -1px 0px 0px var(--light-gray);\n  border-radius: 10px;\n}\n\n.ceo-message-box .quote-icon {\n  font-size: 3rem;\n}\n\n.ceo-message-box p {\n  font-style: italic;\n}\n\n.large-p {\n  font-size: 50px;\n  font-weight: 600;\n}\n\n.grey-bg {\n  background-color: #f3f3f3;\n}\n\n.lighter-gray-bg {\n  background-color: var(--lighter-gray);\n}\n\n.lighter-gray-item {\n  background-color: var(--lighter-gray);\n  padding: 0.5em 1em;\n  border-radius: 5px;\n  margin: auto;\n  text-align: center;\n}\n\n.darker-gray-item {\n  background-color: #303030;\n  padding: 0.5em 1em;\n  border-radius: 5px;\n  margin: auto;\n  text-align: center;\n  color: var(--light);\n}\n\n.pre-line {\n  white-space: pre-line;\n}\n\n.icon {\n  width: 20px;\n}\n\n.small-shade {\n  box-shadow: 1px 1px 4px -2px gray;\n}\n\n.accordion-item {\n  font-family: \"Raleway\";\n  box-shadow: 1px 1px 1px 0px var(--light-gray);\n}\n\n.main-text {\n  text-align: justify;\n  text-align-last: center;\n  width: 50%;\n  margin: auto;\n}\n\n.accordion-button {\n  background-color: #f3f3f3 !important;\n  font-weight: 600;\n  color: #404040;\n  font-size: 18px;\n}\n\n.accordion-button:focus {\n  box-shadow: none;\n  color: #404040;\n}\n\n.accordion-body {\n  border: 7px solid #f3f3f3;\n}\n\n.accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n\n.accordion-button:not(.collapsed)::after {\n  content: \"\\2212\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 600;\n  background-image: unset;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #404040;\n}\n\n.accordion-button.collapsed::after {\n  content: \"\\002b\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 600;\n  background-image: unset;\n}\n\n.accordion-item {\n  margin-bottom: 1rem;\n  border: none;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.accordion-body {\n  font-size: 20px;\n  color: #404040;\n}\n\n.accordion-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.accordion-section {\n  padding: 3rem 0 5rem;\n}\n\n.target-img {\n  display: flex;\n  justify-content: center;\n}\n\n.target-img img {\n  width: 80%;\n}\n\n.main-section-wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  /* min-height: 100vh; */\n  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */\n}\n\n.main-section {\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-repeat: no-repeat;\n  width: 100%;\n  background-size: cover;\n  background-position: bottom center;\n  transition: all 0.5s ease;\n  background-size: cover;\n  background-position: center;\n  position: fixed;\n  z-index: 9999;\n}\n\n.header-section {\n  background: url(../images/lp-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: bottom center;\n}\n\n.text-section p {\n  margin-bottom: 0;\n}\n\n.text-section .section-title {\n  font-size: 40px;\n  margin-bottom: 2rem;\n}\n\n.courgette {\n  font-family: \"Courgette\";\n}\n\n.lp-invest-i-wrapper {\n  text-align: center;\n}\n\n.grid-section p,\n.grid-section2 p:not(.large-p) {\n  padding: 0 2rem 2rem;\n}\n\n.grid-section2 .large-p {\n  margin-bottom: 0;\n  font-size: 30px;\n  text-transform: uppercase;\n  letter-spacing: 0;\n}\n\n.red-bg {\n  background-color: var(--primary);\n}\n\n.head-box {\n  background-color: var(--primary);\n  width: 100%;\n  height: 200px;\n  position: relative;\n}\n\n.white-box {\n  background: white;\n  padding: 1em;\n  border-radius: 1em;\n}\n\n.head-box-logo {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  width: 100px;\n}\n\n.main-section-text {\n  padding-right: 78px;\n}\n\n.main-section .row p:last-child {\n  font-family: \"Raleway\";\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 33px;\n  letter-spacing: 1px;\n}\n\n.rounded-input-group {\n  background: rgba(228, 228, 228, 0.15);\n  border-radius: 30px;\n  width: 85%;\n  height: 40px;\n  display: flex;\n}\n\n.rounded-input-group button {\n  margin-left: auto;\n  height: 100%;\n  min-width: fit-content;\n}\n\n.rounded-input {\n  background: rgba(228, 228, 228, 0);\n  border-radius: 30px;\n  border: none;\n  padding: 0.2em 1em;\n  color: var(--light-gray);\n  min-width: 0;\n}\n\n.rounded-input::placeholder {\n  color: var(--light);\n}\n\n.main-section .normal-p *,\n.main-section .normal-p {\n  color: var(--light);\n}\n\n.main-section .section-title {\n  color: var(--light) !important;\n}\n\n.main-section .row p:first-child {\n  padding-bottom: 0.5rem;\n}\n\n.lp-shop-crop {\n  width: 100%;\n  height: 100%;\n}\n\n.lp-phone-img-wrapper {\n  aspect-ratio: 5/11;\n  width: 50%;\n  position: relative;\n}\n\n.language-btn {\n  border-radius: 30px;\n  margin-right: 10px;\n}\n\n.language-btn button {\n  border: none;\n  margin: 1px;\n  padding: 0 1em;\n}\n\n.language-btn button:first-child {\n  border-radius: 30px 0 0 30px;\n}\n\n.language-btn button:last-child {\n  border-radius: 0 30px 30px 0;\n}\n\n.language-btn .active-lng {\n  background-color: var(--primary);\n  color: #fff;\n}\n.language-btnn {\n  border-radius: 30px;\n  margin-right: 10px;\n}\n\n.language-btnn button {\n  border: none;\n  margin: 1px;\n  padding: 0 1em;\n}\n\n.language-btnn button:first-child {\n  border-radius: 30px 0 0 30px;\n}\n\n.language-btnn button:last-child {\n  border-radius: 0 30px 30px 0;\n}\n\n.language-btnn .active-lng {\n  background-color: var(--primary);\n  color: #fff;\n}\n\n.button-group {\n  display: flex;\n  align-items: center;\n}\n\n.lp-btn-header {\n  background-color: var(--primary);\n  border-radius: 30px;\n  padding: 0.2em 1.2em;\n  color: var(--white);\n  cursor: pointer;\n  border: 1px solid var(--primary);\n  text-decoration: none;\n  min-width: 80px;\n}\n\n.lp-btn {\n  background-color: var(--primary);\n  border-radius: 30px;\n  padding: 0.2em 1.2em;\n  color: var(--white);\n  cursor: pointer;\n  border: 1px solid var(--primary);\n  text-decoration: none;\n  min-width: 80px;\n}\n.lp-btn.adduser {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 8px;\n  padding: 12px 20px;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 700;\n}\n.lp-btn-invest {\n  background-color: var(--primary);\n  border-radius: 30px;\n  padding: 0.2em 1.2em;\n  color: var(--white);\n  cursor: pointer;\n  border: 1px solid var(--primary);\n  text-decoration: none;\n  min-width: 80px;\n}\n\n.lp-btn-invest:hover {\n  background-color: var(--primary);\n\n  border: 1px solid var(--primary);\n}\n\n.lp-news-btn {\n  background-color: var(--primary);\n  padding: 0.2em 1.2em;\n  color: var(--white);\n  border: 1px solid var(--primary);\n  text-decoration: none;\n  /* min-width: 80px; */\n  font-weight: 700;\n}\n.join-banner-news {\n  display: flex;\n  /* flex-direction: column; */\n}\n.join-banner-news .lp-news-btn:hover {\n  color: white; /* Change text color on hover */\n}\n\n.join-banner-news img {\n  width: 300px;\n  object-fit: contain;\n}\n.lp-btn.square-btn {\n  border-radius: 5px;\n}\n\n.lp-btn-invest.inverted-btn {\n  background-color: var(--dark);\n  border: 1px solid var(--dark);\n  color: var(--light);\n}\n\n.lp-btn.inverted-btn {\n  background-color: var(--dark);\n  border: 1px solid var(--dark);\n  color: var(--light);\n}\n\n.lp-btn.full-btn {\n  border-radius: 10px;\n  width: 100%;\n}\n.lp-btn-invest.full-btn {\n  border-radius: 10px;\n  width: 100%;\n}\n.lp-btnn {\n  background-color: var(--primary);\n  border-radius: 30px;\n  padding: 0.2em 1.2em;\n  color: var(--white);\n  cursor: pointer;\n  border: 1px solid var(--primary);\n  text-decoration: none;\n  min-width: 80px;\n}\n\n.lp-btnn.square-btn {\n  border-radius: 5px;\n}\n\n.lp-btnn:hover {\n  color: inherit;\n}\n\n.lp-btnn.inverted-btn {\n  background-color: var(--dark);\n  border: 1px solid var(--dark);\n  color: var(--light);\n}\n\n.lp-btnn.full-btn {\n  border-radius: 10px;\n  width: 100%;\n}\n\n.dark-canvas .lp-btn:hover {\n  color: var(--white);\n  border-color: var(--white);\n}\n\n.center-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.profile-card {\n  background-color: var(--light) !important;\n}\n\n.simple-btn,\n.simple-input {\n  border: none;\n  border-radius: 30px;\n  background-color: inherit;\n}\n\n.simple-input {\n  color: var(--dark);\n}\n\n.simple-button {\n  all: unset;\n  cursor: pointer;\n}\n\n.simple-btn.login {\n  /* padding: 15px 35px 15px 35px; */\n  padding: 10px 22px 10px 22px;\n  border-radius: 5px;\n  background-color: #e11f1c;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.83px;\n  text-align: left;\n  border: none;\n  outline: none;\n  color: #fff;\n  border: none;\n  outline: none;\n  padding: 0.2em 1.2em;\n  border-radius: 30px;\n  border: 1px solid #e11f1c;\n}\n.simple-btn.login:hover {\n  background-color: inherit;\n  color: #000;\n}\n\n.main-header .lp-btn:hover {\n  color: var(--light);\n}\n\n.form-control:focus {\n  color: var(--dark);\n  background-color: #fff;\n  border-color: var(--dark);\n  outline: 0;\n  box-shadow: none;\n}\n\n.simple-square-btn {\n  border: 1px solid;\n  padding: 10px 12px !important;\n  border-radius: 30px;\n  margin: 5px 5px 5px 5px;\n  background: inherit;\n  color: var(--primary);\n}\n\n.simple-square-btn:hover {\n  color: var(--dark);\n}\n\n.red {\n  color: var(--primary);\n}\n\n.lp-btn:hover {\n  background-color: inherit;\n  color: var(--black);\n}\n\n.lp-btnn:hover {\n  background-color: inherit;\n  color: var(--black);\n}\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #e11f1c;\n  border-radius: 10px;\n}\n\n.custom-scroll::-webkit-scrollbar {\n  width: 4px;\n}\n\n.custom-scroll::-webkit-scrollbar-thumb {\n  background-color: #e11f1c;\n  border-radius: 10px;\n}\n\n.open-sidebar .main-section {\n  left: 172px !important;\n}\n\n.scroll-icon-wrapper {\n  width: 50px;\n  height: 50px;\n  position: fixed;\n  bottom: 20px;\n  right: 22px;\n  transform: translateY(-130%);\n  z-index: 1;\n  cursor: pointer;\n}\n\n.scroll-icon-wrapper img {\n  width: 100%;\n  height: 100%;\n}\n\n.pure-section-text {\n  width: 75%;\n  margin: auto;\n  text-align: center;\n}\n\n.custom-section.pure-section {\n  padding: 4rem;\n}\n\n.pure-section .section-title {\n  padding-bottom: 0rem;\n  margin-bottom: 1rem;\n}\n\n/* investment page changes */\n.user-invest-main {\n  padding: 5px 0 !important;\n}\n\n.investment-page .section-title {\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  font-size: 28px;\n}\n\n.investment-section .section-title {\n  color: var(--white);\n  font-size: 3rem;\n  width: 80%;\n  text-align: center !important;\n  margin-bottom: 1rem !important;\n  text-shadow: 1px 1px grey;\n}\n\n.investment-section .normal-p {\n  color: var(--white);\n  text-align: center;\n  width: 80%;\n  text-shadow: 1px 1px grey;\n}\n\n.investment-page .pure-section-text {\n  text-align: justify;\n  text-align-last: center;\n}\n\n.pure-card h3 {\n  padding-bottom: 2rem;\n}\n\n.pure-card p {\n  text-align: justify;\n}\n\n.light-bg {\n  background-color: var(--light) !important;\n}\n\n.lighter-bg {\n  background-color: var(--light-gray);\n}\n\n.normal-lh,\n.normal-lh * {\n  line-height: 1.5rem;\n}\n\n.tree-bg {\n  background: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.5),\n      rgba(12, 12, 12, 0.5)\n    ),\n    url(./../images/banner-bg.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n/* fazal css  */\n.dashboard-main {\n  /* display: flex; */\n  /* margin-left: 78px; */\n  display: flex;\n  overflow: hidden;\n}\n\n.tooltip.bs-tooltip-top {\n  background-color: red !important;\n}\n\n.sidebar {\n  z-index: 999;\n  left: 0 !important;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden !important;\n  /* position: unset; */\n}\n\n.open-admin-sidebar {\n  left: 0;\n}\n\n.dashboard-section-main {\n  margin-left: 78px;\n  display: block !important;\n  width: 100%;\n  /* background: var(--light); */\n  background-color: #f3f3f3;\n}\n\n.dashboard-section-main .MuiGrid-item:not(.db-chart) {\n  /* margin: 0.7em; */\n  padding: 0;\n}\n\n.custom-box {\n  background-color: #fff;\n  box-shadow: 0px 4px 20px 0px #00000026;\n  border-radius: 30px;\n  padding: 50px;\n}\n\n.custom-box.cutting-box {\n  width: 80%;\n  padding: 2em;\n  width: 100%;\n  transform: translateY(-100px);\n}\n\n.light-img-bg {\n  background: url(\"./../images/light-bg.jpg\") !important;\n}\n\n.custom-box.login {\n  padding: 4em 1em;\n  border-radius: 0.6em;\n}\n\n.dashboard-section-main .MuiGrid-container:not(.db-container) {\n  /* background-color: #fff; */\n  /* box-shadow: 0 3px 5px -3px #a2a2a2; */\n  /* border-radius: 5px; */\n  /* padding: 1rem; */\n}\n\n.deshboard-header-wrapper {\n  /* display: flex; */\n  justify-content: space-between;\n  align-items: center;\n}\n\n.jtc-share {\n  background-color: #e0201c;\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 6px;\n  margin-top: 20px;\n}\n\n.jtc-share h2 {\n  font-family: \"Poppins\", sans-serif;\n  color: var(--white);\n  font-weight: 500;\n  font-size: 1.5rem;\n  margin-bottom: 1em;\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.dashboard-share-box {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.dashboard-share-box .text {\n  padding: 0.5rem;\n  margin-bottom: 5px;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-share-box .text.index1 {\n  margin-right: 5px;\n}\n\n.dashboard-share-box .text.index2 {\n  margin-left: 5px;\n}\n\n.dashboard-share-box .text.index3 {\n  margin-right: 5px;\n}\n\n.dashboard-share-box .text.index4 {\n  margin-left: 5px;\n}\n\n.dashboard-share-box .text h3 {\n  margin: 0px;\n  font-family: \"Poppins\", sans-serif;\n  color: #212529;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.dashboard-share-box .text h4 {\n  margin: 0px;\n  font-family: \"Poppins\", sans-serif;\n  color: #212529;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.dashboard-section-main header {\n  background: rgba(255, 255, 255, 1);\n  box-shadow: none;\n}\n\n.db-container {\n  justify-content: center;\n}\n\n.dashboard-chart .apexcharts-toolbar {\n  display: none;\n}\n\n.filter-drop-down {\n  display: flex;\n  justify-content: end;\n  position: relative;\n}\n\n.filter-drop-down .select {\n  display: flex;\n  padding: 0.5rem 0.5rem 0.5rem 0.8rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  justify-content: space-between;\n  align-items: center;\n  width: 200px;\n  cursor: pointer;\n}\n\n.filter-drop-down h3 {\n  text-transform: capitalize;\n  margin: 0px;\n  font-family: \"Poppins\", sans-serif;\n  color: #212529;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.filter-drop-down svg {\n  font-size: 24px;\n  color: #e0201c;\n}\n\n.filter-drop-down .options {\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  position: absolute;\n  width: 100%;\n  z-index: 10;\n  height: 0px;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  animation: dropdownAnimationn 0.5s ease forwards;\n  cursor: pointer;\n}\n\n@keyframes dropdownAnimationn {\n  0% {\n    height: 300%;\n    overflow: unset;\n    opacity: 1;\n  }\n\n  100% {\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n  }\n}\n\n@keyframes dropdownAnimation {\n  0% {\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n  }\n\n  100% {\n    height: 300%;\n    overflow: unset;\n    opacity: 1;\n  }\n}\n\n.filter-drop-down .options.active {\n  transition: opacity 0.3s ease;\n  animation: dropdownAnimation 0.5s ease forwards;\n}\n\n.filter-drop-down .options ul {\n  padding: 0;\n  margin: 0;\n}\n\n.filter-drop-down .options li {\n  padding: 0.5rem 0.5rem 0.5rem 0.8rem;\n  list-style: none;\n}\n\n/* body{\n  overflow: hidden;\n} */\n.modal-li-flex {\n  display: flex;\n  align-items: center;\n}\n\n.MuiDataGrid-root.MuiDataGrid-root--densityStandard {\n  border: none !important;\n}\n\n.MuiDataGrid-row.even {\n  background-color: var(--light);\n}\n\n.MuiTablePagination-displayedRows,\n.MuiTablePagination-selectLabel {\n  margin-bottom: 0;\n}\n\n.MuiDataGrid-row .MuiGrid-container {\n  background-color: inherit;\n  box-shadow: none;\n}\n\n.MuiDataGrid-columnHeaderDraggableContainer {\n  background-color: white !important;\n}\n\n.MuiDataGrid-cell {\n}\n\n.MuiDataGrid-cell:nth-child(even) {\n}\n\n.flex-with-title {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding-left: 10px;\n  flex-wrap: wrap;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: #a6a6a6;\n}\n\n.landing-main {\n  display: flex;\n}\n\n.landing-main-page {\n  height: 100vh !important;\n  width: 100%;\n}\n\n/* login form */\n\n/* Investor Slider----------------------------------------------------------------------- */\n.rounded-square-img {\n  width: 100%;\n  aspect-ratio: 5/5;\n  display: flex;\n  align-items: center;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.investor-slider {\n  overflow: hidden;\n}\n\n.investor-slider .slick-list {\n  border-right: 1px solid #fff;\n}\n\n.rounded-square-img img {\n  width: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n\n.person-item-desc {\n  font-size: 0.8rem;\n  margin-bottom: 5px;\n  letter-spacing: 1px;\n  color: var(--dark);\n}\n\n.person-item-days {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.person-item-wrapper {\n  border-right: 1px solid var(--light-gray);\n}\n\n/* Investor Slider End----------------------------------------------------------------------- */\n\n/* Open section -------------------------------------------------------------------- */\n\n.pitch-card-wrapper {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 6/7;\n  border-radius: 5px;\n  margin-top: 4.8rem;\n}\n\n.card-text {\n  letter-spacing: 1px;\n  font-size: 0.9rem;\n  line-height: 1.3rem;\n  margin-bottom: 0.5em;\n}\n\n.card-subtitle {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.pitch-card {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform-style: preserve-3d;\n  transition: all 0.5s ease;\n  border-radius: 5px;\n}\n\n.pitch-card-item {\n  padding: 1em;\n  background-color: rgba(255, 255, 255, 0.15);\n  margin-bottom: 1em;\n  border-radius: 5px;\n}\n\n.flex-p {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0;\n  font-size: 0.9rem;\n  color: inherit;\n}\n\n.white {\n  color: var(--white);\n  color: #e11f1c;\n  cursor: pointer;\n}\n\n.flex-p span:first-child {\n  font-weight: 500;\n  letter-spacing: 1px;\n  opacity: 0.8;\n}\n\n.muted-text {\n  opacity: 0.8;\n}\n\n.muted-md {\n  opacity: 0.75;\n}\n\n.white-muted {\n  color: var(--white);\n  opacity: 0.8;\n}\n\n.pitch-card-front {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -ms-backface-visibility: hidden;\n  -o-backface-visibility: hidden;\n  backface-visibility: hidden;\n  padding: 1em;\n  border-radius: 5px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 0px 1px #a6a6a688;\n}\n\n.pitch-card-back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -ms-backface-visibility: hidden;\n  -o-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transform: rotateY(180deg);\n  padding: 1em;\n  border-radius: 5px;\n  backdrop-filter: brightness(0.5);\n  -webkit-backdrop-filter: brightness(0.5);\n  border-radius: 5px;\n}\n\n.pitch-card-front img {\n  width: 100%;\n  height: 100%;\n}\n\n.pitch-card:hover {\n  transform: rotateY(180deg);\n}\n\n.open-header {\n  /* padding-right: 1em; */\n  padding-top: 2rem !important;\n}\n\n.open-header ul:not(.open-header-sub-menu) > li {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);\n}\n\n.open-header ul {\n  display: flex;\n  padding-left: 0;\n  margin-bottom: 0;\n  flex-direction: column;\n}\n\n.open-pitch ul {\n  display: block;\n}\n\n.open-pitch {\n  padding-right: 1em;\n}\n\n.open-pitch section dl div p:nth-child(1) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n}\n\n.open-pitch section dl div p:nth-child(2) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(3) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(4) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(5) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(6) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(7) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(8) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(9) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(10) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(11) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(12) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(13) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(14) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(15) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(16) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(17) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(18) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(19) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(20) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(21) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(22) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(23) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(24) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(25) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(26) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(27) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(28) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(29) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(30) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(31) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(32) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(33) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(34) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(35) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(36) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(37) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(38) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-pitch section dl div p:nth-child(39) {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.open-pitch section dl div p:nth-child(40) {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.open-section {\n  min-height: 100vh;\n}\n\n.open-section dt {\n  font-size: 1.3rem;\n  color: var(--dark);\n  margin-bottom: 0.5em;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);\n}\n\n.open-section .section-title {\n  padding: 2rem 0 0.7em;\n  text-align: start;\n  font-size: 24px;\n  text-transform: uppercase;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.open-header li {\n  /* padding-bottom: 50px; */\n  margin-bottom: 1em;\n  font-weight: 700;\n  color: var(--dark-gray);\n  cursor: pointer;\n}\n\n.open-header-sub-menu {\n  margin-left: 0.5em;\n  box-shadow: inset 1px 0 rgba(0, 0, 0, 0.1);\n  transition: all 1s ease;\n  margin-bottom: 1em !important;\n}\n\n.open-header-sub-menu li {\n  padding-bottom: 0;\n  padding-left: 0.5em;\n}\n\n.open-header-sub-menu li:last-child {\n  margin-bottom: 0 !important;\n}\n\n.open-header-sub-menu li.active {\n  color: var(--primary);\n  border-bottom: none !important;\n}\n\n.open-header li.active {\n  border-bottom: 3px solid var(--primary);\n  color: var(--primary);\n}\n\n.open-header li:hover {\n  color: var(--primary);\n}\n\n.deal-term-wrapper {\n  background: var(--grey-bg);\n  padding: 1em;\n  border-radius: 5px;\n  border: 1px solid var(--light-gray);\n}\n\n.deal-term {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.08);\n  padding-bottom: 1em;\n  margin-bottom: 1em;\n  color: var(--dark);\n}\n\n.deal-term p {\n  margin: 0;\n  letter-spacing: 1px;\n}\n\n.deal-term-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.deal-term-title,\n.deal-term-desc {\n  font-size: 0.9rem;\n}\n\n.deal-term-stat {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.deal-term-body {\n  max-height: 0;\n  overflow: hidden;\n  transition: all 1s ease-in-out;\n}\n\n.deal-term:hover .deal-term-body {\n  max-height: 1000px;\n}\n\n/* @keyframes slideup {\n  0%{\n    max-height: 0;\n  }\n  100%{\n    max-height: 1000px;\n  }\n} */\n.deal-term:hover .icon svg {\n  color: var(--primary);\n}\n\n.section-img {\n  aspect-ratio: 5/3;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  margin-bottom: 1em;\n}\n\n.section-img img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.open-pitch-video {\n  width: 100%;\n  aspect-ratio: 5/4;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* Open section End-------------------------------------------------------------------- */\n\n/* Blog section of landing page */\n\n.blog-card {\n  background-color: var(--white);\n  border-radius: 0.3rem;\n  overflow: hidden;\n  box-shadow: 1px 1px 1px 1px var(--light-gray);\n  height: 450px;\n  position: relative;\n}\n\n.blog-card-footer p {\n  margin-bottom: 0;\n}\n\n.line-ellipse {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.footer-img {\n  width: 100%;\n}\n\n.footer-img img {\n  width: 100%;\n  border-radius: 5px;\n  opacity: 0.9;\n}\n\n.blog-card-img {\n  height: 100%;\n}\n\n.blog-card-img img {\n  width: 100%;\n  height: 250px;\n}\n\n.blog-card-title {\n  font-size: 1.3rem;\n  color: var(--dark);\n  margin-bottom: 0.3em;\n  font-weight: 600;\n  line-height: 1.5em;\n  letter-spacing: 0px;\n}\n\n.blog-card-body-wrapper {\n  padding: 1em;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background: var(--white);\n  width: 100%;\n}\n\n.t-card-item .card-title {\n  font-family: \"Poppins\";\n  color: var(--dark);\n  padding-bottom: 3px;\n}\n\n.icon-img {\n  min-width: 45px;\n  max-width: 45px;\n  min-height: 45px;\n  max-height: 45px;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.icon-img img {\n  width: 100%;\n  height: 100%;\n}\n\n.blog-card-footer {\n  display: flex;\n  gap: 1em;\n}\n\n.card-person {\n  font-weight: 600;\n  line-height: 1.4rem;\n  letter-spacing: 1px;\n}\n\n.card-time {\n  font-size: 0.7rem;\n}\n\n.card-desc {\n  font-size: 0.9rem;\n  letter-spacing: 1px;\n  line-height: 1rem;\n  max-height: 3rem;\n  overflow: hidden;\n}\n\n.blog-section .slick-arrow::before {\n  color: var(--primary);\n  font-size: 1.5rem;\n}\n\n.blog-section .slick-next,\n.team-section .slick-next,\n.testimonial-section .slick-next,\n.investors-section .slick-next {\n  right: -5px;\n}\n\n.blog-section .slick-prev,\n.team-section .slick-prev,\n.testimonial-section .slick-prev,\n.investors-section .slick-prev {\n  left: -9px;\n}\n\n.text-body {\n  white-space: pre-line;\n  letter-spacing: 0;\n}\n\n.team-section .slick-arrow::before {\n  color: var(--primary);\n  font-size: 1.5rem;\n}\n\n.team-title {\n  line-height: 1.4em;\n  display: flex;\n  align-items: center;\n}\n\n.member-open-card {\n  min-height: 500px;\n  border-radius: 1em 1em 0px 0px;\n}\n\n.testimonial-card {\n  background: var(--white);\n  padding: 1em;\n  border-radius: 0.3rem;\n  box-shadow: 1px 1px 1px 0px var(--light-gray);\n  position: relative;\n}\n\n.testimonial-card .quote-icon {\n  position: absolute;\n  font-size: 3rem;\n  color: var(--dark);\n}\n\n.testimonial-card .quote-icon:first-child {\n  top: 0;\n  left: 0;\n  right: 0;\n  margin-inline: auto;\n  transform: translateY(-50%);\n}\n\n.testimonial-card .quote-icon:nth-child(2) {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-inline: auto;\n  transform: translateY(50%);\n}\n\n.testimonial-card .row {\n  align-items: center;\n}\n\n.testimonial-card .image-wrapper {\n  aspect-ratio: 1/1;\n  border-radius: 50%;\n  width: 70%;\n  overflow: hidden;\n  margin: auto;\n}\n\n.image-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.image-wrapper img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.custom-card-title {\n  margin-block: 0.5rem;\n  text-align: start;\n  font-size: 24px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.icon {\n  width: 30px;\n  height: 30px;\n  font-size: 1.5rem;\n}\n\n.text-icon {\n  font-size: 1.5rem;\n}\n\n.card-line {\n  width: 10%;\n  height: 5px;\n  background: var(--primary);\n}\n\n.rating-stars {\n  display: flex;\n  gap: 0.5em;\n}\n\n.rating-stars svg {\n  font-size: 1.5rem;\n  color: #ce9f56;\n}\n\n.testimonial-section .slick-arrow::before {\n  color: var(--primary);\n  font-size: 1.5rem;\n}\n\n/* Blog page */\n.blog-title {\n  text-align: start;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--dark);\n  position: relative;\n  letter-spacing: 0px;\n  font-weight: 500;\n  line-height: 2.5rem;\n}\n\n.blog-desc {\n  padding-top: 10px;\n}\n\n.blog-title::after {\n  position: absolute;\n  content: \"\";\n  width: 5%;\n  height: 5px;\n  background-color: var(--primary);\n  left: 0;\n  bottom: -10px;\n}\n\n.blog-main-img {\n  /* overflow: hidden; */\n  display: flex;\n  aspect-ratio: 5/2;\n  align-items: center;\n}\n\n.blog-main-img img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.blog-page .blog-card-wrapper {\n  padding-inline: 0 !important;\n}\n\n.blog-desc,\n.blog-page dd {\n  font-size: 1rem;\n  letter-spacing: 1px;\n  font-weight: 500;\n  line-height: 1.5rem;\n  text-align: justify;\n}\n\n.blog-page dt {\n  font-size: 1.3rem;\n  color: var(--dark);\n  margin-bottom: 0.5em;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.1);\n  display: inline-block;\n}\n\n.blog-page ul {\n  list-style-type: disc;\n  line-height: 2em;\n}\n\n.blog-page .blog-card {\n  box-shadow: none;\n  border: 1px solid var(--light-gray);\n}\n\n.blog-main {\n  padding: 1em;\n}\n\n/* notice section */\n\n.MuiGrid-root.MuiGrid-container.css-11lq3yg-MuiGrid-root {\n  /* background-color: transparent; */\n  padding: 10px;\n  justify-content: center !important;\n  flex-wrap: wrap !important;\n  border-radius: 10px;\n}\n\n.share-type {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding: 20px;\n  gap: 10px;\n}\n\n.dashboard-section-main .share-type {\n  justify-content: start;\n  padding-inline: 0px;\n  gap: 10px;\n}\n\n.active_type {\n  background-color: #dc3545;\n  color: #ffff;\n}\n\n.form-control-radio {\n  font-size: 20px;\n  line-height: 1.1;\n  color: #000000;\n  display: grid;\n  grid-template-columns: 1em auto;\n  gap: 0.5em;\n}\n\n.footer-icons img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.content-wrapper-landing {\n  display: block;\n  line-height: 1rem;\n  max-height: 4rem;\n  overflow: hidden;\n}\n\n/* investors pitch */\n\n.header-logo {\n  width: 70%;\n}\n\n.banner-header {\n  /* background: url('./../images/header_bg.png'); */\n  padding: 2%;\n  margin-top: 72px;\n}\n\n.banner-header-row {\n  background-color: #181818;\n  /* margin: 20px; */\n  border-radius: 20px;\n  padding: 1%;\n}\n\n.primary-tabs-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0 3em;\n  margin: 0 3%;\n  padding-left: 0;\n  justify-content: flex-start;\n}\n\n.primary-tab {\n  font-weight: 500;\n  font-size: 1.1rem;\n  opacity: 0.4;\n  border-bottom: 3px solid transparent;\n  /* color: #A4A4A4; */\n  font-family: \"poppins\";\n  width: max-content;\n}\n\n.primary-tab.active {\n  border-color: var(--primary);\n  color: var(--primary) !important;\n  opacity: 1;\n  font-weight: 600;\n}\n\n.flex-wrap-items {\n  display: flex;\n  gap: 1em;\n  align-items: center;\n}\n\n.flex-wrap-items.flex-sm {\n  gap: 0.5em;\n}\n\n.flex-space {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.md-icon {\n  font-size: 3rem;\n}\n\n.md-icon.img-icon {\n  height: 50px;\n}\n\n.primary-box {\n  background-color: var(--lighter-gray);\n  padding: 1.5em;\n  border-radius: 0.5em;\n}\n\n.dark-box {\n  background-color: var(--dark);\n  padding: 1.5em;\n  border-radius: 0.5em;\n}\n\n.dark-box .para {\n  color: var(--light);\n}\n\n.custom-table {\n  width: 100%;\n}\n\n.custom-table thead {\n  background-color: var(--dark);\n}\n\n.custom-table:not(.square-table) tr td:first-child,\n.custom-table:not(.square-table) tr th:first-child {\n  border-radius: 30px 0 0 30px;\n}\n\n.custom-table:not(.square-table) tr td:last-child,\n.custom-table:not(.square-table) tr th:last-child {\n  border-radius: 0 30px 30px 0;\n}\n\n.custom-table:not(.square-table) tr td:only-child,\n.custom-table:not(.square-table) tr th:only-child {\n  border-radius: 30px !important;\n}\n\n.square-table tr td:first-child,\n.square-table tr th:first-child {\n  border-radius: 15px 0 0 15px;\n}\n\n.square-table tr td:last-child,\n.square-table tr th:last-child {\n  border-radius: 0 15px 15px 0;\n}\n\n.square-table tr td:only-child,\n.square-table tr th:only-child {\n  border-radius: 15px !important;\n}\n\n.custom-table tr.active {\n  background-color: var(--primary) !important;\n  color: var(--light);\n  position: relative;\n}\n\n.custom-table tr.active-dark {\n  background-color: var(--dark) !important;\n  color: var(--light);\n}\n\n.custom-table td.active-dark td {\n  padding: 0.8em;\n}\n\n.custom-table td.active-light {\n  background-color: var(--light);\n}\n\n.custom-table.active-light td {\n  padding: 0.8em;\n}\n\n/* .custom-table tr td:nth-last-child(2).active,\n.custom-table tr td:nth-last-child(2).active-dark {\n  border-radius: 15px 0 0 15px;\n} */\n\n.start-cell {\n  border-radius: 30px 0 0 30px;\n}\n\n.end-cell {\n  border-radius: 0 30px 30px 0;\n}\n\n.only-cell {\n  border-radius: 15px !important;\n}\n\n.only-cell.active {\n  padding: 0.8em;\n  border-radius: 15px;\n  padding-inline: 3em;\n}\n\n.custom-table tr.active + tr:not(.active) {\n  background-color: transparent !important;\n}\n\n.custom-table tr td.active,\n.custom-table tr th.active {\n  background-color: var(--primary);\n  color: var(--light);\n}\n\n.custom-table tr {\n  border-top: 10px solid var(--light);\n  border-bottom: 10px solid var(--light);\n}\n\n.custom-table.table-white tr,\n.custom-table.plain-table tr {\n  border-color: #fff;\n}\n\n.custom-table tr td.active-dark,\n.custom-table tr th.active-dark {\n  background-color: var(--dark);\n  color: var(--light);\n}\n\n.custom-table tr.active td {\n  padding: 0.8em;\n}\n\n.custom-table td.full-cell {\n  border-radius: 15px !important;\n}\n\n.custom-table .lead-row td {\n  font-weight: 700;\n  opacity: 0.9;\n}\n\n.custom-table .lead-cell {\n  font-weight: 700;\n  opacity: 0.9;\n}\n\n.custom-table thead th {\n  color: var(--light);\n  font-weight: 400;\n  padding: 1em;\n  white-space: nowrap;\n}\n\n.table-white {\n  background-color: #fff;\n  border-radius: 15px;\n}\n\n/* \n.custom-table tbody tr:first-child:not(.active, .active-dark) td {\n  padding-top: 1em;\n} */\n\n.custom-table tbody td {\n  font-weight: 400;\n  padding: 0.3em 1em;\n  white-space: nowrap;\n}\n\n.custom-table:not(.plain-table) tbody tr:nth-child(even) {\n  background-color: var(--light-gray);\n}\n\n.custom-table.plain-table .light-row {\n  background-color: var(--light-gray);\n}\n\n.border-bottom {\n  border-bottom: 1px solid #727272;\n}\n\n.row-badge-wrapper {\n  position: relative;\n}\n\n.chart-container {\n  background-color: #fff;\n  padding: 1em 1em 0 0;\n}\n\n.row-badge {\n  position: absolute;\n  left: -35px;\n  top: -16px;\n  padding: 0.6em;\n  aspect-ratio: 1;\n  background-color: var(--white);\n  border-radius: 50%;\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  box-shadow: 4px 4px 7px rgba(0, 0, 0, 0.35);\n}\n\n.badge-cell {\n  margin-left: 1.3em;\n}\n\n.financial-chart .recharts-legend-wrapper {\n  left: 0 !important;\n}\n\n.color-sector {\n  clip-path: circle(79.1% at 22% 84%);\n  width: 65px;\n  height: 65px;\n}\n\n.color-sector.gray-sector {\n  background-color: #d3d3d3;\n}\n\n.color-sector.dark-sector {\n  background-color: #3e3e3e;\n}\n\n.color-sector.red-sector {\n  background-color: #dc2023;\n}\n\n.color-sector.pink-sector {\n  background-color: #ff6d6a;\n}\n\n.dark-cell {\n  background-color: var(--dark);\n}\n\n.custom-th {\n  font-size: 1.1rem;\n  font-weight: 500;\n  height: 60px;\n  border-radius: 10px;\n  padding-inline: 1em;\n  gap: 0.5em;\n  display: flex;\n  align-items: center;\n  color: var(--light);\n}\n\n.primary-cell {\n  background-color: var(--primary);\n}\n\n.dark-cell-sm {\n  padding: 0.3em 1em;\n  background-color: var(--dark);\n  border-radius: 10px;\n  color: var(--light);\n  margin: 2px 0;\n}\n\n.light-cell-sm {\n  padding: 0.3em 1em;\n  background-color: var(--light-gray);\n  border-radius: 10px;\n  margin: 2px 0;\n}\n\n.primary-cell-sm {\n  padding: 0.3em 1em;\n  background-color: var(--primary);\n  color: var(--light);\n  border-radius: 10px;\n  margin: 2px 0;\n}\n\n.shrink-table .custom-row {\n  padding-block: 0.5em;\n}\n\n.custom-row {\n  padding-block: 1.5em;\n}\n\n.custom-row .row-badge {\n  font-size: 0.8rem;\n  top: -5px;\n  left: 0;\n}\n\n.primary-selector .dropdown-toggle,\n.primary-selector .dropdown-toggle:active,\n.primary-selector .dropdown-toggle:focus-visible {\n  background: var(--primary);\n  border: none;\n  box-shadow: none;\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.4em;\n}\n\n.primary-selector .dropdown-menu {\n  max-height: 220px;\n  overflow: auto;\n}\n\n.primary-selector.grayscale .dropdown-toggle,\n.primary-selector.grayscale .dropdown-toggle:active,\n.primary-selector.grayscale .dropdown-toggle:focus-visible {\n  background: var(--lighter);\n  color: var(--dark);\n  flex-direction: row-reverse;\n}\n\n.primary-selector .dropdown-toggle::after {\n  display: none;\n}\n\n.pagination-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 0.5rem;\n}\n\n.pagination-button {\n  background-color: var(--light-gray);\n  border: none;\n  color: var(--dark);\n  font-size: 1rem;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  aspect-ratio: 1/1;\n  width: 2.1rem;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.primary-selector .dropdown-item.active,\n.primary-selector .dropdown-item:active {\n  background-color: var(--primary);\n}\n\ninput[type=\"checkbox\"] {\n  accent-color: var(--primary);\n  border-color: var(--primary);\n}\n\n.center-cells tr th,\n.center-cells tr td {\n  text-align: center;\n}\n\n.line-blog {\n  line-height: 2.5rem;\n}\n\n.square-dot {\n  width: 12px;\n  height: 12px;\n}\n\n.legend-cell {\n  color: var(--dark);\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.7rem;\n  letter-spacing: 1px;\n}\n\n.Sale-vs-ebitda {\n  color: var(--dark);\n  font-weight: 600;\n  font-size: 0.7rem;\n  letter-spacing: 1px;\n}\n\n.legend-cell_1 {\n  color: var(--dark);\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.9rem;\n  letter-spacing: 1px;\n}\n\n.legend-entry {\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n  font-size: 0.9rem;\n}\n\n.legend-entry:not(.last) {\n  border-bottom: 1px solid var(--dark-gray);\n}\n\n.join-banner {\n  /* background: rgba(228, 228, 228, 0.15); */\n  width: 100%;\n  padding: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1em;\n  border-top: 1px solid #dadada;\n  margin-top: 72px;\n  background-color: #404040;\n}\n\n.join-banner p {\n  font-size: 14px;\n  color: var(--light);\n  text-align: start;\n  letter-spacing: 0;\n}\n\n.join-banner-news {\n  /* background: rgba(228, 228, 228, 0.15); */\n  width: 100%;\n  display: flex;\n  align-items: center;\n  /* justify-content: center; */\n  gap: 1em;\n  border-top: 1px solid #dadada;\n  /* margin-top: 72px; */\n  background-color: #000000;\n}\n\n.join-banner-news p {\n  font-size: 14px;\n  /* color: yellow; */\n  color: #fff;\n  text-align: start;\n  letter-spacing: 0;\n  /* margin-bottom: 12px !important; */\n}\n.join-banner-news marquee {\n  font-size: 15px;\n  /* color: yellow; */\n  color: #fff;\n  text-align: start;\n  letter-spacing: 0;\n  /* margin-bottom: 12px !important; */\n}\n\n.sales-growth-chart p {\n  background: #2f80f5;\n  color: var(--light);\n  padding: 0.3em;\n}\n\n.chart-stroke {\n  border: 1px solid #e7e7e7;\n}\n\n.layout_container {\n  font-family: \"Roobert\";\n  min-height: 100vh;\n  background: url(../../../public/images/profit-background.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.card-1 {\n  width: 500px;\n  height: 480px;\n  padding: 3rem;\n  box-sizing: border-box;\n  background: #322727;\n  overflow: hidden;\n  color: #fff;\n}\n\n.card-2 {\n  width: 400px;\n  height: 480px;\n  box-sizing: border-box;\n  background: #e11f1c;\n  overflow: hidden;\n  color: #fff;\n  padding: 1rem 1rem 1rem 2rem;\n}\n\n.layout_container > .row {\n  margin-top: 2.8rem;\n}\n\n.layout-text-profit {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  margin: 3.2rem;\n  color: #fff;\n}\n\n.layout_currency-text {\n  font-size: 19px;\n  width: auto;\n  border-radius: 20px;\n  height: auto;\n  margin-top: -10px;\n  background-color: #e11f1c;\n  padding: 6px 16px;\n}\n\n.primary-btn-profit {\n  display: inline-block;\n  padding: 13px 25px;\n  background: #e11f1c;\n  border-radius: 40px;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 28px;\n  color: white;\n  text-transform: capitalize;\n  text-align: center;\n  -webkit-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n  width: fit-content;\n  border: none;\n}\n\n.primary-btn-profit:hover {\n  background: white;\n  color: #e11f1c;\n}\n\n.select-option-profit {\n  background-color: #e11f1c;\n  color: #fff;\n  border: none;\n  margin-top: -14px;\n  /* width: 110px;\n  height: 40px; */\n  font-weight: 600;\n  border-radius: 10px;\n  padding-left: 10px;\n}\n\n.custome-slider-widget {\n  margin-left: 15px;\n}\n\n.line-red {\n  background-color: #e11f1c;\n  width: 4px;\n  height: 70%;\n  margin-left: 30px;\n}\n\n.red-text-reg {\n  color: #e11f1c;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.black-text-reg {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n/* Content Page Css */\n\n.Content-Main-Heading-container {\n  margin: 2% 3%;\n  background-color: #d71f26;\n  border-radius: 20px;\n  position: relative;\n  height: 200px;\n}\n\n.Double-heading-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.Content-main-heading-1 {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 3.75rem;\n  font-weight: 600;\n  color: #ffffff;\n  text-shadow: -15px -10px 0 rgba(255, 255, 255, 0.1);\n}\n\n.Table-of-content-main {\n  margin: 3%;\n  border-radius: 20px;\n  background-color: #ffffff;\n  padding: 2% 2% 2% 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.Table-of-content-inner {\n  flex: 1;\n}\n\n.TOC-rows {\n  display: flex;\n}\n\n.TOC-Row {\n  /* flex-wrap: wrap; */\n  /* min-width: 280px; */\n}\n\n.TOC-rows-num {\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: #3e3e3e;\n  /* width: 90px; */\n  padding: 0 6%;\n  display: flex;\n  align-items: center;\n  height: 50px;\n}\n\n.TOC-rows-title {\n  padding: 4px;\n}\n\n.TOC-row-h {\n  color: #d71f26 !important;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.15px;\n  cursor: pointer;\n}\n\n.TOC-row-d {\n  color: #3e3e3e;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.15px;\n}\n\n.separator {\n  width: 90%;\n  color: #cecece;\n  margin: 5px auto;\n}\n\n.Heading-row {\n  display: flex;\n  background-color: #3e3e3e;\n  color: white;\n  margin: 3%;\n  padding: 1% 2%;\n  border-radius: 10px;\n}\n\n.Heading-row {\n  flex: 1;\n}\n\n.Heading-row > table {\n  flex: 1;\n}\n\n.link-container {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n}\n\n.Investors-pitch-nav {\n  padding: 0 4%;\n  margin-bottom: -1px !important;\n}\n\n.navbar-toggler {\n  margin: 10px 0;\n  border: none;\n}\n\n.Business-value-main-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.Business-value-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: 10px;\n  justify-content: flex-start;\n}\n\n.Business-value-box {\n  margin: 10px;\n}\n\n/* new login form v2*/\n.New-login-form-main {\n  background-image: url(\"../../assets/images/Newlogin-back.png\");\n  /* background-position: center; */\n  background-position: bottom center !important;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: #f9f9f9;\n  height: 100vh;\n}\n\n.New-login-form-inner {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 2% 6%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.New-login-form-Content {\n  flex: 1.5;\n  justify-content: center;\n  flex-wrap: nowrap !important;\n  align-items: center;\n}\n\n.New-login-bold-text {\n  font-weight: 600;\n  font-size: 20px;\n  font-family: \"poppins\";\n  letter-spacing: 0.5px;\n}\n\n.New-login-normal-text {\n  font-weight: 400;\n  font-size: 18px;\n  font-family: \"poppins\";\n  letter-spacing: 0.5px;\n  margin-bottom: 5%;\n}\n\n.login-youtube-video {\n  border-radius: 10px;\n}\n\n.Centre-the-content {\n  text-align: center;\n}\n\n.New-login-form-form {\n  flex: 1;\n  background-color: white;\n  border-radius: 10px;\n  padding: 3% 3% 0 3%;\n  height: fit-content;\n  box-shadow: 0px 0px 25px rgb(211, 211, 211);\n  margin-left: 7%;\n  margin-right: 2%;\n}\n\n.New-login-form-logo {\n  margin: 0 auto;\n  width: 150px;\n  cursor: pointer;\n}\n\n.New-login-form-heading {\n  font-family: \"poppins\";\n  font-weight: 400;\n  font-size: 20px;\n  letter-spacing: -0.5px;\n}\n\n.New-login-form-heading-2 {\n  font-family: \"poppins\";\n  font-weight: 600;\n  font-size: 20px;\n  letter-spacing: -0.5px;\n}\n\n.Login-type-btn-container {\n  margin: 25px 0 0 0;\n}\n\n.Login-type-btn {\n  border: none;\n  margin: 5px;\n  background-color: transparent;\n  color: #a7a6a6;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"poppins\";\n}\n\n.forget-password-btn {\n  background-color: transparent;\n  border: none;\n  color: var(--primary);\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"poppins\";\n}\n\n.Form-checkbox-holder {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Login-btn-container {\n  text-align: center;\n}\n\n.Login-btn-container > button {\n  padding: 2%;\n  width: 100%;\n  background-color: var(--primary);\n  border-radius: 10px;\n  border: none;\n  color: white;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: \"poppins\";\n  margin-top: 25px;\n}\n\n.signup-text-login-form {\n  color: var(--primary);\n  font-weight: 500;\n  font-size: 16px;\n  border: none;\n  background-color: transparent;\n}\n\n.Input-custom-for-login {\n  background-color: #ededed;\n  border-radius: 5px;\n  border: none;\n  height: 55px;\n  color: #3e3e3e;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"poppins\";\n}\n\n.Input-custom-for-login:focus {\n  background-color: #ededed;\n}\n\n.Input-field-icons-body {\n  border: none;\n  background-color: #ededed;\n  color: #3e3e3e;\n}\n\n.Input-field-icons {\n  width: 20px !important;\n}\n\n.button-red-active {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  font-family: \"poppins\";\n  color: var(--primary) !important;\n}\n\n.pageloader {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n}\n\n.pageloader div {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.card-shares-investor {\n  border-radius: 20px;\n  margin: 30px;\n  background-color: #ebebeb;\n}\n\n.circle-checkout {\n  margin-right: 10px;\n  margin-top: -6px;\n}\n\n.content-checkout {\n  margin-top: 0px;\n}\n\n.checkout-field-box {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  background-color: #ebebeb;\n  border-radius: 7px;\n}\n\n.checkout-field-box > span {\n  color: #565656;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.info-detail-step > h6 {\n  color: #565656;\n}\n\n.checkout-terms {\n  font-size: 1.3rem;\n  color: #a5a5a5;\n  font-family: \"Raleway\";\n  font-weight: 600;\n}\n\n.black-checkout-name {\n  color: #121212;\n  font-weight: 600;\n}\n\n.cart-box {\n  background-color: #e0201c;\n  color: #ffffff;\n  padding: 10px;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.cart-box > span {\n  color: #ffffff;\n}\n\n.terms-condition {\n  padding: 10px;\n  border-radius: 7px;\n  background-color: #ebebeb;\n}\n\n.terms-condition > span {\n  color: #a5a5a5;\n}\n\n.copy-clabe {\n  color: #d71f26;\n  margin-left: 10px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.transition-div {\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: max-content;\n  min-width: 96px;\n  min-height: 0;\n  padding: 8px 12px;\n  background-color: rgba(50, 50, 51, 0.88);\n  border-radius: 8px;\n  z-index: 9999;\n}\n\n.transition-div p {\n  color: #fff !important;\n  font-size: 14px !important;\n  line-height: 20px;\n  white-space: pre-wrap;\n  text-align: center;\n  word-wrap: break-word;\n  margin: 0 !important;\n}\n\n.transition-div.show {\n  opacity: 1;\n}\n\n/* Ali Work */\n\n.doc-card {\n  margin: 20px 20px;\n  height: 350px;\n}\n\n.other-details {\n  display: flex;\n  padding-left: 20px;\n  flex-direction: column;\n}\n\n.other-details h4 {\n  font-family: \"Raleway\";\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 33px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-top: 40px;\n}\n\n.other-details p {\n  font-family: \"Raleway\";\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 28px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.doc-with-title {\n  padding-left: 20px;\n}\n\n.doc-with-title .doc-title {\n  font-family: \"Bebas Neue\";\n  font-size: 70px;\n  font-weight: 700;\n  line-height: 70px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.NFT-image-upload-txt {\n  display: flex;\n  justify-content: space-between;\n  background: #404040;\n  padding: 17px 16px;\n  border-radius: 10px;\n}\n\n.box-verified {\n  display: flex;\n  justify-content: space-between;\n  background: #404040;\n  padding: 17px 16px;\n  border-radius: 10px;\n}\n\n.NFT-image-upload-txt button {\n  color: #fff;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Raleway\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px;\n  background: transparent;\n  border: none;\n  outline: none;\n}\n\n.box-verified button {\n  color: #fff;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Raleway\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px;\n  border: none;\n  outline: none;\n}\n\n.NFT-image-upload-txt button svg {\n  font-size: 26px;\n  margin-bottom: 4px;\n}\n\n.NFT-image-upload-txt p {\n  color: #9c9c9c;\n  text-align: center;\n  font-size: 14px;\n  font-family: \"Raleway\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px;\n  letter-spacing: 0px;\n}\n\n.profile-nft-row1 .footer-descc {\n  color: #404040;\n  text-align: center;\n  font-size: 16px;\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  padding: 15px 0px !important;\n}\n\n.doc-card .doc-card-status {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  color: #fff;\n  text-align: center;\n  font-size: 16px;\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border-radius: 10px;\n  padding: 4px 8px;\n}\n\n.doc-card .doc-card-status.accepted {\n  background: #00b855;\n}\n\n.doc-card .doc-card-status.rejected {\n  background: #d71f26;\n}\n\n.doc-card .doc-card-status.pending {\n  background: #ff8a00;\n}\n\n.doc-card .doc-card-status.processing {\n  background: blue;\n}\n\n.NFT-image-holder {\n  text-align: center;\n  /* padding: 30px; */\n  background: #f5f5f5;\n  border-radius: 10px;\n}\n\n.NFT-image-holder img {\n  width: 100%;\n}\n\n.doc-card-wrap {\n  height: 100%;\n}\n\n.profile-nft-row1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 380px;\n}\n\n.email-verification-img {\n  width: 180px;\n  height: 130px;\n}\n\n.signature-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.signature-active {\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  overflow: hidden;\n  border-radius: 6px;\n  border: 2px solid #e11f1c;\n}\n\n.signature-option img {\n  width: 150px;\n  margin-top: -32px;\n  /* margin-left: 50px; */\n}\n\n.signature-option {\n  overflow: hidden;\n  width: 150px;\n  margin-top: -32px;\n  /* margin-left: 50px; */\n}\n\n.signature-sec {\n  padding-inline: 20px;\n}\n\n.signature-sec .top .top-1 {\n  display: flex;\n  gap: 15px;\n}\n\n.signature-sec .bottom div:nth-child(1) {\n  flex-direction: column;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(1) {\n  margin: 10px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(2) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(3) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(4) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-option:nth-child(5) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(1) {\n  margin: 10px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(2) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(3) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(4) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) .signature-active:nth-child(5) {\n  margin: 3px 0px 3px 0px;\n  width: 183px;\n  overflow: hidden;\n}\n\n.signature-sec .bottom div:nth-child(1) button {\n  display: inline-block;\n  padding: 5px 10px;\n  background: #e11f1c;\n  border-radius: 6px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: white;\n  text-transform: capitalize;\n  text-align: center;\n  transition: all 0.5s;\n  width: -moz-fit-content;\n  width: fit-content;\n  border: none;\n  margin-top: 10px;\n}\n\n.signature-sec .top .top-1 {\n  display: flex;\n  gap: 15px;\n}\n\n.signature-sec .top .top-1 label input {\n  margin-right: 5px;\n}\n\n.signature-sec .top .top-1 label {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.top .top-2 button:nth-child(2) {\n  display: inline-block;\n  padding: 5px 10px;\n  background: #e11f1c;\n  border-radius: 6px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: white;\n  text-transform: capitalize;\n  text-align: center;\n  transition: all 0.5s;\n  width: -moz-fit-content;\n  width: fit-content;\n  border: none;\n  margin-right: 10px;\n}\n\n.top .top-2 button:nth-child(3) {\n  display: inline-block;\n  padding: 5px 10px;\n  background: #e11f1c;\n  border-radius: 6px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: white;\n  text-transform: capitalize;\n  text-align: center;\n  transition: all 0.5s;\n  width: -moz-fit-content;\n  width: fit-content;\n  border: none;\n}\n\n.top .top-2 #convas {\n  border: 1px solid #dee2e6 !important;\n  touch-action: none !important;\n  width: 100% !important;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-radius: 6px;\n  box-shadow: rgb(244 0 0 / 25%) 0px 2px 5px -1px,\n    rgb(255 0 0 / 30%) 0px 1px 3px -1px;\n}\n\n.top .top-3 {\n}\n\n.top .top-3 input {\n  padding: 5px 10px;\n  width: 100%;\n  margin: 10px 0px;\n  border-radius: 6px;\n  border: 1px solid #525659;\n}\n\n.top .top-3 button {\n  display: inline-block;\n  padding: 5px 10px;\n  background: #e11f1c;\n  border-radius: 6px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: white;\n  text-transform: capitalize;\n  text-align: center;\n  transition: all 0.5s;\n  width: -moz-fit-content;\n  width: fit-content;\n  border: none;\n}\n\n.pdf-container {\n  overflow: hidden;\n  overflow-x: auto;\n  overflow-y: auto;\n  height: 480px;\n  border: 2px solid grey;\n}\n\n/* new landing */\n\n.main-container-new {\n  /* height: 100vh; */\n  position: relative;\n  padding-bottom: 101px;\n}\n\n.main-container-new .bg-video {\n  position: absolute;\n  filter: brightness(1.6);\n  width: 100% !important;\n  /* height: 100%; */\n  top: 0;\n  z-index: 0;\n}\n\n.main-container-new .bg-overlay {\n  position: absolute;\n  filter: brightness(0.5);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1;\n}\n\n.main-container-new .content {\n  position: relative;\n  z-index: 2;\n}\n\n.main-container-new .content h1 {\n  font-family: \"Poppins\";\n  font-size: 52px;\n  font-weight: 700;\n  line-height: 60px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  width: 100%;\n  margin-inline: auto;\n  padding-top: 195px;\n  max-width: 70%;\n}\n\n.main-container-new .content h1 span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.main-container-new .content p {\n  font-family: \"Poppins\";\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 45px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  margin: 15px 0px 63px 0px;\n  width: 100%;\n  margin-inline: auto;\n}\n\n.main-container-new .content .button {\n  text-align: center;\n}\n\n.main-container-new .content .button button {\n  width: 171px;\n  height: 49px;\n  border-radius: 30px;\n  background-color: rgba(225, 31, 28, 1);\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  border: 2px solid rgba(225, 31, 28, 1);\n}\n\n.invester-new {\n  max-width: 1140px;\n  margin-inline: auto;\n  background-color: #000;\n  border-radius: 30px;\n  margin-top: 180px;\n  /* margin-bottom: 71px; */\n}\n\n.invester-new .person-item-wrapper {\n  border: none !important;\n  margin-inline: 10px;\n  padding: 16px 22px;\n}\n\n.invester-new .person-item {\n  display: flex;\n  padding: 0;\n  border: none !important;\n  gap: 13px;\n  align-items: center;\n}\n\n.invester-new .person-item .rounded-square-img {\n}\n\n.invester-new .person-item .rounded-square-img img {\n  width: 48px;\n  height: 48px;\n  border-radius: 25px;\n}\n\n.invester-new .person-item .person-item-desc {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: 0em;\n  text-align: left;\n  width: 100%;\n  margin: 0;\n}\n\n.invester-new .person-item .person-item-days span:nth-child(2) {\n  font-family: \"Poppins\";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0em;\n  text-align: right;\n}\n\n.invester-new .person-item .person-item-days {\n  width: 100%;\n  margin: 0;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.invester-new .slick-prev {\n  /* font-size: 0; */\n  line-height: 5;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: auto;\n  height: auto;\n  padding: 0;\n  transform: translate(13px, -53.5%);\n  cursor: pointer;\n  /* color: #424242; */\n  border: none;\n  outline: none;\n  background: #e32626;\n  border-radius: 25px;\n  font-size: 24px;\n  color: #fff;\n  opacity: 0.5;\n}\n\n.invester-new .slick-next {\n  /* font-size: 0; */\n  line-height: 5;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: auto;\n  height: auto;\n  padding: 0;\n  transform: translate(-13px, -53.5%);\n  cursor: pointer;\n  /* color: #424242; */\n  border: none;\n  outline: none;\n  background: #e32626;\n  border-radius: 25px;\n  font-size: 24px;\n  color: #fff;\n  opacity: 0.5;\n}\n\n.invester-new .slick-prev:hover,\n.invester-new .slick-prev:focus,\n.invester-new .slick-next:hover,\n.invester-new .slick-next:focus {\n  opacity: 1;\n  background: #e32626;\n  color: #fff;\n}\n\n.invester-new .slick-prev:before,\n.invester-new .slick-next:before {\n  font-family: \"slick\";\n  font-size: 22px;\n  line-height: 1.1;\n  /* opacity: .75; */\n  color: white;\n  margin-right: 7px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  opacity: 1;\n}\n\n.sec-two {\n  border-radius: 30px;\n  margin-top: -30px;\n  background: #fff;\n  position: relative;\n}\n\n.sec-two .text-start {\n  width: 100%;\n  margin-inline: auto;\n  font-weight: 700;\n  line-height: 60px;\n  font-size: 32px;\n  margin-bottom: 20px !important;\n  text-align: center !important;\n}\n\n.sec-two .text-start p {\n  text-align: center;\n}\n\n.sec-two .normal-p {\n  width: 100%;\n  margin-inline: auto;\n  margin-bottom: 30px;\n  font-weight: 500;\n  color: #2b2b2b;\n  text-align: start;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.sec-two .two {\n  width: 50%;\n  margin-inline: auto;\n}\n\n.sec-two .lp-phone-img-wrapper {\n  margin-inline: auto;\n}\n\n.sec-three {\n  background-image: url(../../../public/images/sec-three.png);\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 100px 0px;\n}\n\n.sec-three h2 {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: left;\n  width: 100%;\n  color: #fff;\n  margin-bottom: 20px;\n  line-height: 45px;\n}\n\n.sec-three h2 span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-three p {\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n  letter-spacing: 0em;\n  text-align: left;\n  width: 100%;\n  color: #fff;\n  margin-bottom: 30px;\n}\n\n.sec-three .button {\n  text-align: left;\n}\n\n.sec-three .button button {\n  /* width: 143px; */\n  height: 41px;\n  border-radius: 30px;\n  background-color: rgba(225, 31, 28, 1);\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  border: 2px solid rgba(225, 31, 28, 1);\n  padding-inline: 20px;\n}\n\n.sec-three .video {\n  position: relative;\n}\n\n.sec-three .video video {\n  width: 80%;\n  border-radius: 20px;\n}\n\n.sec-three .background {\n  position: absolute;\n  width: 80%;\n  height: 100%;\n  background-color: rgba(29, 29, 29, 0.521);\n  top: 0;\n\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sec-three .background img {\n  width: 102px;\n  height: 113px;\n}\n\n.sec-four {\n  padding-bottom: 71px;\n  padding-top: 0px;\n}\n\n.sec-four .sec10-container {\n  display: flex;\n  justify-content: center;\n  /* max-width: 890px; */\n  /* width: 80%; */\n  margin-bottom: 36px;\n}\n\n.sec-four .sec10-container .sec10-list {\n  border: 3px solid black;\n  border-radius: 16px;\n  padding: 0px;\n  width: 100%;\n}\n\n.sec-four .sec10-container .sec10-list .sec10-title {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  color: #2b2b2b !important;\n  border-radius: 10px;\n  margin: 0px;\n  width: 100%;\n  /* border-bottom: 1px solid #000;\n  border-top: 1px solid #000; */\n}\n\n.sec-four .sec10-container .sec10-list .sec10-title-b {\n  border-bottom: 3px solid black;\n}\n\n.sec-four .sec10-container .sec10-list .sec10-title h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.sec-four .sec10-container .sec10-list .sec10-title .sec10-icon {\n  cursor: pointer;\n  font-size: 20px;\n  color: red;\n  min-width: 20px;\n}\n\n.sec-four .sec10-container .sec10-list .sec10-para {\n  padding: 10px;\n  color: #2b2b2b !important;\n}\n\n.sec-four h2 {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: center;\n  width: 67%;\n  color: #000;\n  margin-bottom: 20px;\n  margin-inline: auto;\n  margin-bottom: 40px;\n}\n\n.sec-four p {\n}\n\n.sec-five .layout-text-profit {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: start;\n  margin: 0;\n  color: #000;\n}\n\n.sec-five .layout-text-profit img {\n  width: 169px;\n}\n\n.sec-five .layout-text-profit h3 {\n  color: #2b2b2b;\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 40px;\n  width: 52%;\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n\n.sec-five .layout-text-profit h3 span {\n  color: #e11f1c;\n}\n\n.sec-five .layout-text-profit p {\n  color: #2b2b2b;\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 32px !important;\n}\n\n.sec-five .layout-text-profit button {\n  /* width: 143px; */\n  height: 41px;\n  border-radius: 30px;\n  background-color: rgba(225, 31, 28, 1);\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  border: 2px solid rgba(225, 31, 28, 1);\n  padding-inline: 20px;\n}\n\n.sec-five .card-11 {\n  padding: 67px 31px 67px 62px;\n  box-sizing: border-box;\n  /* border-radius: 20px; */\n  /* background: linear-gradient(213deg, #e11f1c 0.96%, #660e0c 98.4%); */\n  /* box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.6); */\n  overflow: hidden;\n  color: #fff;\n}\n\n.sec-five .card-22 {\n  box-sizing: border-box;\n  /* border-radius: 20px; */\n  /* background: #f4f4f4; */\n  overflow: hidden;\n  color: #fff;\n  padding: 67px 62px 67px 31px;\n}\n\n.sec-five .currency {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px;\n}\n\n.sec-five .money {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 21px;\n}\n\n.sec-five .layout_currency-text {\n  font-size: 19px;\n  margin-top: 0px;\n  background-color: #a10707;\n  /* padding: 6px 16px;\n  width: 78px;\n  height: 37px; */\n  border-radius: 10px;\n}\n\n.sec-five .justify-content-between {\n  align-items: center;\n}\n\n.sec-five .css-eg0mwd-MuiSlider-thumb {\n  color: #fff;\n}\n\n.sec-five .css-eg0mwd-MuiSlider-thumb:hover {\n  box-shadow: none;\n}\n\n.sec-five .css-14pt78w-MuiSlider-rail {\n  /* color: #8c1414; */\n  color: #fff;\n  opacity: 1;\n}\n.close-icon-sec7 {\n  position: absolute;\n  top: 0px;\n  right: 150px;\n  font-size: 25px;\n  color: #e11f1c;\n  cursor: pointer;\n}\n.sec-five .range {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  opacity: 0.7;\n}\n\n.sec-five .custome-slider-widget {\n  /* margin-left: 15px; */\n  width: 96%;\n  margin-inline: 10px;\n}\n\n.sec-five .css-187mznn-MuiSlider-root {\n  padding: 8px 0px;\n}\n\n.sec-five .selected-range {\n  color: #fff;\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background: #252525;\n  border-radius: 10px;\n  padding: 15px;\n  width: 96%;\n  margin-inline: auto;\n  margin-top: 23px;\n  margin-bottom: 27px;\n  position: relative;\n  z-index: 1;\n}\n\n.sec-five .years {\n  color: #fff;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0px;\n}\n\n.sec-five .select-option-profit {\n  background-color: #252525;\n  border-radius: 10px;\n  cursor: pointer;\n  padding: 15px 25px;\n}\n\n.sec-five .button {\n  text-align: center;\n}\n\n.sec-five .button .calculate {\n  border-radius: 30px;\n  background: #fff;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  width: 136px;\n  height: 37px;\n  color: #e11f1c;\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n}\n\n.sec-five .result h6 {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  padding: 0;\n  margin: 0px;\n}\n\n.sec-five .result h3 {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  padding: 0;\n}\n\n.sec-five .result h5 {\n  color: #fff;\n  text-align: right;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.sec-five .result .boder-bottom {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.sec-five .css-1gv0vcd-MuiSlider-track {\n  color: #fff !important;\n}\n\n.sec-five {\n  padding: 63px 0px;\n}\n\n.sec-six {\n  display: flex;\n}\n\n.sec-six .left {\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sec-six .left .new-para {\n  position: absolute;\n  /* top: 10px; */\n  color: #000;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  font-weight: bold;\n  font-family: \"open-sans\", sans-serif;\n  letter-spacing: 1.2px;\n}\n\n.sec-six .left .new-para span:nth-child(1) {\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 4px 12px;\n}\n\n.sec-six .left .new-para span:nth-child(2) {\n  background-color: #fff;\n  border-radius: 0 0 6px 6px;\n  padding: 4px 12px;\n}\n\n.sec-six .left img {\n  height: 100vh;\n  width: 100%;\n}\n\n.sec-six .right {\n  flex: 1;\n  background: rgba(35, 35, 35, 1);\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  flex-direction: column;\n  padding-left: 90px;\n}\n\n.sec-six h3 {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 40px;\n  width: 80%;\n  margin: 0;\n}\n\n.sec-six h3 span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-six p {\n  color: #fff;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n  margin: 0px;\n  width: 80%;\n  margin-top: 22px;\n  margin-bottom: 28px;\n}\n\n.sec-six button {\n  /* width: 143px; */\n  height: 41px;\n  border-radius: 30px;\n  background-color: rgba(225, 31, 28, 1);\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  border: 2px solid rgba(225, 31, 28, 1);\n  padding-inline: 20px;\n}\n\n.sec-seven {\n  padding: 81px 0px;\n}\n\n.sec-seven .title {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: center;\n  width: 70%;\n  color: #000;\n  margin-bottom: 20px;\n  margin-inline: auto;\n  margin-bottom: 20px;\n}\n\n.sec-seven .title span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-seven .desc {\n  color: #000;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n  width: 100%;\n  margin-bottom: 28px;\n  margin-inline: auto;\n  text-align: center;\n}\n\n.sec-seven .card-wrap {\n  background: #fff;\n  height: 100%;\n  padding: 28px 39px;\n  position: relative;\n}\n\n.sec-seven .card-wrap:hover {\n  box-shadow: 15px 15px 25px 0px rgba(0, 0, 0, 0.15);\n}\n\n.sec-seven .card-wrap h4 {\n  font-family: \"Poppins\";\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 25px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: rgba(86, 86, 86, 1);\n  margin-top: 22px;\n  margin-bottom: 6px;\n}\n\n.sec-seven .card-wrap p {\n  font-family: \"Raleway\";\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: rgba(115, 115, 115, 1);\n}\n\n.sec-seven .card-border {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0%;\n  /* Initially, the border width is 0% */\n  height: 2px;\n  /* Adjust the height as needed */\n  background-color: #e11f1c;\n  /* Adjust the border color */\n  opacity: 0;\n  /* Initially, the opacity is 0 */\n}\n\n.card-wrap:hover .card-border {\n  transition: opacity 0.3s;\n  /* Opacity transition for smoother fade-in on hover */\n  animation: borderAnimation 0.3s forwards;\n  /* Apply the keyframe animation */\n}\n\n@keyframes borderAnimation {\n  0% {\n    width: 0%;\n    opacity: 0;\n  }\n\n  100% {\n    width: 100%;\n    opacity: 1;\n  }\n}\n\n.sec-eight {\n}\n\n.sec-eight .sec-eight-wrap {\n}\n\n.sec-eight .sec-eight-wrap .inner {\n  display: flex;\n}\n\n.sec-eight .sec-eight-wrap .inner .left {\n  width: 30%;\n  background: #232323;\n  padding-bottom: 60px;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .parent-p {\n  padding-left: 76px;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .parent .parent-p {\n  color: #e11f1c;\n  font-family: \"Poppins\";\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  padding: 10px 0px 10px 50px;\n  /* border-bottom: 2px solid #fff; */\n  border-top: 2px solid #393939;\n}\n\n.sec-eight .sec-eight-wrap .inner .left ul li {\n}\n\n.sec-eight .sec-eight-wrap .inner .right {\n  width: 70%;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .open-header li {\n  color: #c7c7c7;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 5px;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu {\n  margin: 0;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu li {\n  padding-left: 80px;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .open-header li.active {\n  border-bottom: none;\n  box-shadow: none;\n  color: var(--primary);\n}\n\n.sec-eight\n  .sec-eight-wrap\n  .inner\n  .left\n  .open-header\n  ul:not(.open-header-sub-menu)\n  > li {\n  box-shadow: none;\n  margin: 0;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu {\n  box-shadow: none;\n}\n\n.sec-eight .sec-eight-wrap .inner .left .parent li:nth-child(1) {\n  border: none;\n}\n\n.sec-eight .right {\n  position: relative;\n  background-image: url(../../../public/images/sec-eight.png);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 22px 99px 22px 38px;\n}\n\n.sec-eight .right .p-c-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.sec-eight .right .p-c-wrapper .leftt {\n  /* width: 100%; */\n}\n\n.sec-eight .right .p-c-wrapper .leftt img {\n  width: 247px;\n}\n\n.sec-eight .right .p-c-wrapper {\n}\n\n.sec-eight .right .p-c-wrapper {\n}\n\n.sec-eight .right .p-c-wrapper .rightt {\n}\n\n.sec-eight .right .p-c-wrapper .rightt {\n  color: #fff;\n  font-family: \"Poppins\";\n  padding: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.sec-eight .sec10-container {\n  display: flex;\n  justify-content: center;\n  /* max-width: 890px; */\n  /* width: 80%; */\n  margin-bottom: 28px;\n}\n\n.sec-eight .sec10-container .sec10-list {\n  border: 3px solid rgba(87, 87, 87, 0.5);\n  border-radius: 20px;\n  padding: 0px;\n  width: 100%;\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-title {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  color: #2b2b2b !important;\n  border-radius: 10px;\n  margin: 0px;\n  width: 100%;\n  /* border-bottom: 1px solid #000;\n  border-top: 1px solid #000; */\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-title-b {\n  border-bottom: 3px solid rgba(87, 87, 87, 0.5);\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-title h3 {\n  color: #bababa;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-title .sec10-icon {\n  cursor: pointer;\n  font-size: 20px;\n  color: #575757;\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-para {\n  padding: 10px;\n  color: #2b2b2b !important;\n}\n\n.sec-eight .sec10-container .sec10-list .sec10-para p {\n  color: #bababa;\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.sec-eight .right .pitch-cardd {\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.sec-eight .right .accrodian {\n  position: relative;\n}\n\n.sec-eight .right .bg-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.sec-nine {\n  padding-top: 81px;\n  overflow: hidden;\n}\n\n.sec-nine .title {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #000;\n  margin: 0;\n}\n\n.sec-nine .title span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-nine .desc {\n  color: #000;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n  width: 47%;\n  margin-bottom: 28px;\n  margin-inline: auto;\n  text-align: center;\n}\n\n.sec-nine .investor-card {\n  display: flex;\n  padding: 0px;\n}\n\n.sec-nine .investor-card .investor-card-img {\n  width: auto;\n  margin: auto;\n  border-radius: 0%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: unset;\n}\n\n.sec-nine .investor-card .investor-card-img-inner {\n  border-radius: 0%;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.sec-nine .investor-card .investor-card-img img {\n  width: 415px;\n  border-radius: 0%;\n  filter: none;\n  transition: all 0.3s ease;\n  height: 333px;\n}\n\n.sec-nine .investor-card-body {\n  padding: 0px 136px 0px 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n}\n\n.sec-nine .investor-card-body .bt1 {\n  margin-bottom: 10px;\n}\n\n.sec-nine .investor-card-body .bt2 {\n  margin-left: auto;\n  margin-top: 5px;\n}\n\n.sec-nine .investor-card-body .investor-title {\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #2b2b2b;\n  margin-bottom: 9px;\n}\n\n.sec-nine .investor-card-body .investor-desc {\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #797979;\n}\n\n.sec-nine .slick-prev {\n  left: 20px;\n  color: rgba(225, 31, 28, 0.5);\n  width: 100px;\n  height: 100px;\n  z-index: 20;\n}\n\n.sec-nine .slick-prev:hover {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-nine .slick-next {\n  right: 20px;\n  color: rgba(225, 31, 28, 0.5);\n  width: 100px;\n  height: 100px;\n  z-index: 20;\n}\n\n.sec-nine .slick-next:hover {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-nine {\n}\n\n.sec-ten {\n  padding-top: 91px;\n  padding-inline: 62px;\n}\n\n.sec-ten .title {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #000;\n  margin: 0;\n}\n\n.sec-ten .title span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-ten .blog-card {\n  border-radius: 20px;\n  background-color: #fafafa;\n  height: 100%;\n  box-shadow: none;\n}\n\n.sec-ten .blog-card:hover {\n  background: #fafafa;\n  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.2);\n}\n\n.sec-ten .blog-card-body-wrapper {\n  position: static;\n  background: transparent;\n}\n\n.sec-ten .blog-card-wrapper {\n  padding: 30px 16px 30px 16px;\n}\n\n.sec-ten .blog-card-title {\n  color: #2b2b2b;\n  font-family: \"Poppins\";\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 0px;\n}\n\n.sec-ten .card-desc {\n  color: #797979;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  /* 122.222% */\n  margin-bottom: 10px;\n}\n\n.sec-ten .card-person {\n  color: #2b2b2b;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  /* 122.222% */\n}\n\n.sec-ten .card-time {\n  color: #2b2b2b;\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n  /* 157.143% */\n}\n\n.sec-ten .blog-card-footer {\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sec-ten .blog-card-footer .right {\n}\n\n.sec-ten .blog-card-footer .left {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.sec-eleven {\n  padding-top: 40px;\n  padding-bottom: 80px;\n}\n\n.sec-eleven .title span {\n  color: rgba(225, 31, 28, 1);\n}\n\n.sec-eleven .title {\n  color: #343434;\n  font-family: \"Poppins\";\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  margin-top: 15px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.sec-eleven .desc {\n  color: #343434;\n  text-align: left;\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n  font-weight: bold;\n  /* width: 85%; */\n}\n\n.sec-eleven .desc span {\n  color: #e53e51;\n}\n\n.sec-eleven form {\n  padding: 40px 32px;\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 7px 7px 15px 0px rgba(0, 0, 0, 0.25);\n}\n\n.sec-eleven form h3 {\n  color: #a7a6a6;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.sec-eleven form input {\n  border-radius: 5px;\n  background: #f3f3f3;\n  height: 55px;\n  width: 100%;\n  border: none;\n  color: #3e3e3e;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 24px;\n  padding: 0px 18px;\n}\n\n.sec-eleven form textarea {\n  border-radius: 5px;\n  background: #f3f3f3;\n  color: #3e3e3e;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  width: 100%;\n  border: none;\n  padding: 18px;\n}\n\n.sec-eleven form .type {\n  display: flex;\n  gap: 5px;\n}\n\n.sec-eleven form .type .left {\n  flex: 1;\n  display: flex;\n  height: 55px;\n  align-items: center;\n  background: #f3f3f3;\n  padding: 0px 10px;\n  border-radius: 5px;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.sec-eleven form .type .right {\n  flex: 1;\n  display: flex;\n  height: 55px;\n  align-items: center;\n  background: #f3f3f3;\n  padding: 0px 10px;\n  border-radius: 5px;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.sec-eleven form .type .right p {\n  color: #3e3e3e;\n  text-align: right;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.sec-eleven form .type .left p {\n  color: #3e3e3e;\n  text-align: right;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.sec-eleven form .type .left svg {\n  color: #d9d9d9;\n  font-size: 12px;\n}\n\n.sec-eleven form .type .right svg {\n  color: #d9d9d9;\n  font-size: 12px;\n}\n\n.sec-eleven form button {\n  border-radius: 15px;\n  background: #e11f1c;\n  width: 171px;\n  height: 57px;\n  color: #fff;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border: none;\n  margin-top: 31px;\n}\n\n.sec-eleven form input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #acacac;\n  opacity: 1;\n  /* Firefox */\n}\n\n.sec-eleven form input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #acacac;\n}\n\n.sec-eleven form input::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #acacac;\n}\n\n.sec-eleven form textarea::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #acacac;\n  opacity: 1;\n  /* Firefox */\n}\n\n.sec-eleven form textarea:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #acacac;\n}\n\n.sec-eleven form textarea::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #acacac;\n}\n\n.sec-eleven form .type .right.active {\n  background: #e11f1c;\n  box-shadow: 4px 4px 7px 0px rgba(0, 0, 0, 0.5);\n}\n\n.sec-eleven form .type .left.active {\n  background: #e11f1c;\n  box-shadow: 4px 4px 7px 0px rgba(0, 0, 0, 0.5);\n}\n\n.sec-eleven form .type .right.active p {\n  color: #fff;\n}\n\n.sec-eleven form .type .left.active p {\n  color: #fff;\n}\n\n.sec-eleven form .type .left.active svg {\n  color: #fff;\n  font-size: 12px;\n}\n\n.sec-eleven form .type .right.active svg {\n  color: #fff;\n  font-size: 12px;\n}\n\n.form-form {\n  display: inline-block;\n  padding: 10px 12px;\n  font-family: \"Poppins\";\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: center;\n  background: rgba(225, 31, 28, 1);\n  border-radius: 15px 0px 0px 15px;\n  position: fixed;\n  z-index: 9999;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #fff;\n}\n\n.css-1t2bqnt {\n  color: #fff !important;\n}\n\n.cta {\n  padding: 15px 25px;\n  border-radius: 5px;\n  border: 1px solid white;\n  background-color: #fff !important;\n  color: #252525;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  width: 100%;\n}\n\n.bg-video-landing {\n  width: 100%;\n}\n\n.notification-card {\n  position: absolute;\n  border-radius: 10px;\n  top: 60px;\n  right: 386px;\n  z-index: 999999;\n  background-color: white;\n  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.541);\n  height: 330px;\n  overflow: hidden;\n  width: 300px;\n}\n\n.notification-card-main {\n  position: absolute;\n  border-radius: 10px;\n  top: 68px;\n  right: 100px;\n  z-index: 999999;\n  background-color: white;\n  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.541);\n  height: 330px;\n  overflow: hidden;\n  width: 300px;\n}\n\n.Notification-in-header {\n  padding: 5px 10px;\n  display: flex;\n  font-family: \"Jost\";\n  color: #121212;\n  background: #fff;\n}\n\n.Notification-in-header.is_seen {\n  background: rgba(112, 181, 249, 0.2);\n}\n\n.Notification-in-header:hover {\n  background: linear-gradient(90deg, #e11f1c 100%, #b600d1 100.01%);\n  color: white !important;\n  cursor: pointer;\n}\n\n.Notification-in-header .image-holder {\n  width: 40px;\n  align-items: center;\n  display: flex;\n}\n\n.Notification-in-header .image-holder img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n.Notification-in-header .text-area {\n  margin-left: 10px;\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.Notification-in-header .text-area .name-txt span {\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 5px;\n  text-transform: capitalize;\n}\n\n.Notification-in-header .text-area .name-txt {\n  font-size: 16px;\n  font-weight: 500;\n  white-space: nowrap;\n  width: 200px;\n}\n\n.Notification-in-header .text-area .msg-txt {\n  font-size: 14px;\n  font-weight: 500;\n  width: 150px;\n}\n\n.header-empty-record {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-empty-record span {\n  font-weight: 600;\n  font-size: 22px;\n  font-family: \"Jost\";\n  color: #b600d1;\n}\n\n.not-top-icon {\n  position: absolute;\n  top: 22px;\n  right: 500px;\n  height: 16px;\n  width: 16px;\n  line-height: 16px;\n  border-radius: 50%;\n  background: #e11f1c;\n  text-align: center;\n  font-size: 10px;\n  color: #ffff;\n}\n\n.not-top-main-icon {\n  position: relative;\n  top: -11px;\n  /* right: 90px; */\n  left: 40px;\n  width: 100%;\n  line-height: 16px;\n  border-radius: 50%;\n  background: #e11f1c;\n  text-align: center;\n  font-size: 11px;\n  color: #ffff;\n  padding: 0px 4px;\n  margin-right: -34px;\n  margin-top: 27px;\n}\n\n.not-button {\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  width: 100%;\n}\n\n.notification-history-card {\n  border: 1px solid #ddd;\n  padding: 20px;\n  margin-bottom: 20px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n}\n\n.notification-history-card h4 {\n  font-size: 20px;\n  margin: 0;\n  color: #333;\n  width: 100%;\n  word-break: break-all;\n}\n\n.notification-history-card p {\n  font-size: 16px;\n  color: #666;\n  width: 100%;\n  word-break: break-all;\n}\n\n.image-holder-detail-notification img {\n  width: 280px;\n  height: 40px;\n  object-fit: contain;\n}\n\n/* referral */\n\n.referral-area .invite-friends h4 {\n  margin-bottom: 10px;\n  font-size: 24px;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.setting-bg {\n  background-color: var(--card-background-color);\n  padding: 20px;\n}\n\n.referral-area .invite-friends .input-group {\n  position: relative;\n  width: 100%;\n  font-size: large;\n}\n\n.invite-friends .input-group .copy-url-btn {\n  position: absolute;\n  right: -25px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--primary);\n  font-size: 20px;\n  z-index: 9;\n  width: 30px !important;\n}\n\n.invite-friends .input-group .form-control {\n  width: 100%;\n  height: 70px;\n  border-radius: 5px;\n  /* border: 1px solid black; */\n  color: black;\n  background-color: #ebebeb;\n}\n\n/* referral-area */\n.referral-area table.dataTable thead tr th {\n  background: var(--black);\n  border-bottom: 1px solid var(--black);\n}\n\n.referral-area table.dataTable tbody tr td {\n  background: black;\n}\n\n.rewards-inviter {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rewards-inviter .single-item {\n  margin-bottom: 30px;\n}\n\n.rewards-inviter .single-item h4 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: capitalize;\n  color: var(--black);\n}\n\n.rewards-inviter .single-item h2 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--black);\n  display: flex;\n  justify-content: center;\n}\n\n.checkout-field-referral-box {\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  background-color: #ebebeb;\n  border-radius: 7px;\n  flex-wrap: wrap;\n  overflow: scroll;\n  gap: 25px;\n  margin: 20px;\n  justify-content: space-between !important;\n}\n\n.checkout-field-referral-box > span {\n  color: #565656;\n  font-weight: 500;\n  font-size: 16px;\n  word-break: break-all;\n}\n\nheader {\n  background-color: #fff;\n  padding-top: 15px;\n}\n\nheader .header-wrap {\n  display: flex;\n  padding-inline: 120px;\n  justify-content: space-between;\n  align-items: center;\n}\n\nheader .header-wrap .left {\n}\n\nheader .header-wrap .left img {\n  width: 120px;\n}\n\nheader .header-wrap .center {\n}\n\nheader .header-wrap .center ul {\n  display: flex;\n  box-shadow: 0px 33px 30px 0px #00000026;\n  background-color: #fff;\n  margin: 0;\n  padding: 0 35px;\n  border-radius: 36px;\n  gap: 35px;\n}\n\nheader .header-wrap .center ul li {\n  display: flex;\n  /* box-shadow: 0px 33px 30px 0px #00000026; */\n  background-color: #fff;\n  margin: 0;\n  padding: 16px 0px;\n  border-radius: 36px;\n}\nheader .header-wrap .center ul a.active {\n  border-bottom: 1px solid #e11f1c;\n  border-radius: 0;\n  color: #e11f1c;\n}\n\n/* .header-wrap .center ul li:hover{\n  color: #e11f1c;\n}\n.header-wrap .center ul li:hover:after {\n  content: '';\n  display: block;\n  border-bottom: 2px solid #E11F1C; \n  margin-top: 2px; \n\n} */\nheader .header-wrap .center ul li a {\n}\n\nheader .header-wrap .right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\nheader .header-wrap .right {\n}\n\nheader .header-wrap .right .switch-lang {\n}\n\nheader .header-wrap .right .login-btn {\n}\n\nheader .header-wrap .right .login-btn button {\n  padding: 15px 35px 15px 35px;\n  border-radius: 5px;\n  background-color: #e11f1c;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20.83px;\n  text-align: left;\n  border: none;\n  outline: none;\n  color: #fff;\n  border: none;\n  outline: none;\n}\n\nheader .header-wrap .right .switch-lang .notifivation {\n}\n\n.home-sec-1 {\n  padding: 200px 0px;\n  position: relative;\n  /* background-image: url(/src/assets/images/banner-img-sec1.jpg); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: initial;\n  margin-top: 55px !important;\n}\n\n.home-sec-1 .bg-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(/src/assets/images/home-sec-1-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  z-index: -1;\n}\n\n.home-sec-1 .home-sec-1-left {\n}\n\n.home-sec-1 .home-sec-1-left h1 {\n  font-size: 52px;\n  font-weight: 400;\n  line-height: 72.63px;\n  text-align: left;\n  margin-bottom: 20px !important;\n  color: #fff;\n}\n\n.home-sec-1 .home-sec-1-left h1 span {\n  font-weight: 800;\n  color: #e11f1c;\n}\n\n.home-sec-1 .home-sec-1-left p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 25px !important;\n  color: #fff;\n}\n\n.home-sec-1 .home-sec-1-left .button {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.home-sec-1 .home-sec-1-left .button button:nth-child(1) {\n  padding: 15px 25px;\n  color: #fff;\n  background-color: #252525;\n  border-radius: 5px;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20.83px;\n  text-align: left;\n}\n\n.home-sec-1 .home-sec-1-left .button button:nth-child(2) {\n  padding: 15px 25px;\n  color: #252525;\n  background-color: transparent;\n  border-radius: 5px;\n  border: 1px solid #e11f1c;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20.83px;\n  text-align: left;\n}\n\n.home-sec-1 .home-sec-1-right {\n}\n\n.home-sec-two {\n  padding-inline: 139px;\n  margin-top: -150px;\n}\n\n.home-sec-two .home-sec-twe-wrap {\n  padding-bottom: 40px;\n}\n\n.home-sec-two .home-sec-twe-wrap .person-item-wrapper {\n}\n\n.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item {\n  display: flex;\n  gap: 17px;\n}\n\n.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item .left {\n}\n\n.home-sec-two\n  .home-sec-twe-wrap\n  .person-item-wrapper\n  .person-item\n  .left\n  .rounded-square-img {\n}\n\n.home-sec-two\n  .home-sec-twe-wrap\n  .person-item-wrapper\n  .person-item\n  .left\n  .rounded-square-img\n  img {\n  width: 76px;\n  height: 76px;\n  border-radius: 100%;\n}\n\n.home-sec-two .home-sec-twe-wrap .person-item-wrapper .person-item .right {\n}\n\n.slick-slider .slick-list {\n}\n\n.slick-slider .slick-list .slick-track {\n}\n\n.slick-slider .slick-list .slick-track div.slick-slide:nth-child(1) {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background-color: #fff;\n  padding: 21px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper {\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper {\n  background: #fff;\n  border: 2px solid #fff;\n  border-radius: 16px;\n  padding: 23px;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  margin: 10px;\n  position: relative;\n  top: 40px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper\n  .right\n  h3 {\n  font-size: 24.81px;\n  font-weight: 700;\n  line-height: 32.31px;\n  color: #252525;\n  margin-bottom: 5px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper\n  .right\n  h4 {\n  font-size: 12.42px;\n  font-weight: 400;\n  line-height: 19.23px;\n  color: #252525;\n  margin-bottom: 3px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc {\n  font-size: 12.42px;\n  font-weight: 600;\n  line-height: 19.23px;\n  text-align: left;\n  color: #252525;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1) {\n  font-size: 23.29px;\n  font-weight: 700;\n  line-height: 30.32px;\n  color: #e11f1c;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(1)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(3)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(4)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(6)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(7)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(9)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(10)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(12)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(13)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(15)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(16)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(18)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(19)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(21)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(22)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(24)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(25)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(27)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(28)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2) {\n  font-size: 12.42px;\n  font-weight: 600;\n  line-height: 19.23px;\n  text-align: left;\n  color: #252525;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper {\n  background: #252525;\n  border: 2px solid #fff;\n  border-radius: 16px;\n  padding: 23px;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  margin: 10px 10px 40px 10px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper\n  .right\n  h3,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper\n  .right\n  h3 {\n  font-size: 24.81px;\n  font-weight: 700;\n  line-height: 32.31px;\n  color: #fff;\n  margin-bottom: 5px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper\n  .right\n  h4,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper\n  .right\n  h4 {\n  font-size: 12.42px;\n  font-weight: 400;\n  line-height: 19.23px;\n  color: #fff;\n  margin-bottom: 3px;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc,\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-desc {\n  font-size: 12.42px;\n  font-weight: 600;\n  line-height: 19.23px;\n  text-align: left;\n  color: #fff;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(1) {\n  font-size: 23.29px;\n  font-weight: 700;\n  line-height: 30.32px;\n  color: #e11f1c;\n}\n\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(2)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(5)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(8)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(11)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(14)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(17)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(20)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(23)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(26)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(29)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(32)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(35)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(38)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(41)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(44)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(47)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(50)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(53)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(56)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(59)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(62)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(65)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2),\n.home-sec-two\n  .slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide:nth-child(68)\n  div\n  .person-item-wrapper\n  .right\n  .person-item-days\n  span:nth-child(2) {\n  font-size: 12.42px;\n  font-weight: 600;\n  line-height: 19.23px;\n  text-align: left;\n  color: #fff;\n}\n\n.home-sec-two .slick-slider .slick-list .slick-track .slick-slide:nth-child(2) {\n  background-color: gray;\n}\n\n.home-sec-two .slick-prev,\n.home-sec-two .slick-next {\n  font-size: 0;\n  line-height: 0;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  transform: translate(0, -50%);\n  cursor: pointer;\n  color: #252525;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n\n.home-sec-two .slick-prev {\n  left: -45px;\n}\n\n.home-sec-two .slick-next {\n  right: -45px;\n}\n\n.home-sec-two .slick-dots {\n  position: absolute;\n  bottom: -5px;\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  text-align: center;\n}\n\n.home-sec-two .slick-dots li {\n  background: #d2d2d2;\n  margin: 0px !important;\n  width: 36px !important;\n  height: 5px !important;\n}\n\n.home-sec-two .slick-dots li.slick-active {\n  background-color: #252525;\n  border-radius: 21px;\n}\n\n.home-sec-two .slick-dots li button {\n  display: none !important;\n}\n\n.home-sec-two .slick-dots li button {\n}\n\n.home-sec-two .slick-dots li button:before {\n}\n\n.home-sec-two .slick-dots li:first-child {\n  border-radius: 21px 0px 0px 21px;\n}\n\n.home-sec-two .slick-dots li:last-child {\n  border-radius: 0px 21px 21px 0px;\n}\n\n.home-sec-two .slick-dots {\n  bottom: -5px !important;\n}\n\n.home-sec-two .slick-prev:hover,\n.home-sec-two .slick-prev:focus,\n.home-sec-two .slick-next:hover,\n.home-sec-two .slick-next:focus {\n  color: #252525 !important;\n  outline: none;\n  background: transparent;\n}\n\n.home-sec-three {\n  padding: 80px 0px;\n}\n\n.home-sec-three .home-sec-three-left {\n}\n\n.home-sec-three .home-sec-three-left img {\n  width: 100%;\n}\n\n.home-sec-three .home-sec-three-right {\n}\n\n.home-sec-three .home-sec-three-right h2 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 10px;\n}\n\n.home-sec-three .home-sec-three-right h3 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 12px;\n}\n\n.home-sec-three .home-sec-three-right h3 span {\n  color: #e11f1c;\n}\n\n.home-sec-three .home-sec-three-right p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n}\n\n.home-sec-three .home-sec-three-right .p1 {\n  padding-bottom: 40px !important;\n}\n\n.home-sec-three .home-sec-three-right .p2 {\n  padding-bottom: 25px !important;\n}\n\n.home-sec-three .home-sec-three-right .button {\n}\n\n.home-sec-three .home-sec-three-right .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n}\n.home-sec-three .button {\n  margin-top: 25px;\n}\n.home-sec-three .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n}\n\n.home-sec-four {\n  padding: 80px 0px;\n  background-image: url(/src/assets/images/home-sec-four-bg.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n\n.home-sec-four .home-sec-four-right {\n}\n\n.home-sec-four .home-sec-four-right img {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.home-sec-four .home-sec-four-left {\n}\n\n.home-sec-four .home-sec-four-left h2 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: left;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n.home-sec-four .home-sec-four-left h3 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #fff;\n  margin-bottom: 12px;\n}\n\n.home-sec-four .home-sec-four-left h3 span {\n  color: #e11f1c;\n}\n\n.home-sec-four .home-sec-four-left p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #fff;\n}\n\n.home-sec-four .home-sec-four-left .p1 {\n  padding-bottom: 40px !important;\n}\n\n.home-sec-four .home-sec-four-left .p2 {\n  padding-bottom: 25px !important;\n}\n\n.home-sec-four .home-sec-four-left .button {\n}\n\n.home-sec-four .home-sec-four-left .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #252525;\n  background-color: #fff;\n  border: 0px;\n}\n\n.home-sec-four .home-sec-four-left .button button svg path {\n  fill: #252525;\n}\n\n.home-sec-five {\n  padding: 80px 0px;\n}\n\n.home-sec-five h2 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 10px;\n}\n\n.home-sec-five h3 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 20px;\n  width: 50%;\n  margin-inline: auto;\n}\n\n.home-sec-five h3 span {\n  color: #e11f1c;\n}\n\n.home-sec-five .left,\n.home-sec-five .right {\n  display: flex;\n  flex-direction: column;\n  gap: 45px;\n}\n\n.home-sec-five .left .home-sec-five-left-one {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 31px 17px 13px;\n  position: relative;\n}\n\n.home-sec-five .right .home-sec-five-right-one {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 13px 17px 31px;\n  position: relative;\n}\n\n.home-sec-five .left h4 {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: right;\n  color: #e11f1c;\n  padding-right: 15px;\n}\n\n.home-sec-five .right h4 {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: left;\n  color: #e11f1c;\n  padding-left: 15px;\n}\n\n.home-sec-five .left p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.83px;\n  text-align: right;\n  color: #000;\n}\n\n.home-sec-five .right p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.83px;\n  text-align: left;\n  color: #000;\n}\n\n.home-sec-five .left .home-sec-five-left-two {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 31px 17px 13px;\n  position: relative;\n  margin-right: -30px;\n  margin-left: 30px;\n}\n\n.home-sec-five .right .home-sec-five-right-two {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 33px 17px 31px;\n  position: relative;\n  margin-left: -30px;\n  margin-right: 30px;\n}\n\n.home-sec-five .left .home-sec-five-left-three {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 31px 17px 13px;\n  position: relative;\n  margin-right: -80px;\n  margin-left: 80px;\n}\n\n.home-sec-five .right .home-sec-five-right-three {\n  box-shadow: 15.52px 18.63px 74.43px 0px #00000014;\n  background: #fff;\n  padding: 17px 13px 17px 31px;\n  position: relative;\n  margin-left: -80px;\n  margin-right: 80px;\n}\n\n.home-sec-five .left .number {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: center;\n  color: #fff;\n  background-color: #e11f1c;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 38px;\n  height: 35px;\n  border-radius: 0px 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.home-sec-five .right .number {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: center;\n  color: #fff;\n  background-color: #e11f1c;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 38px;\n  height: 35px;\n  border-radius: 16px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.home-sec-five .center {\n}\n\n.home-sec-five .home-sec-five-center {\n}\n\n.home-sec-five .home-sec-five-center img {\n  width: 100%;\n}\n\n.home-sec-five .right {\n}\n\n.home-sec-six {\n  padding: 80px 0px;\n}\n\n.home-sec-six .home-sec-six-right {\n  background-image: url(/src/assets/images/home-sec-six-bg.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.home-sec-six .home-sec-six-right img {\n  width: 100%;\n}\n\n.home-sec-six .home-sec-six-left {\n}\n\n.home-sec-six .home-sec-six-left h2 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 10px;\n}\n\n.home-sec-six .home-sec-six-left h3 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 12px;\n}\n\n.home-sec-six .home-sec-six-left h3 span {\n  color: #e11f1c;\n}\n\n.home-sec-six .home-sec-six-left p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n}\n\n.home-sec-six .home-sec-six-left .p1 {\n  padding-bottom: 40px !important;\n}\n\n.home-sec-six .home-sec-six-left .p2 {\n  padding-bottom: 25px !important;\n}\n\n.home-sec-six .home-sec-six-left .button {\n}\n\n.home-sec-six .home-sec-six-left .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n}\n\n.home-sec-seven {\n  padding: 80px 0px;\n}\n\n.home-sec-seven h2 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 10px;\n}\n\n.home-sec-seven h3 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 36px;\n  width: 50%;\n  margin-inline: auto;\n}\n\n.home-sec-seven h3 span {\n  color: #e11f1c;\n}\n\n.home-sec-seven .video {\n  position: relative;\n  height: 438px;\n}\n\n.home-sec-seven .video .left-img {\n  position: absolute;\n  left: -130px;\n  top: -130px;\n  z-index: 10;\n}\n\n.home-sec-seven .video .right-img {\n  position: absolute;\n  right: -77px;\n  bottom: -30px;\n  z-index: 10;\n}\n\n.home-sec-seven .video .background {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.home-sec-seven .video .background img {\n  width: 100%;\n  border-radius: 8px;\n}\n.home-sec-seven .video .background svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 78px;\n  color: #e11f1c;\n  cursor: pointer;\n}\n.home-sec-seven .video .right-img {\n}\n\n.home-sec-eight {\n  padding: 80px 0px;\n  position: relative;\n}\n.home-sec-eight .container {\n  background: linear-gradient(99.74deg, #e11f1c -7.32%, #7b110f 101.94%);\n  border-radius: 20px;\n}\n.home-sec-eight .home-sec-eight-bg {\n  background-image: url(/src/assets/images/home-sec-eight-bg.png);\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 519px;\n  height: 188px;\n  position: absolute;\n  object-fit: contain;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  left: 50%;\n}\n.home-sec-eight .left {\n}\n.home-sec-eight .left h2 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #fff;\n  margin-bottom: 14px;\n}\n\n.home-sec-eight .left h6.currency {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: left;\n  color: #fff;\n}\n.home-sec-eight .left p.layout_currency-text {\n  padding: 15px 25px;\n  background-color: #252525;\n}\n.home-sec-eight .left .money {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: left;\n  color: #fff;\n}\n.home-sec-eight .left .range {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: left;\n  color: #fff;\n  opacity: 1;\n}\n.home-sec-eight .left p {\n}\n.home-sec-eight {\n}\n\n/* MUZAMMIL CSS START */\n\n.home-sec-nine {\n  padding: 80px 0px;\n}\n.home-sec-nine h3 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 10px;\n}\n.home-sec-nine .btn-wrapper {\n}\n.home-sec-nine .btn-wrapper button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n}\n.home-sec-nine h1 {\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 12px;\n}\n.home-sec-nine h1 span {\n  color: #e11f1c;\n}\n.home-sec-nine p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 20px;\n}\n.home-sec-ten {\n  padding: 80px 0;\n}\n.home-sec-ten h1 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 12px;\n}\n.home-sec-ten h1 span {\n  color: #e11f1c;\n}\n.home-sec-ten p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: center;\n  color: #252525;\n  margin-bottom: 60px;\n  max-width: 767px;\n  margin-inline: auto;\n}\n.home-sec-ten .cardd {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  flex-direction: column;\n  padding: 12px;\n  border-radius: 12px;\n  gap: 12px;\n  min-height: 297px;\n}\n.home-sec-ten .cardd img {\n  width: 55px;\n}\n.home-sec-ten .cardd h3 {\n  font-size: 24.81px;\n  font-weight: 700;\n  line-height: 32.31px;\n  color: #252525;\n  margin-bottom: 5px;\n  text-align: center;\n}\n.home-sec-ten .cardd h3 span {\n  color: #e11f1c;\n}\n.home-sec-ten .cardd p {\n  font-size: 0.8rem;\n  margin-bottom: 5px;\n  letter-spacing: 1px;\n  color: #404040;\n  text-align: center;\n  line-height: 20px;\n}\n.home-sec-ten .button {\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n}\n.home-sec-ten .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n}\n\n.home-sec-eleven {\n  padding: 80px 0;\n}\n.home-sec-eleven h1 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 12px;\n}\n.home-sec-eleven h1 span {\n  color: #e11f1c;\n}\n.home-sec-eleven p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n}\n.home-sec-eleven .video {\n  position: relative;\n}\n.home-sec-eleven .video video {\n  width: 100%;\n  border-radius: 20px;\n}\n.home-sec-eleven .background {\n  position: absolute;\n  width: 100%;\n  height: 98%;\n  /* background-color: rgba(29, 29, 29, 0.521); */\n  background-color: #fff;\n  top: 0;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.home-sec-eleven .background img {\n  width: 100%;\n  /* height: auto; */\n  cursor: pointer;\n}\n.home-sec-twelve {\n  position: relative;\n  /* padding-bottom: 101px; */\n  height: 600px;\n  margin: 80px 0px;\n}\n.home-sec-twelve .bg-video {\n  position: absolute;\n  filter: brightness(0.8);\n  width: 100% !important;\n  /* height: 100%; */\n  top: 0;\n  z-index: 0;\n}\n.home-sec-twelve .bg-video .bg-video-landing {\n  width: 100%;\n}\n.home-sec-twelve .bg-video .bg-overlay {\n  position: absolute;\n  width: 100%;\n  height: 98%;\n  /* background-color: rgba(29, 29, 29, 0.521); */\n  top: 0;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.home-sec-twelve .content {\n  position: absolute;\n  z-index: 2;\n  top: 60px;\n  width: 100%;\n}\n.home-sec-twelve .content h1 {\n  font-size: 52px;\n  font-weight: 700;\n  line-height: 60px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(255, 255, 255, 1);\n  /* padding-top: 60px; */\n}\n.home-sec-twelve .content h1 span {\n  color: #e11f1c;\n}\n.home-sec-twelve .button {\n  display: flex;\n  justify-content: center;\n}\n.home-sec-twelve .button button {\n  border-radius: 5px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  background-color: #252525;\n  border: none;\n}\n.home-sec-twelve .content-card {\n  position: absolute;\n  z-index: 2;\n  bottom: 20%;\n  width: 100%;\n}\n.home-sec-twelve .content-card h3 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: left;\n  color: #252525;\n  margin-bottom: 10px;\n  color: #fff;\n}\n.home-sec-twelve .content-card h1 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 45.57px;\n  text-align: left;\n  color: #e11f1c;\n  margin-bottom: 12px;\n}\n.home-sec-twelve .content-card p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: left;\n  color: #fff;\n}\n.mobile-nav {\n  display: none;\n}\n.hamburger-mobile {\n  display: none;\n}\n\n.home-sec-twelve .video {\n  position: relative;\n}\n.home-sec-twelve .video video {\n  width: 100%;\n  border-radius: 12px;\n  filter: brightness(0.5);\n}\n.home-sec-twelve .background {\n  position: absolute;\n  width: 100%;\n  height: 98%;\n  /* background-color: rgba(29, 29, 29, 0.521); */\n  background-color: #fff;\n  top: 0;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.home-sec-twelve .background img {\n  width: 100%;\n  /* height: auto; */\n  height: 243px;\n  object-fit: cover;\n  border-radius: 12px;\n}\n.home-sec-twelve .background svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 78px;\n  color: #e11f1c;\n  cursor: pointer;\n}\n/* MUZAMMIL CSS END */\n\n.mobile-nav.active {\n  transform: translateX(0%);\n}\n\n.data .cardd {\n  background: rgba(255, 255, 255, 0.5);\n  padding: 20px;\n  border-radius: 12px;\n  border: 2px solid #fff;\n}\n.data-0twelve {\n  display: none;\n}\n.home-sec-testimonial {\n  padding: 80px 0;\n  position: relative;\n}\n.home-sec-testimonial .home-slider-next {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 40px;\n  cursor: pointer;\n}\n.home-sec-testimonial .home-slider-prev {\n  position: absolute;\n  left: 60px;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 40px;\n  cursor: pointer;\n}\n.home-sec-testimonial {\n  padding-inline: 139px;\n}\n.home-sec-testimonial .slick-prev {\n  left: -85px;\n}\n.home-sec-testimonial .slick-prev {\n  font-size: 0;\n  line-height: 0;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  transform: translate(0, -50%);\n  cursor: pointer;\n  color: #252525;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n.home-sec-testimonial .slick-next {\n  right: -85px;\n}\n.home-sec-testimonial .slick-next {\n  font-size: 0;\n  line-height: 0;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  transform: translate(0, -50%);\n  cursor: pointer;\n  color: #252525;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n.home-sec-testimonial .slick-prev:hover {\n  color: #252525 !important;\n  outline: none;\n  background: transparent;\n}\n.home-sec-testimonial .slick-next:hover {\n  color: #252525 !important;\n  outline: none;\n  background: transparent;\n}\n.home-sec-testimonial .testimonial-video {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n}\n.home-sec-testimonial .testimonial-desc {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  text-align: center;\n  color: #252525;\n  padding: 40px 0;\n}\n.home-sec-testimonial h1 {\n  font-family: \"Poppins\";\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 53px;\n  letter-spacing: 0em;\n  text-align: center;\n  width: 67%;\n  color: #000;\n  margin-bottom: 20px;\n  margin-inline: auto;\n  margin-bottom: 40px;\n}\n.home-sec-testimonial .video {\n  position: relative;\n}\n.home-sec-testimonial .video video {\n  width: 100%;\n  border-radius: 12px;\n}\n.home-sec-testimonial .video .background {\n  position: absolute;\n  width: 100%;\n  height: 98%;\n  /* background-color: rgba(29, 29, 29, 0.521); */\n  background-color: #fff;\n  top: 0;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.home-sec-testimonial .video .background img {\n  width: 100%;\n  border-radius: 12px;\n}\n.home-sec-testimonial .video .background svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 78px;\n  color: #e11f1c;\n  cursor: pointer;\n}\n\n.custom-header-new {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 20px;\n  padding-right: 10px;\n}\n.custom-header-new .left {\n}\n.custom-header-new .right {\n}\n\n.css-i6s8oy {\n  display: block !important;\n}\n.storeSection .content {\n  margin-bottom: 40px;\n}\n.storeSection .content .heading {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 81.76px;\n  font-weight: 700;\n  line-height: 103.01px;\n  text-align: left;\n  color: #1a1a1a;\n  margin: 0;\n}\n.storeSection .content .sub-heading {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 20.44px;\n  font-weight: 400;\n  line-height: 25.75px;\n  text-align: left;\n  color: #1a1a1a;\n}\n.storeSection .content .sub-heading span {\n  color: #c96b77;\n}\n.storeSection .search-con {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n  gap: 20px;\n}\n.storeSection .search-con .left {\n  width: 100%;\n  border-right: 1px solid #ececec;\n  border-width: 4px;\n  padding-right: 15px;\n}\n.storeSection .search-con .left .wrap {\n  position: relative;\n}\n.storeSection .search-con .left input {\n  border: none;\n  border-radius: 100px;\n  width: 100%;\n  color: #000;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 20.44px;\n  font-weight: 400;\n  line-height: 25.75px;\n  text-align: left;\n  padding: 19px 60px;\n  background-color: #f8f9fb;\n  border: 1px solid #d2d4d7;\n}\n.storeSection .search-con .left .wrap .search-icon {\n  position: absolute;\n  left: 3%;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  cursor: pointer;\n}\n.storeSection .search-con .left input::placeholder {\n  color: #d9d9d9;\n}\n.storeSection .search-con .right {\n}\n\n.storeSection .search {\n  margin-bottom: 62px;\n}\n.storeSection .InvestCardCon {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 35px;\n  margin-bottom: 80px;\n}\n.storeSection .InvestCardCon .InvestCard {\n  border: 1.53px solid #ede6e6;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.storeSection .InvestCardCon .InvestCard .top {\n  /* height: 200px; */\n  height: 250px;\n  /* overflow: hidden; */\n}\n.storeSection .InvestCardCon .InvestCard .top .type-img {\n  object-fit: contain;\n  border-radius: 12px 12px 0px 0px;\n  max-height: 300px;\n  width: auto;\n  height: 250px;\n}\n\n.storeSection .InvestCardCon .InvestCard .top .wrap-video {\n  position: relative;\n}\n.storeSection .InvestCardCon .InvestCard .top video {\n  width: 100%;\n  border-radius: 12px 12px 0px 0px;\n  /* max-height: 300px; */\n  /* width: auto; */\n  height: 250px;\n  position: relative;\n  object-fit: cover;\n}\n.storeSection .InvestCardCon .InvestCard .top .background {\n  position: absolute;\n  top: 0;\n}\n.storeSection .InvestCardCon .InvestCard .top .background img:nth-child(1) {\n  width: 100%;\n  border-radius: 12px;\n  height: 250px;\n}\n.storeSection .InvestCardCon .InvestCard .top .background img:nth-child(2) {\n  width: 50px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.storeSection .InvestCardCon .InvestCard .top .wrap-video .playPause {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  width: 60px;\n}\n.storeSection .InvestCardCon .InvestCard .wrap {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  gap: 38px;\n}\n.storeSection .InvestCardCon .InvestCard .top .slick-initialized .slick-slide {\n  padding: 0px !important;\n}\n.storeSection .InvestCardCon .InvestCard .bottom {\n  padding: 28px;\n  margin-top: 20px;\n}\n.storeSection .InvestCardCon .InvestCard .bottom .box1 {\n  display: flex;\n  align-items: center;\n  /* justify-content: center; */\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.storeSection .InvestCardCon .InvestCard .bottom .box1 img {\n}\n.storeSection .InvestCardCon .InvestCard .bottom .box1 h3 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 26px;\n  text-align: left;\n  color: #1a1a1a;\n  margin: 0;\n}\n.storeSection .InvestCardCon .InvestCard .bottom p {\n  color: #929094;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 18.4px;\n  font-weight: 500;\n  line-height: 23.18px;\n  text-align: left;\n  margin-bottom: 25px;\n  letter-spacing: 1px;\n}\n\n.storeSection .InvestCardCon .InvestCard .bottom .box2 {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  gap: 8px;\n  margin-bottom: 29px;\n}\n.storeSection .InvestCardCon .InvestCard .bottom .box2 img {\n}\n.storeSection .InvestCardCon .InvestCard .bottom .box2 p {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 14.31px;\n  font-weight: 500;\n  line-height: 18.03px;\n  text-align: left;\n  color: #929094;\n  margin: 0;\n}\n.storeSection .InvestCardCon .InvestCard .bottom button {\n  border: none;\n  outline: none;\n  width: 100%;\n  border-radius: 100px;\n  background-color: #e0201c;\n  color: #fff;\n  padding: 12px 22px;\n  position: relative;\n  z-index: 10;\n}\n.storeSection .btn-wrapper-viewMore {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.storeSection .btn-wrapper-viewMore button {\n  border: none;\n  outline: none;\n  padding: 6px 22px;\n  border-radius: 30px;\n  border: 1px solid #e0201c;\n  background: none;\n  color: #e0201c;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 24.75px;\n  font-weight: 500;\n  line-height: 31.18px;\n  text-align: center;\n  width: 100%;\n  max-width: 280px;\n}\n\n/* The slider */\n/* .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0px;\n  background: #fff;\n  transition: .4s;\n  border-radius: 30px;\n  border: 1px solid #ccc;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 1.5em;\n  width: 1.5em;\n  border-radius: 16px;\n  left: 6.2px;\n  top: 3px;\n  bottom: 0;\n  background-color: white;\n  box-shadow: 0 2px 5px #999999;\n  transition: .4s;\n} */\n\n/* input:checked+.slider {\n  background-color: #5fdd54;\n  border: 1px solid transparent;\n}\n\ninput:checked+.slider:before {\n  transform: translateX(1.5em);\n} */\n.storeSection .InvestCardCon .InvestCard .slider .slick-dots {\n  bottom: 20px !important;\n}\n.storeSection .slick-dots li.slick-active button:before {\n  color: #fff !important;\n  opacity: 100% !important;\n  border: 1px solid #fff;\n  border-radius: 100%;\n}\n.storeSection .slick-dots li button:before {\n  color: #fff !important;\n  font-size: 14px !important;\n  opacity: 70% !important;\n}\n\n.storeSectionDetail {\n}\n.storeSectionDetail .top-heading {\n  margin-bottom: 60px;\n}\n.storeSectionDetail .top-heading h1 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 70px;\n  font-weight: 700;\n  line-height: 70px;\n  color: #1a1a1a;\n  margin-bottom: 12px;\n  text-align: center;\n}\n.storeSectionDetail .top-heading p {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 20.44px;\n  font-weight: 400;\n  line-height: 25.75px;\n  text-align: center;\n  color: #1a1a1a;\n}\n.storeSectionDetail .top {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 50px;\n}\n.storeSectionDetail .top .left {\n  flex: 1.5;\n}\n.storeSectionDetail .top .right {\n  flex: 1;\n}\n.storeSectionDetail .top .right .bar {\n  background-color: #dfdfdf;\n  border-radius: 50px;\n  height: 8px;\n}\n.storeSectionDetail .top .right .bar-wrap {\n  background-color: #09bb09;\n  border-radius: 50px;\n  height: 8px;\n}\n.storeSectionDetail .top .right .box {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 2px;\n  margin-bottom: 20px;\n}\n.storeSectionDetail .top .right .progress-barr progress {\n}\n.storeSectionDetail .progress-barr progress {\n  width: 100%;\n  height: 12px;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.storeSectionDetail .progress-barr progress::-webkit-progress-bar {\n  background-color: #eee;\n  border-radius: 5px;\n}\n\n.storeSectionDetail .progress-barr progress::-webkit-progress-value {\n  background-color: #e0201c; /* Color of the progress value */\n  border-radius: 5px;\n}\n\n.storeSectionDetail .progress-barr progress::-moz-progress-bar {\n  background-color: #e0201c;\n  border-radius: 5px;\n}\n.storeSectionDetail .top .right .box h1.green {\n  color: #e0201c;\n  font-family: Outfit, sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 35.28px;\n  text-align: left;\n}\n.storeSectionDetail .top .right .box h1 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 35px;\n  font-weight: 700;\n  line-height: 40px;\n  text-align: left;\n  margin: 0;\n}\n.storeSectionDetail .top .right .box p {\n  font-family: Outfit, sans-serif;\n  font-size: 18.4px;\n  font-weight: 500;\n  line-height: 23.18px;\n  text-align: left;\n  color: #929094;\n}\n.storeSectionDetail .top .right .box button {\n  border: none;\n  outline: none;\n  padding: 2px 22px;\n  border-radius: 30px;\n  background: #e0201c;\n  color: #fff;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 22px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 34px;\n  width: 100%;\n  max-width: 300px;\n}\n.storeSectionDetail .top .left .slider img {\n  border-radius: 12px;\n  width: 100% !important;\n}\n\n.storeSectionDetail .bottom {\n  margin-top: 100px;\n}\n.storeSectionDetail .bottom .main-heading {\n  text-align: center;\n  color: #000000;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 61.7px;\n  font-weight: 700;\n  line-height: 77.74px;\n  margin-bottom: 100px;\n  border-bottom: 1px solid #e0201c;\n  width: 152px;\n  margin-inline: auto;\n  border-width: 5px;\n}\n.storeSectionDetail .bottom .container {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 50px;\n}\n.storeSectionDetail .bottom .container:last-child {\n  margin-bottom: 0;\n}\n.storeSectionDetail .bottom .container .left {\n  flex: 1;\n}\n.storeSectionDetail .bottom .container .left h1 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 54.95px;\n  font-weight: 700;\n  line-height: 54.95px;\n  text-align: left;\n  color: #1a1a1a;\n  margin-bottom: 40px;\n}\n.storeSectionDetail .bottom .container .left p {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 20.44px;\n  font-weight: 400;\n  line-height: 25.75px;\n  text-align: left;\n  color: #1a1a1a;\n}\n.storeSectionDetail .bottom .container .right {\n  flex: 1;\n}\n.storeSectionDetail .bottom .container .right img {\n  border-radius: 12px;\n  width: 100%;\n}\n.storeSectionDetail .bottom .btn-wrapper-viewMore {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 80px;\n}\n.storeSectionDetail .bottom .btn-wrapper-viewMore button {\n  outline: none;\n  padding: 6px 22px;\n  border-radius: 30px;\n  border: 1px solid #e0201c;\n  background: none;\n  color: #e0201c;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 24.75px;\n  font-weight: 500;\n  line-height: 31.18px;\n  text-align: center;\n  width: 100%;\n  max-width: 280px;\n}\n.storeSectionDetail .slick-dots {\n  bottom: 20px !important;\n}\n.storeSectionDetail .slick-dots li button {\n}\n.storeSectionDetail .slick-dots li.slick-active button:before {\n  color: #fff !important;\n  opacity: 90%;\n  border: 1px solid #fff;\n  border-radius: 30px;\n}\n.storeSectionDetail .slick-dots li button:before {\n  color: #fff !important;\n  opacity: 70%;\n  font-size: 12px !important;\n}\n\n.heading-partners {\n  margin-top: 70px;\n  color: #ff0000;\n  font-weight: 700;\n  font-size: 24px;\n}\n.storeSectionDetail .swiper-pagination-bullet-active {\n  background-color: #fff;\n}\n.storeSectionDetail .swiper-slide .type-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  height: 400px;\n}\n.storeSectionDetail .swiper-slide video {\n  width: 100%;\n  /* height: 400px; */\n  height: auto;\n  border-radius: 12px;\n  position: relative;\n}\n.storeSectionDetail .swiper-slide .wrap-video {\n  position: relative;\n}\n.storeSectionDetail .swiper-slide .wrap-video .background {\n  position: absolute;\n  top: 0;\n}\n.storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(1) {\n  width: 100%;\n  border-radius: 12px;\n  height: 400px;\n}\n.storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(2) {\n  width: 50px;\n}\n.storeSectionDetail .swiper-slide .wrap-video .playPause1 {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  width: 100%;\n}\n.storeSectionDetail .swiper-slide .wrap-video .playPause {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  width: 60px;\n}\n/* .swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  background: #fff;\n\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.swiper-slide img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n} */\n\n/* -----------------------offer-modal-body-------------------------- */\n.offer-modal {\n  height: 90%;\n  margin-top: 80px;\n  border-top-left-radius: 50px;\n  border-top-right-radius: 50px;\n}\n.offer-modal-sec {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.offer-modal-sec h6 {\n  transform: rotate(-5deg);\n  margin-top: 10px;\n  font-weight: 700;\n}\n.offer-modal-sec .offer-modal-img img {\n  width: 180px;\n}\n\n.offer-modal-img {\n  position: relative;\n}\n.offer-modal-img .text {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  align-items: center;\n}\n.offer-modal-img .text p {\n  font-size: 14px;\n  color: #fff;\n  width: 130px;\n  text-align: center;\n  transform: rotate(-10deg);\n  font-weight: bold;\n  line-height: 23px;\n}\n\n.offer-modal-img .text p span {\n  margin-top: 20px;\n  font-size: 15px;\n  display: block;\n}\n\n.offer-modal-sec .timer-sec {\n  padding-top: 30px;\n  display: flex;\n  gap: 10px;\n}\n\n.timer-sec .box {\n  width: 60px;\n  height: 60px;\n  position: relative;\n  background-color: #333333;\n  border-radius: 5px;\n}\n.timer-sec .box .content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #ffffff;\n  font-size: 35px;\n}\n\n.timer-sec .box .hr {\n  background-color: #ffffff;\n  height: 2px;\n  margin-top: 30px;\n}\n\n.userform-modal {\n}\n.userform-modal .custom-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 12px;\n  height: 50px;\n}\n.userform-modal .custom-header h1 {\n  font-family: \"poppins\", sans-serif;\n  font-size: 25px;\n  line-height: 33px;\n  margin: 0;\n}\n.userform-modal .custom-header svg {\n  cursor: pointer;\n}\n.userform-modal form .input-wrap {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 12px;\n}\n.userform-modal form .input-wrap.last {\n  margin-bottom: 25px;\n}\n.userform-modal form .input-wrap label {\n  font-family: \"poppins\", sans-serif;\n  font-size: 18px;\n  color: #222222;\n}\n.userform-modal form .input-wrap input {\n  border: none;\n  outline: none;\n  width: 100%;\n  border: 1px solid #eeeeee;\n  padding: 6px 8px;\n  border-radius: 6px;\n}\n.userform-modal form .input-wrap input::placeholder {\n  color: #000;\n}\n.userform-modal .modal-dialog {\n  max-width: 500px;\n  margin-inline: auto;\n}\n\n.userform-modal .btn-wrap {\n}\n.userform-modal .btn-wrap button {\n  border: none;\n  outline: none;\n  background-color: #e0201c;\n  border-radius: 30px;\n  font-family: \"poppins\", sans-serif;\n  font-size: 16px;\n  color: #222222;\n  cursor: pointer;\n  color: #fff;\n  padding: 8px 20px;\n}\n\n/*************************************************************** NEW STYLING ****************************************************/\n.custom-header .logo-section p {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: left;\n  color: rgba(0, 0, 0, 1);\n}\n\n.adminContainer {\n  box-shadow: 0px 4px 20px 0px #00000026;\n  background: #ffffff;\n  border-radius: 30px;\n  margin-top: 50px !important;\n  /* margin: 30px !important; */\n}\n.adminContainer .wallet-con span {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 40px;\n  text-align: left;\n  color: #e0221e;\n}\n\n.btn-outline-danger {\n  color: #000000;\n  padding: 16px 25px !important;\n  border-radius: 10px;\n  background-color: #000000;\n  color: #fff;\n  border: none;\n  &:hover {\n    background: #e0221e;\n  }\n}\n.btn-outline-danger.active_type {\n  background-color: #e0221e;\n}\n.userContainer {\n  box-shadow: 0px 4px 20px 0px #00000026;\n  background: #ffffff;\n  border-radius: 30px;\n  padding: 50px;\n  padding-bottom: 0px;\n  width: 96% !important;\n  max-width: none !important;\n  position: relative;\n}\n.mainContainerComp {\n  box-shadow: 0px 4px 20px 0px #00000026;\n  background: #ffffff;\n  border-radius: 30px;\n  padding: 50px;\n  padding-bottom: 0px;\n  width: 96% !important;\n  max-width: none !important;\n  position: relative;\n}\n.userContainer .form-label {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  text-align: left;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n.userContainer .form-control {\n  padding: 16px 16px;\n  border: 1px solid #d9d9d9;\n  position: relative;\n  padding-inline-start: 50px;\n  color: #666666;\n}\n.userContainer .form-control::placeholder {\n  color: #666666;\n}\n.userContainer .searchCon {\n  background-color: #f5f5f5;\n  width: 28px;\n  height: 28px;\n  border-radius: 28px;\n\n  position: absolute;\n  top: 70%;\n  left: 22px;\n  transform: translate(-50%, -50%);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.userContainer .search-icon {\n}\n\n.custom-header-table {\n  background-color: black !important;\n  color: white !important;\n  text-align: center;\n}\n.css-gl260s-MuiDataGrid-columnHeadersInner {\n  background-color: #000000;\n  color: #fff;\n  border-radius: 16px 16px 0px 0px;\n}\n.css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer {\n  background-color: #000000;\n  color: #fff;\n}\n.css-z8fhq1-MuiDataGrid-columnHeaders {\n  background-color: #000000 !important;\n}\n\n.css-1e2bxag-MuiDataGrid-root .MuiDataGrid-iconSeparator {\n  display: none;\n}\n.css-1e2bxag-MuiDataGrid-root\n  .MuiDataGrid-columnHeader:hover\n  .MuiDataGrid-menuIcon {\n  background-color: #000;\n}\n\n.css-11pb1sy-MuiContainer-root {\n  /* max-width: 1350px !important; */\n  margin-left: 20px;\n}\n\n.mainContainerComp .form-control {\n  padding: 16px 16px;\n  border: 1px solid #d9d9d9;\n  position: relative;\n  padding-inline-start: 50px;\n  color: #666666;\n  border-radius: 11px;\n}\n.mainContainerComp .form-select {\n  padding: 16px 16px;\n  border: 1px solid #d9d9d9;\n  position: relative;\n  padding-inline-start: 50px;\n  color: #666666;\n  border-radius: 11px;\n}\n.mainContainerComp .searchCon {\n  background-color: #f5f5f5;\n  width: 28px;\n  height: 28px;\n  border-radius: 28px;\n  position: absolute;\n  top: 70%;\n  left: 22px;\n  transform: translate(-50%, -50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.lp-btn.annualProgressBtn {\n  border-radius: 8px;\n  background-color: #e0221e;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.mainContainerComp .btn-excel-download {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #e0221e;\n  border-radius: 8px;\n  padding: 12px 20px;\n  color: #fff;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n}\n.mainContainerComp .form-label {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  text-align: left;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n.mainContainerComp .send-notification-btn {\n  min-width: 461px;\n  background-color: #e0221e;\n}\n\n.css-2u6ojp-MuiContainer-root {\n  max-width: none !important;\n}\n.css-17jjc08-MuiDataGrid-footerContainer {\n  /* border-top: 2px solid #E0221E !important; */\n}\n.mainContainerComp .table-head tr th {\n  background-color: #000000;\n  color: #fff;\n  padding: 12px;\n  font-weight: 400;\n  font-family: \"Poppins\", sans-serif;\n}\n.mainContainerComp .table-head tr th:first-child {\n}\n.mainContainerComp .table-head tr th:last-child {\n}\n.mainContainerComp .table-body tr td {\n  padding: 12px;\n}\n.mainContainerComp .table-body tr:nth-child(even) td {\n  background-color: #f6f6f6;\n}\n.sidebar-content-name-con {\n  margin: 40px 0px;\n}\n.sidebar-content-name-con.hidden {\n  display: none;\n}\n\n.sidebar-content-name-con h3 {\n  color: #fff;\n  font-family: \"Atmospheric\", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 27px;\n  text-align: left;\n  margin-left: 16px;\n}\n.wallet-con-wrap {\n}\n.wallet-con-wrap .img-con {\n  border-radius: 100px;\n  background: #ffffff;\n  width: 68px;\n  height: 68px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 20px;\n}\n.wallet-cardd {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n.wallet-flex-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n}\n.kyc_btn {\n  color: #fff;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  text-align: center;\n  border: none;\n  outline: none;\n  padding: 14px 25px;\n\n  &:hover {\n    color: #fff;\n  }\n}\n\n.kyc_btn.pending {\n  background-color: #ff8f2e;\n}\n.kyc_btn.pending.btn-borderr {\n  border: 2px solid #000;\n  background-color: #fff;\n  color: #000;\n}\n\n.kyc_btn.approved {\n  background-color: #23cd5c;\n}\n.kyc_btn.approved.btn-borderr {\n  border: 2px solid #000;\n  background-color: #fff;\n  color: #000;\n}\n.kyc_btn.rejected {\n  background-color: #e0221e;\n}\n.kyc_btn.rejected.btn-borderr {\n  border: 2px solid #000;\n  background-color: #fff;\n  color: #000;\n}\n\n.css-iclwpf .MuiDataGrid-columnHeaderTitleContainer {\n  background-color: #000000 !important;\n  color: #fff !important;\n}\n.MuiDataGrid-columnHeaderTitleContainer {\n  background-color: #000000 !important;\n  color: #fff !important;\n}\n\n.MuiDataGrid-columnHeadersInner {\n  background-color: #000000 !important;\n  color: #fff !important;\n}\n.css-vcjdx3 {\n  background-color: #000000 !important;\n  color: #fff !important;\n}\n.css-iclwpf {\n  /* display: none !important; */\n}\n.MuiDataGrid-menuIcon {\n  display: none !important;\n}\n.css-iclwpf {\n  /* display: none !important; */\n}\n.MuiDataGrid-columnSeparator {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
